import React, { Component, useState, forwardRef } from "react";
import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel,
  FormControl,
  Table,
  HelpBlock,
  Form,
  OverlayTrigger,
  Tooltip,
  Modal,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import Collapsible from "react-collapsible";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import BootstrapSwitchButton from "react-bootstrap-switch";
import Switch from "react-switch";
import {
  SendQuote,
  GetSubscriber,
  getallrider,
  GetAllSuppliers,
  checkMedication,
  searchMedicationForOrder,
  searchMedicationUsingBarcodeForOrder,
  get_single_lead_data,
  searchLeadForOrder,
  getpagewiseHealthcondition,
  getMedicationcategory,
  getcitywiseMedication,
  AddMedication,
  getCity,
  getCountry,
  getMedication,
  AddOrder,
  searchlastsubscription,
  getOrders,
  getmedicationdatabyid,
  getOrdersbyid,
  getremaincreditforleaduser,
  getallCurrier,
  getSalesRepresentative,
  getallmedicationpackages,
  Get_Settings,
  GetClaimFamilyDetails,
  updateMedication_old_data,
  getAllMedication,
  storeOrderComment,
  getAllUsersWithOutPagination,
  createAddress,
  getBatchNumberByAllMedicine,
  searchMedicationById,
  checkFirstOrder,
} from "../../../Listfunction";
import DateRangePicker from "react-daterange-picker";
import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import { quantity } from "chartist";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Downshift from "downshift";
import LoadingOrder from "views/Components/loadingOrder";
import LoadingMedication from "views/Components/loadingMedication";

import LoadingSpinner from "views/Components/loadingSpinner";
import "../../../assets/css/demo.css";
import "../../../assets/css/qtyFieldiconremove.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import ScreenLoader from "views/Components/screenLoader";
import { createLogicalAnd } from "typescript";
import OutOfStockModal from "./outOfStockModal";
import CommentSection from "components/CommentSection/CommentSection.jsx";
import CreateAddressModal from "components/AddressModal/createAddressModal";
import OrderItemCard from "./OrderItemCard";
import { CreateNewPurchaseRequest } from "api/purchaseRequest/purchaseRequest";
// import { Left } from "react-bootstrap/lib/Media";
const moment = extendMoment(originalMoment);

const ForwardedFormControl = forwardRef((props, ref) => (
  <input {...props} ref={ref} />
));

class addorder extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    this.state = {
      name: "",
      addressTypeError: null,
      addressType: "",
      subscribername: "",
      selectedSubscriberName: "",
      typing: false,
      typingTimeout: 0,
      selectedmedication: "",
      selectedSubscriber: "",
      selectedFile: [],
      processing: true,
      subscriber_detail: [],
      sales_rep: "",
      sales_rep_data: [],
      prescription_url: "",
      // source : '1',
      // delivery_type : '1',
      contentLoading: true,
      medicationloading: false,
      city_info: [],
      country_detail: [],
      medication_detail: [],
      addmedicationdetailform: [],
      subscriber: 0,
      avalable_flash_point: "",
      newsubscriber: "",
      subscriberError: null,
      opharmareferance: "",
      mypharmareferance: "",
      flashreference: "",
      mypharmareferanceError: null,
      opharmareferanceError: null,
      prescription: "",
      priscriptionurl: "",
      priscriptionurlError: null,
      orderdate: new Date(),
      paymentduedate: new Date(),
      source: "1",
      medicationItems: [],
      noRecordFound: false,
      subscriberItems: [],
      healthconditionItems: [],
      healthconditiondetails: [],
      srno: 1,
      description: "0",
      unitprice: "",
      quantity: "",
      subtotal: "",
      newmargin: "",
      discountamount: 0,
      basketvalue: "0.00",
      deliverytype: "1",
      deliverycharge: 0,
      deliverychargeError: null,
      totalcost: "0.00",
      totalcostError: null,
      lastsubscriptionorder: "",
      lastsubscriptionorderError: null,
      page: "",
      username: "",
      useremail: "",
      userphone: "",
      usermobile: "",
      addressradio: "",
      loading: false,
      name: "",
      nameError: null,
      mobileno: "",
      mobilenoError: null,
      status: "1",
      statusError: null,
      phoneno: "",
      phonenoError: null,
      email: "",
      emailError: null,
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      country: "1",
      countryError: null,
      latiAndLogitError: null,
      address_form_data: [],
      order_form_detail: [],
      m_id: [],
      companyname: "",
      discount: 0,
      companynote: "",
      _notificationSystem: null,
      cardHidden: true,
      medicationdataList: [],
      lastsubscription: [],
      showModal: false,
      showaddressModal: false,
      subscriptiondetail: [],
      medicationdata: [],
      quanitydata: [],
      addressdata: [],
      address_id: "",
      addressaccess: "0",
      // addresslist : [{id:0,addressline1 : '',addressline2 : '',city:'',country:0,postalcode : ''}],
      inputList: [],
      alert: null,
      medicationaddError: null,
      marginmodal: false,
      discountmodal: false,
      margintype: "1",
      discountpercentage: 0,
      marginpercentage: 0,
      marginamount: 0,
      b2borganizationdiscount: 0,
      showmediactonModal: false,
      medicationitemcode: "",
      medicationitemcodeError: null,
      medicationdescription: "",
      medicationdescriptionError: null,
      medicationitemname: "",
      medicationitemnameError: null,
      medicationcategory: "0",
      medicationcategoryError: null,
      medicationunitprice: "",
      medicationunitpriceError: null,
      medicationaddcommision: "1",
      medicationis_featured: "2",
      medicationcity: "0",
      medicationcityError: null,
      medicationprice: 0,
      category_detail: [],
      marginfinalamount: 0,
      displaymarginamount: "",
      displaymarginpercentage: "",
      dynamicfinalpercentage: 0,
      b2baccess: 0,
      city_id: "",
      errormessages: [],
      medicationerrormessage: [],
      addnewaddress: false,
      healthcondition: null,
      paymentoption: null,
      paymentoptionError: null,
      currentMedicineIndex: "",
      ordernote: null,
      rider_id: null,
      currier_id: null,
      is_currier: null,
      tracking_id: null,
      tracking_url: null,
      tracking_note: null,
      rider_idError: null,
      rider_details: [],
      currier_details: [],
      rider_data: [],
      currier_data: [],
      not_get_medicine: "",
      quantity: "",
      barcode: "",
      is_flash_medicine: "",
      suppliersData: [],
      supplier: "",
      codeDisabled: "",
      currier_disabled: "yes",
      package_image_data: [],
      packageImageError: null,
      package_image: [],
      packageitemdetails: [],
      packageitem: null,
      packageitemoptiondetails: [],
      primaryimage: "",
      tags: [],
      datarange: moment.range(today.clone(), today.clone().add(7, "days")),
      delivery_from_date: "",
      delivery_to_date: "",
      isdatepickeron: false,
      isLoading: false,
      item_type: "1",
      packageItems: [],
      labpackage: [],
      packageItemss: [],
      catalougepackageId: null,
      catalougepackagename: null,
      catPackageDiscount: 0,
      catPackageDiscountAmount: 0,
      packagefeatures: [],
      noOffExpOrder: "",
      isDeliveryCharge: false,
      occupation: "",
      is_LeadB2B: "",
      sub_orderType: false,
      first_address: "",
      po_number: "",
      po_document: [],
      grn_document: [],
      GRNDocUrl: [],
      PNdocUrl: [],
      medicineCheckedValue: [],
      isAllChecked: false,
      DeliveryChargeValues: [],
      isWrongQuantity: false,
      userData: "",
      StoreManager: false,
      store: "",
      wrongFieldId: "",
      deliveryTypeOptions: [
        { value: "1", label: "Normal" },
        { value: "2", label: "Express" },
        { value: "3", label: "Island Wide" },
        { value: "4", label: "Pick Up" },
        { value: "5", label: "Galle" },
      ],
      deliveryTypeOptionsB2C: [
        { value: "1", label: "Normal" },
        { value: "2", label: "Express" },
        { value: "3", label: "Island Wide" },
        { value: "5", label: "Galle" },
      ],
      isPartialOrder: false,
      isAbusableOrder: false,
      is_printable: false,
      item_description: "",
      selling_price: "",
      unit_price: "",
      isOverQuantity: "",
      latitude: "",
      longitude: "",
      isClaimableOrder: false,
      isPackageHasClaimMedicineAllowed: false,
      customAddress: "",
      customAddressError: null,
      showOutOfStockPop: false,
      medicationListing: [],
      tokenDetails: { token: JSON.parse(localStorage.getItem("user")) },
      getSource: "",
      medicationOptions: [],
      localMedicationData: [],
      allMedicine: [],
      getUnavalibleCost: "",
      comments: [],
      newComment: "",
      commentError: null,
      UserListData: [],
      isCreateAddressModalOpen: false,
      billing_address_id: "",
      first_billing_address: "",
      billing_city_id: "",
      addressModalType: "",
      isBillingSame: false,
      medicinBatchesdata: [],
      expandedId: null,
      requestRefillLabel: "Request Refill",
      showRefillModal: false,
      isFirstOrder: false,
    };
    this.inputRef = React.createRef();
    this.barcodeInputRef = React.createRef();
    this.qtyInputRef = React.createRef();
    this.sellingPriceInputRef = React.createRef();
    this.medSearchCache = {};
    this.medSearchRequestSeq = 0;
    this._loadMedTimer = null;
    this.medIndex = [];

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handledate = this.handledate.bind(this);
    this.handlebasketandsubtotal = this.handlebasketandsubtotal.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleb2bdetails = this.handleb2bdetails.bind(this);
    this.lastorderdetail = this.lastorderdetail.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handlePOFileChange = this.handlePOFileChange.bind(this);
    this.handleGRNFileChange = this.handleGRNFileChange.bind(this);
    this.opendiscountmodal = this.opendiscountmodal.bind(this);
    this.openmarginmodal = this.openmarginmodal.bind(this);
    this.medicationChange = this.medicationChange.bind(this);
    this.addrssselect = this.addrssselect.bind(this);
    this.medication_item_code_error = React.createRef();
    this.message_error = React.createRef();
    this.inputOnChange = this.inputOnChange.bind(this);

    this.inputOnChangeSubscriber = this.inputOnChangeSubscriber.bind(this);
    this.setIndexValue = this.setIndexValue.bind(this);
    this.isFalshMedicine = this.isFalshMedicine.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.handleAddComment = this.handleAddComment.bind(this);
    this.handleDeleteComment = this.handleDeleteComment.bind(this);
  }

  currier_details = [{ value: "1", label: "PromptXP" }];
  // handleaddressInputChange = (e, index) => {

  //   const { name,value } = e.target;
  //   // const {value } = e.target.type === 'select' ? e.target.selected : e.target.value;
  //   const list = [...this.state.addresslist];
  //   list[index][name] = value;

  //   this.setState({addresslist:list })

  // };

  upload() {
    document.getElementById("selectImage").click();
  }

  handlePrescriptionFileChange = (event) => {
    let data = [];
    data.push(event.target.files);
    this.setState({ selectedFile: data });
  };

  buildMedIndex = (medArray) => {
    try {
      this.medIndex = medArray.map((m) => {
        const label = `${m.title} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = this.soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.id, label, labelLower, soundex: sdx };
      });
      // sort for stable prefix scanning
      this.medIndex.sort((a, b) => (a.labelLower > b.labelLower ? 1 : -1));
    } catch (e) {
      this.medIndex = [];
    }
  };

  uploadPODoc() {
    document.getElementById("select_podoc").click();
  }

  handlePOFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ po_document: data });
  }

  uploadGRNDoc() {
    document.getElementById("select_grndoc").click();
  }

  uploadPOFinal = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (this.state.po_document.length > 0) {
      var PO_data = "";
      if (this.state.po_document.length != 0) {
        this.setState({ processing: true });
        const fdata = new FormData();
        fdata.append("document_type", "po");
        this.state.po_document.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("document_file[]", file[i]);
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/document";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            PO_data = res.data.data.document_url;
            this.setState({
              PNdocUrl: PO_data,
            });
          });
      }
    }
  };

  uploadGRNFinal = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (this.state.grn_document.length > 0) {
      var GRN_data = "";
      if (this.state.grn_document.length != 0) {
        this.setState({ processing: true });
        const fdata = new FormData();

        fdata.append("document_type", "grn");

        this.state.grn_document.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("document_file[]", file[i]);
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/document";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            GRN_data = res.data.data.document_url;
            this.setState({
              GRNDocUrl: GRN_data,
            });
          });
      }
    }
  };

  handleGRNFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ grn_document: data });
  }

  grndeleteDoc = (idx) => {
    var doc = this.state.GRNDocUrl;
    doc.splice(idx, 1);
    this.setState({
      GRNDocUrl: doc,
      alert: null,
    });
  };

  grnFinaldeleteDoc = (idx) => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.grndeleteDoc(idx)}
          onCancel={() => this.hideAlert()}
          confirmBtnText="Yes"
          cancelBtnText="No"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          showCancel
        >
          <h4>Are you sure you want to remove this document</h4>
        </SweetAlert>
      ),
    });
  };

  podeleteDoc = (idx) => {
    var doc = this.state.PNdocUrl;
    doc.splice(idx, 1);
    this.setState({
      PNdocUrl: doc,
      alert: null,
    });
  };

  poFinaldeleteDoc = (idx) => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.podeleteDoc(idx)}
          onCancel={() => this.hideAlert()}
          confirmBtnText="Yes"
          cancelBtnText="No"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          showCancel
        >
          <h4>Are you sure you want to remove this document</h4>
        </SweetAlert>
      ),
    });
  };

  isFalshMedicine = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_flash_medicine: checked });
  };

  isCurrier = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ currier_disabled: "no" });
    } else {
      this.setState({ currier_disabled: "yes" });
    }
    this.setState({ is_currier: checked });
  };

  medicationChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  addanother() {
    this.setState({ inputList: [] });
    this.serial = 1;
    this.setState({
      addressaccess: "1",
      adressradio: "",
      addressline2: "",
      addressline1: "",
      city: "0",
      postalcode: "",
      country: "1",
      medicationItems: [],
      medication_detail: [],
      cityError: null,
      countryError: null,
      addnewaddress: true,
      latiAndLogitError: null,
      latitude: "",
      longitude: "",
      addressType: "",
      customAddress: "",
      addressline1Error: null,
    });
    this.setState({ medicationloading: false });

    this.setState({
      address_id: "0",
      addressline2: this.state.addressline2,
      addressline1: this.state.addressline1,
      city: this.state.city,
      postalcode: this.state.postalcode,
      country: this.state.country,
    });

    this.handlebasketandsubtotal();
  }

  onSelect = (datarange, states) => {
    this.setState({
      datarange,
      states,
      isdatepickeron: !this.state.isdatepickeron,
      delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
      delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
    });
  };

  onToggle = () => {
    this.setState({ isdatepickeron: !this.state.isdatepickeron });
  };

  handleDateChange = (date) => {
    this.setState({
      orderdate: date,
    });
  };

  handlePaymentDueDate = (date) => {
    this.setState({ paymentduedate: date });
  };
  handleAddMultipleClick = (count) => {
    const newItems = [];
    for (let i = 0; i < count; i++) {
      newItems.push({
        id: moment().valueOf() + i,
        srno: this.getSerial(),
        description: "",
        unitprice: "",
        newmargin: "",
        item_type: "1",
        margin_discount_percentage: 0,
        margin_discount_sub_type: 2,
        quantity: 1,
        subtotal: 0,
        medicationItems: [],
        selectmedication: "",
        availableQuantity: 0,
        orderItemNumber: 0,
        isChecked: false,
        isUpSeller: false,
        isPartialOrderItem: true,
        item_description: "",
        selling_price: "",
        unit_price: "",
        is_printable: false,
        total_allocated: 0,
        requestRefillLabel: "request refill",
      });
    }
    const previousLength = this.state.inputList.length;

    this.setState({ inputList: [...this.state.inputList, ...newItems] }, () => {
      const firstNewIndex = previousLength;
      // if (
      //   this.inputRef.current &&
      //   this.inputRef.current[firstNewIndex] &&
      //   this.inputRef.current[firstNewIndex].focus
      // ) {
      //   this.inputRef.current[firstNewIndex].focus();
      // }
      if (
        this.barcodeInputRef.current &&
        this.barcodeInputRef.current[firstNewIndex] &&
        this.barcodeInputRef.current[firstNewIndex].focus
      ) {
        this.barcodeInputRef.current[firstNewIndex].focus();
      }
    });

    // this.setState({ inputList: [...this.state.inputList, ...newItems] }, () => {
    //   if (this.barcodeInputRef.current) {
    //     this.barcodeInputRef.current.focus();
    //   }
    // });
  };

  // handleAddClick = () => {
  //   var serial = 1;
  //   this.setState(
  //     {
  //       inputList: [
  //         ...this.state.inputList,
  //         {
  //           id: moment().valueOf(),
  //           srno: this.getSerial(),
  //           description: "",
  //           unitprice: "",
  //           newmargin: "",
  //           item_type: "1",
  //           margin_discount_percentage: 0,
  //           margin_discount_sub_type: 2,
  //           quantity: 1,
  //           subtotal: 0,
  //           medicationItems: [],
  //           selectmedication: "",
  //           availableQuantity: 0,
  //           orderItemNumber: 0,
  //           isChecked: false,
  //           isUpSeller: false,
  //           isPartialOrderItem: true,
  //           item_description: "",
  //           selling_price: "",
  //           unit_price: "",
  //           is_printable: false,
  //           total_allocated: 0,
  //         },
  //       ],
  //     },
  //     () => {
  //       if (this.barcodeInputRef.current) {
  //         this.barcodeInputRef.current.focus();
  //       }
  //     }
  //   );
  // };

  handledate = (event) => {
    // const target = event.target;
    // // const value = target.type === 'select' ? target.selected : target.value;
    // const value = target.type ===  "Datetime" ? target.selected : target.value;
    // const name = target.name;
    // this.setState({
    //   [name]: value
    // });
  };

  handleCommentChange = (e) => {
    this.setState({
      newComment: e.target.value,
      commentError: null,
    });
  };

  handleAddComment = (comment) => {
    this.setState((prevState) => ({
      comments: [...prevState.comments, comment],
    }));
  };

  handleDeleteComment = (commentId) => {
    this.setState((prevState) => ({
      comments: prevState.comments.filter((c) => c.id !== commentId),
    }));
  };

  onhealthconditionchnage = (value) => {
    this.setState({
      healthcondition: value,
    });
  };

  checkFirstOrders = (subscriberId) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const orderId = "";

    checkFirstOrder(subscriberId, orderId, obj).then((res) => {
      this.setState({ isFirstOrder: res.data.isFirstOrder });
    });
  };

  onSubscriberChange = (value) => {
    this.setState({
      subscriber: value.value,
      subscriberError: null,
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getremaincreditforleaduser(value.value, obj).then((res) => {
      if (res.data != null) {
        this.setState({ avalable_flash_point: res.data.remainingCredit });
      } else {
        this.setState({ avalable_flash_point: 0 });
      }
    });

    this.handlebasketandsubtotal();

    this.handleb2bdetails();
    this.handlebasketandsubtotal();
    this.checkFirstOrders(value.value);

    setTimeout(() => {
      if (!this.state.inputList || this.state.inputList.length === 0) {
        this.handleAddMultipleClick(5);
      }
    }, 250);

    this.setState({
      // deliverytype: "1",
      deliverycharge: 0,
      totalcost: "",
      discountamount: 0,

      name: "",
      email: "",
      phoneno: "",
      mobileno: "",
      addressline1: "",
      addressline2: "",
      city: "0",
      country: "1",
      postalcode: "",
      lastsubscription: [],
    });

    // this.handlebasketandsubtotal();

    this.setState({ subscriberItems: [] });
  };

  handleDeliveryChange = (event) => {
    this.setState({ deliverycharge: Number(event.target.value) });
    this.handlebasketandsubtotal();
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });

    if (name == "country") {
      if (value != 0) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var country_id = value;
        this.addrssselect(0, value);
        getCity(obj, country_id).then((res) => {
          this.setState({ city_info: res.data });
        });
      } else if (value == "0") {
        this.setState({ city_info: [] });
      }
    }

    if (name == "city") {
      if (value != "0") {
        // change as set logic according to country
        //  this.addrssselect(0,value)
      }
    }

    if (name == "margintype") {
      this.setState({ marginfinalamount: 0 });
    }
    // if(this.state.marginpercentage == '')
    // {
    //   this.setState({ marginpercentage: 0 });
    // }

    // if(this.state.marginamount == '')
    // {
    //   this.setState({ marginamount :  0 });
    // }
    this.handlebasketandsubtotal();
    if (name == "subscriber") {
      this.handleb2bdetails();
      this.handlebasketandsubtotal();

      this.setState({
        deliverycharge: 0,
        // totalcost: "",
        discountamount: 0,

        name: "",
        email: "",
        phoneno: "",
        mobileno: "",
        addressline1: "",
        addressline2: "",
        city: "0",
        country: "1",
        postalcode: "",
        lastsubscription: [],
      });
    }
    // this.handlebasketandsubtotal();
  };

  async lastorderdetail(id) {
    this.setState({ showModal: true, quanitydata: [], medicationdataList: [] });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await getOrdersbyid(id, obj).then((res) => {
      var data = res.data.orderItems;
      let medi_array = [];
      const newdata = data.map((mydata) =>
        getmedicationdatabyid(mydata.medication_id, obj).then((mdata) => {
          medi_array.push({ medicine: mdata.data, quantity: mydata.quantity });
          this.setState({
            medicationdataList: medi_array,
          });
        }),
      );

      this.setState({
        subscriptiondetail: res.data,
        quanitydata: data,
      });
    });
  }

  async lastorderdata(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let compelte = 1;
    let pg_no = 1;
    this.setState({ noRecordFound: false });
    while (compelte == 1) {
      this.setState({ noRecordFound: false });
      await searchlastsubscription(id, pg_no, obj).then((res) => {
        var orderdata = res.data;
        if (orderdata.data.length == 0) {
          this.setState({ noRecordFound: true });
        }

        if (orderdata.data.length == 0) {
          compelte = 0;
        } else {
          compelte = 0;
          var array1 = this.state.lastsubscription;
          var array2 = array1.concat(orderdata.data);

          this.setState({
            lastsubscription: array2,
          });
        }
      });
      pg_no++;
    }
  }

  handleb2bdetails() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ loading: true }, () => {
      this.state.subscriber_detail.map((detail) => {
        var source_data = "1";
        if (detail.source == 1) {
          source_data = { value: "1", label: "Flash" };
        } else if (detail.source == 2) {
          source_data = "2";
        } else if (detail.source == 3) {
          source_data = "3";
        } else if (detail.source == 4) {
          source_data = "4";
        }
        if (this.state.subscriber == detail.id) {
          if (
            detail.lead_catalogue_package != null &&
            detail.lead_catalogue_package != [] &&
            detail.lead_catalogue_package != ""
          ) {
            var packagediscount = 0;
            var features = [];
            var packagefeatues = {
              raya: "",
              express: [],
              mad: "",
            };

            var raya = "";
            var express = "";
            var mad = "";
            let claim = [];

            var packageLength = detail.lead_catalogue_package.length;
            var fetlist =
              detail.lead_catalogue_package[packageLength - 1]
                .lead_catalogue_package_feature;

            for (let i = 0; i < fetlist.length; i++) {
              if (fetlist[i].feature_title == "raya_flat_discount") {
                var raya = fetlist[i];
              } else if (fetlist[i].feature_title == "medicine_discount") {
                var mad = fetlist[i];
              } else if (fetlist[i].feature_title == "delivery") {
                var express = fetlist[i];
              } else if (
                fetlist[i].feature_title == "claim" &&
                JSON.parse(fetlist[i].feature_value).length !== 0
              ) {
                claim = JSON.parse(fetlist[i].feature_value);
                const findCreditType = claim.find((item) => item);
                this.setState({
                  // claimCreditType: findCreditType.creditType,
                  isPackageHasClaimMedicineAllowed: findCreditType.medicine,
                });
              }
            }

            if (
              raya.feature_value != null &&
              raya.feature_value != 0 &&
              raya.is_active == 1
            ) {
              packagefeatues.raya = raya.feature_value;
            }
            if (express.feature_value != null && express.is_active == 1) {
              const deliveryFeatures = JSON.parse(express.feature_value).find(
                (delivery) => delivery,
              );
              packagefeatues.express = JSON.parse(express.feature_value);
              // if (this.state.deliverytype.value == 2) {
              //   this.setState({
              //     isDeliveryCharge: true,
              //   });
              // }
            }
            if (
              mad.feature_value != null &&
              mad.feature_value != 0 &&
              mad.is_active == 1
            ) {
              packagefeatues.mad = mad.feature_value;
              packagediscount = parseInt(mad.feature_value);
            }

            features.push(packagefeatues);

            // if (mad.is_active == 1) {
            //   packagediscount = parseInt(mad.feature_value);
            // }

            if (
              detail.lead_catalogue_package[packageLength - 1]
                .catalogue_package != null
            ) {
              var catpackage =
                detail.lead_catalogue_package[packageLength - 1]
                  .catalogue_package;
              var logo = detail.b2b ? detail.b2b.company_logo : "";
              var packagename = catpackage.title;
              var packageid = catpackage.id;

              this.setState({
                catalougepackageId: packageid,
                catalougepackagename: packagename,
                catPackageDiscount: packagediscount,
                packagefeatures: features,
                is_LeadB2B: detail.is_b2b,
                logo_1: logo,
              });
            }
          } else {
            this.setState({
              catalougepackageId: "",
              catalougepackagename: "",
              catPackageDiscount: 0,
              packagefeatures: [],
            });
          }

          if (detail.b2b == null) {
            this.setState({
              loading: false,
              companyname: "",
              // deliverycharge : 0,
              companynote: "",
              discount: 0,
              discountamount: 0,
              b2borganizationdiscount: 0,
              b2baccess: 0,
              logo_1: "",
            });
            this.lastorderdata(detail.id);
            this.setState({
              loading: false,
              name: detail.name,
              source: source_data,
              email: detail.email,
              // earn_points : detail.earn_points,
              phoneno: detail.phone,
              mobileno: detail.mobile_no,
              addressdata: detail.address,
              username: detail.name,
              useremail: detail.email,
              occupation: `${
                detail.lead_detail ? detail.lead_detail.occupation : ""
              }`,
              userphone: detail.phone,
              usermobile: detail.mobile_no,
              b2bdeliverycharge: "",
            });

            // set default address detail load
            detail.address.map((add, indexk) => {
              if (indexk == 0) {
                this.setState({
                  first_address: add.id,
                  address_id: add.id,
                  first_billing_address: this.state.sub_orderType ? add.id : "",
                  billing_address_id: this.state.sub_orderType ? add.id : "",
                  isBillingSame: this.state.sub_orderType ? true : false,
                });
                this.addrssselect(add.id, add.country_id);
              }
            });
          } else {
            this.setState({
              loading: false,
              name: detail.name,
              email: detail.email,
              phoneno: detail.phone,
              mobileno: detail.mobile_no,
              // earn_points : detail.earn_points,
              b2baccess: 1,
              source: source_data,
              companyname: detail.b2b["company_name"],
              deliverycharge: detail.b2b["delivery_value"],
              b2bdeliverycharge: detail.b2b["delivery_value"],
              companynote: detail.b2b["note"],
              discount: detail.b2b["discount"],
              username: detail.name,
              useremail: detail.email,
              occupation: `${
                detail.lead_detail ? detail.lead_detail.occupation : ""
              }`,
              userphone: detail.phone,
              usermobile: detail.mobile_no,
              addressdata: detail.address,
              b2borganizationdiscount: detail.b2b["discount"],
            });

            this.lastorderdata(detail.id);

            // set default address detail load
            detail.address.map((add, indexk) => {
              if (indexk == 0) {
                this.setState({
                  first_address: add.id,
                  address_id: add.id,
                  first_billing_address: this.state.sub_orderType ? add.id : "",
                  billing_address_id: this.state.sub_orderType ? add.id : "",
                  isBillingSame: this.state.sub_orderType ? true : false,
                });
                this.addrssselect(add.id, add.country_id);
              }
            });
          }
        }
      });
    });
  }

  handleGetAllMedication = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const store = token.store_id;
    await getAllMedication(obj, store)
      // .then((response) => response.json())
      .then((response) => {
        const mdata = response.data;
        // this.setState({ allMedicine: mdata });
        const medicationOptions = mdata.map((medication) => ({
          value: medication.id,
          label: `${medication.title} (${medication.item_code})`,
        }));
        this.setState({ medicationOptions: medicationOptions });
        this.setState({ localMedicationData: mdata }, () => {
          // build local search index for fast client-side lookups
          if (
            this.state.localMedicationData &&
            this.state.localMedicationData.length > 0
          ) {
            this.buildMedIndex(this.state.localMedicationData);
          }
        });
      });
  };

  getAllUserList = async () => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    try {
      const res = await getAllUsersWithOutPagination(obj);
      const data = res.data;
      const UserListData =
        data &&
        data.map((user) => {
          return {
            value: user.id,
            label: user.name,
            email: user.email,
            role: user.role,
          };
        });

      this.setState({ UserListData: UserListData });
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      userData: token,
      StoreManager: token.role,
      store: token.store_id,
    });
    if (this.state.store !== 1 && token.store_id !== null) {
      this.setState({
        deliverytype: { value: "1", label: "Normal" },
        paymentoption: { value: "Cash", label: "Cash" },
      });
    }
    Get_Settings(obj).then((res) => {
      this.setState({ DeliveryChargeValues: res.data.data });
    });

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    // Disabled full pre-loading of all medications to avoid huge memory and CPU usage.
    // Use async search on demand instead (loadMedicationOptions).
    this.handleGetAllMedication();
    this.getAllUserList(obj);

    /*
    let compelte_subscriber =1   
    let subscriber_pg_no = 1
   while(compelte_subscriber==1)
   {

    await GetSubscriber(obj,subscriber_pg_no,500)
    .then((res) => {
      
      const data = res.data.data;
      if(data.length == 0)
      {
        compelte_subscriber = 0
      }
      else
      {
       var array1 = this.state.subscriber_detail;
       var array2 = array1.concat( data)
      
        this.setState({
          subscriber_detail : array2,
        })
        
        let subscriberItems = []
                  //console.log(this.state.medication_detail,"medicationdetail");
                  this.state.subscriber_detail.map((x, i) => {
                    subscriberItems.push({ value:x.id , label:  x.name+" ("+x.mobile_no+")"  })
                  })
                 
                  //  console.log(medicationItems , "medication item");
                  this.setState({
                    subscriberItems : subscriberItems
                  })
      }
    })
    subscriber_pg_no++
  }
  */
    // generate subscriber option array
    //generate healthcondition option
    let compelte_hc = 1;
    let hc_pg_no = 1;
    while (compelte_hc == 1) {
      var country_id = "1";
      await getpagewiseHealthcondition(hc_pg_no, country_id, obj).then(
        (res) => {
          const data = res.data.data;
          if (data.length == 0) {
            compelte_hc = 0;
          } else {
            var array1 = this.state.healthconditiondetails;
            var array2 = array1.concat(data);

            this.setState({
              healthconditiondetails: array2,
            });

            let hcItems = [];
            this.state.healthconditiondetails.map((x, i) => {
              hcItems.push({
                value: x.healthconditionname,
                label: x.healthconditionname,
              });
            });
            this.setState({
              healthconditionItems: hcItems,
            });
          }
        },
      );
      hc_pg_no++;
    }

    let compelte1 = 1;
    let pg_no1 = 1;
    while (compelte1 == 1) {
      await getallmedicationpackages(obj, pg_no1)
        // .then((response) => response.json())
        .then((response) => {
          const mdata = response.data;
          if (mdata.data.length == 0) {
            compelte1 = 0;
          } else {
            var array1 = this.state.labpackage;
            var array2 = array1.concat(mdata.data);
            this.setState({
              labpackage: array2,
            });

            let pcItems = [];
            this.state.labpackage.map((x, i) => {
              pcItems.push({
                value: x.id,
                label: `${x.package_name}(${x.package_code})`,
              });
            });
            this.setState({
              packageItems: pcItems,
            });
          }
        });
      pg_no1++;
    }

    let role = 5;
    getallrider(role, obj).then((res) => {
      const data = res.data;

      var array1 = this.state.rider_details;
      var array2 = array1.concat(data);

      this.setState({
        rider_details: array2,
      });

      let riderItems = [];
      this.state.rider_details.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        rider_data: riderItems,
      });
    });

    // get all sales representative

    getSalesRepresentative(obj).then((res) => {
      const data = res.data.data;

      var array1 = this.state.sales_rep_data;
      var array2 = array1.concat(data);

      this.setState({
        sales_details: array2,
      });

      let repItems = [];
      this.state.sales_details.map((x, i) => {
        repItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        sales_rep_data: repItems,
      });
    });

    getallCurrier(10, obj).then((res) => {
      const data = res.data;

      var array1 = this.state.currier_details;
      var array2 = array1.concat(data);

      this.setState({
        currier_details: array2,
      });

      let currierItems = [];
      this.state.currier_details.map((x, i) => {
        currierItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        currier_data: currierItems,
      });
    });

    var country_id = 1;

    getCity(obj, country_id).then((res) => {
      this.setState({ city_info: res.data });
    });
    await GetAllSuppliers(obj).then((res) => {
      this.setState({ suppliersData: res.data.data });
    });

    // this.handlebasketandsubtotal();
    // this.handletotalcost(this.state.deliverycharge);
    await getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    let medicomplete = 1;
    let p_no = 1;
    while (medicomplete == 1) {
      await getMedicationcategory(obj, p_no, 500).then((cat_res) => {
        var cat = cat_res.data;
        if (cat.data.length == 0) {
          medicomplete = 0;
        } else {
          //                compelte = 0
          var array1 = this.state.category_detail;
          var array2 = array1.concat(cat.data);

          this.setState({
            category_detail: array2,
          });
        }
      });
      p_no++;
    }

    if (this.props.match.params.id !== undefined) {
      let propvalue = this.props.match.params.id;

      await get_single_lead_data(propvalue, obj).then((lead_data) => {
        var leaddata = lead_data.data;
        this.setState({
          selectedSubscriberName: leaddata.data[0].name,
          subscriber_detail: leaddata.data,
        });
      });
      this.setState({ subscriber: propvalue });

      this.setState({ selectedSubscriber: propvalue });

      this.handleb2bdetails();
      this.handlebasketandsubtotal();
      this.setState({
        // deliverycharge: "",
        // totalcost: "",
        discountamount: 0,

        name: "",
        email: "",
        phoneno: "",
        mobileno: "",
        addressline1: "",
        addressline2: "",
        city: "0",
        country: "1",
        postalcode: "",
        lastsubscription: [],
      });
    }
    // await this.showPolicyDetails();
    GetClaimFamilyDetails(this.state.subscriber, obj).then((res) => {
      this.setState({ familyDetails: res.data.data });
    });
    this.setState({ contentLoading: false });
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Order</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.setState({ isLoading: false });
      this.props.history.push("/admin/order_list");
    }, 3000);
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  serial = 1;
  getSerial() {
    return this.serial++;
  }
  // Soundex algorithm for simple phonetic matching (returns 4-char code)
  soundex(str) {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    // pad with zeros
    return out.padEnd(4, "0").slice(0, 4);
  }

  // async loader for medication select with debounce + cache + request sequencing
  loadMedicationOptions = (inputValue) => {
    // require at least 2 characters to reduce work
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);

    const q = inputValue.trim();

    // return cached result when available
    if (this.medSearchCache[q]) {
      return Promise.resolve(this.medSearchCache[q]);
    }

    // ensure medIndex is built from localMedicationData when available
    if (
      (!this.medIndex || this.medIndex.length === 0) &&
      this.state.localMedicationData &&
      this.state.localMedicationData.length > 0
    ) {
      this.buildMedIndex(this.state.localMedicationData);
    }

    // debounce filter: returns a promise resolved after debounce
    return new Promise((resolve) => {
      if (this._loadMedTimer) clearTimeout(this._loadMedTimer);
      this._loadMedTimer = setTimeout(() => {
        // If we have local data index, filter locally (fast)
        if (this.medIndex && this.medIndex.length > 0) {
          const lower = q.toLowerCase();
          const results = [];
          const LIMIT = 50;

          // 1) prefix matches
          for (
            let i = 0;
            i < this.medIndex.length && results.length < LIMIT;
            i++
          ) {
            const m = this.medIndex[i];
            if (m.labelLower.startsWith(lower)) results.push(m);
          }

          // 2) substring matches
          if (results.length < LIMIT) {
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (results.indexOf(m) !== -1) continue;
              if (m.labelLower.includes(lower)) results.push(m);
            }
          }

          // 3) phonetic soundex fallback for longer queries
          if (results.length === 0 && lower.length >= 3) {
            const qSound = this.soundex(lower);
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (m.soundex && m.soundex === qSound) results.push(m);
            }
          }

          const options = results.map((m) => ({
            value: m.value,
            label: m.label,
          }));

          // cache limited queries
          try {
            const keys = Object.keys(this.medSearchCache);
            if (keys.length > 200) delete this.medSearchCache[keys[0]];
            this.medSearchCache[q] = options;
          } catch (e) {}

          return resolve(options);
        }

        // fallback: call API once (debounced) if no local data
        this.medSearchRequestSeq++;
        const reqSeq = this.medSearchRequestSeq;
        try {
          const token = JSON.parse(localStorage.getItem("user"));
          const obj = token ? token.token : null;
          const city_id = this.state.city_id || 1;

          searchMedicationForOrder(q, city_id, 1, obj, this.state.store)
            .then((res) => {
              if (reqSeq !== this.medSearchRequestSeq) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: medication.id,
                label: `${medication.title} (${medication.item_code})`,
              }));
              try {
                const keys = Object.keys(this.medSearchCache);
                if (keys.length > 200) delete this.medSearchCache[keys[0]];
                this.medSearchCache[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };

  async onSendQuote() {
    this.setState({ errormessages: [] });
    let error = false;

    const nonEmptyMedicationList = this.state.inputList.filter(
      (item) => item.description !== "" && !!item.description,
    );
    this.state.inputList = nonEmptyMedicationList;

    if (this.state.subscriber == "0") {
      error = true;
      this.setState({
        subscriberError: (
          <small className="text-danger">Subscriber is required.</small>
        ),
      });
    } else {
      this.setState({ subscriberError: null });
    }

    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }
    if (Number(this.state.address_id) === 0) {
      if (this.state.addressline1.length === 0) {
        error = true;
        this.setState({
          addressline1Error: (
            <small className="text-danger">address is required.</small>
          ),
        });
      } else {
        this.setState({
          addressline1Error: null,
        });
      }
    } else {
      this.setState({
        addressline1Error: null,
      });
    }

    if (this.state.inputList.length == 0) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      error = false;
      this.state.inputList.map((x, i) => {
        if (x.description == "") {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>Please Enter Proper Medication data!</h4>
              </SweetAlert>
            ),
          });
        } else {
          if (error == true) {
            this.setState({ medicationaddError: null });
          } else {
          }
        }
      });
    }
    if (this.state.addnewaddress == true) {
      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: (
            <small className="text-danger">District is required.</small>
          ),
        });
      } else {
        this.setState({ cityError: null });
      }
      if (
        this.state.latitude.length === 0 ||
        this.state.longitude.length === 0
      ) {
        error = true;
        this.setState({
          latiAndLogitError: (
            <small className="text-danger">
              Latitude and Longitude are required.
            </small>
          ),
        });
      } else {
        this.setState({ latiAndLogitError: null });
      }
    }
    if (error) {
      this.message_error.current.focus();
    }

    if (!error) {
      /*if (
        this.state.totalcost > 5000 &&
        this.state.paymentoption.value == "Cash"
      ) {
        this.setState({
          ispaywarning: true,
        });
      } else {*/
      this.setState({ isLoading: true /*,ispaywarning: false*/ });
      //if(1)
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let orderItemsform = [];
      let sendQuoteBatches = [];

      this.state.inputList.map((x, i) => {
        sendQuoteBatches = x.medicinBatchesdata.map((data) => {
          return {
            batch_no: data.batch_no,
            expiry_date: data.expiry_date,
            quantity: data.qty,
          };
        });
        if (x.margin_discount_sub_type == 2) {
          //var itemT = parseInt(x.item_type)
          orderItemsform.push({
            id: x.description.value,
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_price: x.newmargin,
            margin_discount_percentage: 0,
            item_id: x.orderItemNumber,
            item_description: x.item_description,
            unit_price: x.unitprice,
            batches: sendQuoteBatches,
          });
        } else if (x.margin_discount_sub_type == 1) {
          //var itemT = parseInt(x.item_type)
          orderItemsform.push({
            id: x.description.value,
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_price: 0,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_percentage: x.margin_discount_percentage,
            item_id: x.orderItemNumber,
            item_description: x.item_description,
            unit_price: x.unitprice,
            batches: sendQuoteBatches,
          });
        }
      });

      const filterdBatches = sendQuoteBatches
        .filter((batch) => batch.quantity > 0)
        .map((batch) => ({
          batch_no: batch.batch_no,
          expiry_date: batch.expiry_date,
          quantity: batch.qty,
        }));

      const channel = "admin";
      const created_by = token.id;
      const date = new Date(this.state.orderdate);
      var dd = ("0" + date.getDate()).slice(-2);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var yyyy = date.getFullYear();
      var today = yyyy + "-" + mm + "-" + dd;

      var priscription_data = "";
      var prescription_text = "";
      if (this.state.selectedFile.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();
        this.state.selectedFile.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("presription_file[]", file[i]);
          }
        });

        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/orders/prescription";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            priscription_data = res.data.data.prescription_url;
            prescription_text = "";
            // priscription_array_data.push(priscription_data);
          });
      }

      var PO_data = "";
      if (this.state.po_document.length != 0) {
        this.setState({ processing: true });
        const fdata = new FormData();
        this.state.po_document.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("po[]", file[i]);
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/document";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            PO_data = res.data.data.po_document_url;
          });
      }

      var GRN_data = "";
      if (this.state.grn_document.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();
        this.state.grn_document.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("grn[]", file[i]);
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/document";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            GRN_data = res.data.data.prescription_url;
          });
      }

      var marginvalue = "";
      if (this.state.margintype == 1) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      } else if (this.state.margintype == 2) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      }

      var discountper = 0;
      if (this.state.dynamicfinalpercentage != 0) {
        discountper = parseFloat(this.state.dynamicfinalpercentage);
      } else {
        discountper = parseFloat(this.state.discount);
      }

      var tag = [];
      if (this.state.healthcondition == null) {
        tag = "";
      } else {
        this.state.healthcondition.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.label);
          tag = array2;
        });
      }

      var paymentop = "";
      if (this.state.paymentoption != null) {
        paymentop = this.state.paymentoption.value;
      }

      var riderinfo = "";
      if (this.state.rider_id == null) {
        if (this.state.rider_id != null) {
          riderinfo = this.state.rider_id.value;
        } else {
          riderinfo = "";
        }
      } else {
        if (this.state.rider_id != null) {
          if (this.state.rider_id.value != null) {
            riderinfo = this.state.rider_id.value;
          } else {
            riderinfo = "";
          }
        }
      }

      var currier_partner_id = "";
      var c_c = 0;
      if (this.state.currier_disabled == "no") {
        c_c = 1;
        currier_partner_id = this.state.currier_id.value;
      } else {
        c_c = 0;
        currier_partner_id = riderinfo;
      }

      var deliveryType = this.state.deliverytype.value;

      if (deliveryType == 1) {
        this.setState({
          delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
          delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
        });
      } else {
        this.setState({ delivery_from_date: "", delivery_to_date: "" });
      }

      var subOrderType = "1";
      var orderStatus = "1";
      var PO_No = this.state.po_number;
      var PNDoc = this.state.PNdocUrl;
      var GRNDoc = this.state.GRNDocUrl;

      if (this.state.sub_orderType == true) {
        subOrderType = "2";
        orderStatus = "13";
      } else {
        PO_No = "";
        PNDoc = [];
        GRNDoc = [];
      }

      var orderSource = this.state.source.value;

      this.setState({ processing: false }, () => {
        SendQuote(
          this.state.subscriber,
          orderSource,
          this.state.opharmareferance,
          today,
          this.state.prescription,
          this.state.priscriptionurl,
          deliveryType,
          this.state.deliverycharge,
          this.state.lastsubscriptionorder,
          this.state.address_id,
          this.state.addressline1,
          this.state.addressline2,
          this.state.city,
          this.state.postalcode,
          this.state.country,
          channel,
          orderItemsform,
          this.state.basketvalue,
          this.state.totalcost,
          this.state.lastsubscriptionorder,
          this.state.email,
          this.state.name,
          this.state.mobileno,
          this.state.phoneno,
          orderStatus,
          priscription_data,
          this.state.margintype,
          marginvalue,
          discountper,
          tag,
          paymentop,
          prescription_text,
          this.state.not_get_medicine,
          currier_partner_id,
          c_c,
          this.state.tracking_id,
          this.state.tracking_note,
          this.state.tracking_url,
          this.state.delivery_from_date,
          this.state.delivery_to_date,
          subOrderType,
          PO_No,
          PNDoc,
          GRNDoc,
          this.state.item_description,
          this.state.isAbusableOrder,
          this.state.latitude,
          this.state.longitude,
          this.state.addressType,
          this.state.customAddress,
          filterdBatches,
          obj,
        )
          .then((res) => {
            if (res.data.success === false) {
              this.setState({ processing: true });
              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
                this.setState({ isLoading: false });
              } else {
                this.handleClick("bl");
                this.setState({ isLoading: false });
              }
            } else if (res.data.success === true) {
              this.setState({ processing: true });
              this.handleSuccess("bl");
            }
            // this.props.history.push('/admin/order_list');
          })
          .catch((error) => {
            this.handleNetworkError("bl");
            this.setState({ isLoading: false });
          });
      });
      //}
    }
  }

  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    const nonEmptyMedicationList = this.state.inputList.filter(
      (item) =>
        item.description !== "" &&
        item.description !== null &&
        item.description !== undefined,
    );
    this.state.inputList = nonEmptyMedicationList;

    if (this.state.subscriber == "0") {
      error = true;
      this.setState({
        subscriberError: (
          <small className="text-danger">Subscriber is required.</small>
        ),
      });
    } else {
      this.setState({ subscriberError: null });
    }

    if (this.state.totalcost.length == 0) {
      error = true;
      this.setState({
        totalcostError: (
          <small className="text-danger">Total Cost is required.</small>
        ),
      });
    } else {
      this.setState({ totalcostError: null });
    }

    if (this.state.store === 1 || this.state.store === null) {
      if (this.state.inputList.length === 0) {
        error = true;
        this.setState({
          alert: (
            <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              <h4>Please Enter Proper Medication data!</h4>
            </SweetAlert>
            // kamal
          ),
        });
      } else {
        error = false;
        this.state.inputList.map((x, i) => {
          if (x.description === "") {
            error = true;
            this.setState({
              alert: (
                <SweetAlert
                  className="order_alert"
                  style={{ display: "block", marginTop: "-100px" }}
                  onConfirm={() => this.hideAlert()}
                  onCancel={() => this.hideAlert()}
                  confirmBtnBsStyle="info"
                >
                  <h4>Please Enter Proper Medication data!</h4>
                </SweetAlert>
              ),
            });
          } else {
            if (error === false) {
              this.setState({ medicationaddError: null });
            }
          }
        });
      }
    }
    if (this.state.addnewaddress == true) {
      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: (
            <small className="text-danger">District is required.</small>
          ),
        });
      } else {
        this.setState({ cityError: null });
      }
      if (
        this.state.latitude.length === 0 ||
        this.state.longitude.length === 0
      ) {
        error = true;
        this.setState({
          latiAndLogitError: (
            <small className="text-danger">
              Latitude and Longitude are required.
            </small>
          ),
        });
      } else {
        this.setState({ latiAndLogitError: null });
      }
    }

    // if(this.state.rider_id == null)
    // {error = true
    //    this.setState({
    //     rider_idError: (
    //         <small className="text-danger">
    //           Rider is required.
    //         </small>
    //       )
    //     })
    //   }else{ this.setState({ rider_idError: null });}
    if (
      Number(this.state.address_id) === 0 &&
      this.state.getSource != 15 &&
      this.state.source.value != "15"
    ) {
      if (
        (this.state.store === 1 || this.state.store === null) &&
        this.state.addressline1.length === 0
      ) {
        error = true;
        this.setState({
          addressline1Error: (
            <small className="text-danger">address is required.</small>
          ),
        });
      } else {
        this.setState({
          addressline1Error: null,
        });
      }
    } else {
      this.setState({
        addressline1Error: null,
      });
    }
    if (
      this.state.opharmareferance.length == 0 &&
      this.state.source.value == "2"
    ) {
      error = true;
      this.setState({
        opharmareferanceError: (
          <small className="text-danger">oPharma referance is required.</small>
        ),
      });
    } else {
      this.setState({ opharmareferanceError: null });
    }

    if (
      this.state.mypharmareferance.length == 0 &&
      this.state.source.value == "3"
    ) {
      error = true;
      this.setState({
        mypharmareferanceError: (
          <small className="text-danger">MyPharma referance is required.</small>
        ),
      });
    } else {
      this.setState({ mypharmareferanceError: null });
    }

    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }
    const shouldCheckOutOfStock =
      this.state.store !== 1 && this.state.store !== null;
    const outOfStockItems = this.state.inputList.filter(
      (item) =>
        parseFloat(item.quantity) > parseFloat(item.pharmacyLevelQuantity),
    );
    if (shouldCheckOutOfStock && outOfStockItems.length > 0) {
      this.setState({
        showOutOfStockPop: true,
        medicationListing: outOfStockItems,
      });
      return;
    }

    if (error) {
      this.message_error.current.focus();
    }
    if (!error) {
      /*if (
        this.state.totalcost > 5000 &&
        this.state.paymentoption.value == "Cash"
      ) {
        this.setState({
          ispaywarning: true,
        });
      } else {*/
      this.setState({ isLoading: true /*,ispaywarning: false*/ });
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      let orderItemsform = [];
      let batches = [];
      // let isPartialOrder = false;

      this.state.inputList.map((x, i) => {
        let partialSent = !x.isPartialOrderItem;
        batches = x.medicinBatchesdata.map((batch) => ({
          batch_no: batch.batch_no,
          expiry_date: batch.expiry_date,
          quantity: batch.qty,
        }));

        if (x.margin_discount_sub_type == 2) {
          orderItemsform.push({
            id: (x.description && x.description.value) || "",
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_price: x.newmargin,
            margin_discount_percentage: 0,
            item_id: x.orderItemNumber,
            claimable: x.isChecked,
            is_recommended_product: x.isUpSeller,
            partial_sent: partialSent,
            unit_price: x.unitprice,
            item_description: x.item_description,
            is_printable: x.is_printable,
            batches: batches,
          });
          // this.setState({
          //   isPartialOrder: x.isPartialOrderItem ? false : true,
          // });
        } else if (x.margin_discount_sub_type == 1) {
          orderItemsform.push({
            id: (x.description && x.description.value) || "",
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_price: 0,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_percentage: x.newmargin,
            item_id: x.orderItemNumber,
            claimable: x.isChecked,
            is_recommended_product: x.isUpSeller,
            partial_sent: partialSent,
            unit_price: x.unitprice,
            item_description: x.item_description,
            is_printable: x.is_printable,
            batches: batches,
          });

          // this.setState({
          //   isPartialOrder: x.isPartialOrderItem ? false : true,
          // });
        }
        // if (partialSent) {
        //   isPartialOrder = true;
        // }
      });
      // this.setState({ isPartialOrder });
      const filterdBatches = batches
        .filter((batch) => batch.quantity > 0)
        .map((batch) => ({
          batch_no: batch.batch_no,
          expiry_date: batch.expiry_date,
          quantity: batch.qty,
        }));

      const channel = "admin";
      const date = new Date(this.state.orderdate);
      var dd = ("0" + date.getDate()).slice(-2);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var yyyy = date.getFullYear();
      var today = yyyy + "-" + mm + "-" + dd;

      const paymentdate = new Date(this.state.paymentduedate);
      var pdd = ("0" + paymentdate.getDate()).slice(-2);
      var pmm = ("0" + (paymentdate.getMonth() + 1)).slice(-2);
      var pyyyy = date.getFullYear();
      var ptoday = pyyyy + "-" + pmm + "-" + pdd;

      var priscription_data = "";
      if (this.state.selectedFile.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();

        this.state.selectedFile.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("presription_file[]", file[i]);
          }
        });

        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/orders/prescription";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            priscription_data = res.data.data.prescription_url;
          });
      }

      var marginvalue = "";
      if (this.state.margintype == 1) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      } else if (this.state.margintype == 2) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      }

      var discountper = 0;
      if (this.state.dynamicfinalpercentage != 0) {
        discountper = parseFloat(this.state.dynamicfinalpercentage);
      } else {
        if (this.state.discount == null) {
          discountper = 0;
        } else {
          discountper = parseFloat(this.state.discount);
        }
      }

      var tag = [];
      if (this.state.healthcondition == null) {
        tag = "";
      } else {
        this.state.healthcondition.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.label);
          tag = array2;
        });
      }

      var paymentop = "";
      if (this.state.paymentoption != null) {
        paymentop = this.state.paymentoption.value;
      }

      var rider_info = "";
      if (this.state.rider_id != null) {
        rider_info = this.state.rider_id.value;
      }

      var prescriptionurl = [];
      if (this.state.prescription_url.length != 0) {
        prescriptionurl.push(this.state.prescription_url);
      }

      var currier_partner_id = "";
      var c_c = 0;
      if (this.state.currier_disabled == "no") {
        c_c = 1;
        currier_partner_id = this.state.currier_id.value;
      } else {
        c_c = 0;
        currier_partner_id = rider_info;
      }

      var deliveryType = this.state.deliverytype.value;

      if (deliveryType == 1) {
        this.setState({
          delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
          delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
        });
      } else {
        this.setState({ delivery_from_date: "", delivery_to_date: "" });
      }

      var subOrderType = "1";
      var orderStatus = "1";
      var PO_No = this.state.po_number;
      var PNDoc = this.state.PNdocUrl;
      var GRNDoc = this.state.GRNDocUrl;

      if (this.state.sub_orderType == true) {
        subOrderType = "2";
        orderStatus = "13";
      } else {
        PO_No = "";
        PNDoc = [];
        GRNDoc = [];
      }

      var orderSource = this.state.source.value || "1";
      const findPartialItemsIncluded = this.state.inputList.filter(
        (item) => !item.isPartialOrderItem,
      );

      this.setState({ processing: false }, () => {
        const storeNullValue = this.state.store === null ? 1 : this.state.store;
        const totalCostNum = parseFloat(this.state.totalcost) || 0;
        const unavailableCostNum =
          parseFloat(this.state.getUnavalibleCost) || 0;
        const finalTotalCost = (totalCostNum - unavailableCostNum).toFixed(2);
        const isStoreOrder = storeNullValue !== 1;

        const addressId =
          this.state.address_id != ""
            ? this.state.address_id
            : // isStoreOrder
              // ?
              0;
        // : this.state.address_id;

        const addressLine2 =
          this.state.addressline2 != ""
            ? this.state.addressline2
            : isStoreOrder
              ? "ambalangoda"
              : this.state.addressline2;

        const cityId =
          this.state.city != "0"
            ? this.state.city
            : isStoreOrder
              ? 4
              : this.state.city;

        const countryId =
          this.state.country != "0"
            ? this.state.country
            : isStoreOrder
              ? 1
              : this.state.country;

        const IsClaimOrder = this.state.inputList.some(
          (item) => item.isChecked === true,
        );

        AddOrder(
          this.state.subscriber,
          orderSource,
          this.state.opharmareferance,
          today,
          this.state.prescription,
          this.state.priscriptionurl,
          deliveryType,
          this.state.deliverycharge,
          this.state.lastsubscriptionorder,
          addressId,
          this.state.addressline1,
          addressLine2,
          cityId,
          this.state.postalcode,
          countryId,
          channel,
          orderItemsform,
          obj,
          this.state.basketvalue,
          this.state.sub_orderType ? finalTotalCost : totalCostNum,
          this.state.lastsubscriptionorder,
          this.state.email,
          this.state.name,
          this.state.mobileno,
          this.state.phoneno,
          orderStatus,
          priscription_data,
          this.state.margintype,
          marginvalue,
          discountper,
          tag,
          paymentop,
          ptoday,
          this.state.ordernote,
          this.state.mypharmareferance,
          currier_partner_id,
          this.state.not_get_medicine,
          c_c,
          this.state.tracking_id,
          this.state.tracking_note,
          this.state.tracking_url,
          this.state.sales_rep,
          this.state.delivery_from_date,
          this.state.delivery_to_date,
          this.state.isDeliveryCharge,
          subOrderType,
          PO_No,
          PNDoc,
          GRNDoc,
          this.state.flashreference,
          findPartialItemsIncluded.length > 0 ? true : false,
          this.state.isAbusableOrder,
          this.state.item_description,
          this.state.isClaimableOrder ? "1" : "0",
          this.state.latitude,
          this.state.longitude,
          this.state.addressType,
          this.state.customAddress,
          this.state.store === null ? 1 : this.state.store,
          this.state.sub_orderType
            ? this.state.billing_address_id
            : this.state.address_id,
          filterdBatches,
        )
          .then(async (res) => {
            if (res.data.success === false) {
              this.setState({ processing: true });
              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
                this.setState({ isLoading: false });
              } else {
                this.handleClick("bl");
                this.setState({ isLoading: false });
              }
            } else if (res.data.success === true) {
              this.setState({ processing: true });
              if (
                res.data.data.orderItems &&
                res.data.data.orderItems.length === 0 &&
                this.state.store !== 1 &&
                this.state.store !== null
              ) {
                this.handleCreateToken(res.data.data.id);
              }
              if (this.state.store === 1 || this.state.store === null) {
                this.handleCreateComment(res.data.data.id);
              }
              this.handleSuccess("bl");
            }
            // this.props.history.push('/admin/order_list');
          })
          .catch((error) => {
            this.handleNetworkError("bl");
            this.setState({ isLoading: false });
          });
      });
      //}
    }
  }

  handleCreateToken = (orderId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        window.open(
          `${process.env.REACT_APP_BILL_GENERATE_URL}/token/${orderId}`,
          "_blank",
        );
        resolve();
      }, 3000);
    });
  };

  handleCreateComment = (ordereId) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const commentBody = {
      order_id: ordereId,
      // get text from comments array
      comment: this.state.comments.map((c) => c.text).join("\n"),
      type: "medicine",
      is_private: true,
      assigned_id: this.state.mentionedUsers
        ? this.state.mentionedUsers.map((u) => u.id)
        : [],
    };
    storeOrderComment(obj, commentBody)
      .then((res) => {
        console.log("Comment created successfully", res);
      })
      .catch((error) => {
        console.error("Error creating comment:", error);
      });
  };

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  Add_New_Medication() {
    this.setState({
      showmediactonModal: true,
      medicationerrormessage: [],
      medicationitemcodeError: null,
      medicationitemnameError: null,
      medicationunitpriceError: null,
      medicationcategoryError: null,
      medicationcityError: null,
      medicationaddcommision: "1",
      medicationis_featured: "2",
      medicationdescription: "",
      medicationunitprice: 0,
      medicationitemcode: "",
      medicationitemname: "",
      medicationcategory: "",
      medicationcity: "0",
      quantity: "",
      barcode: "",
      is_flash_medicine: "",
      supplier: "",
      codeDisabled: "",
      item_description: "",
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
      itemname: "",
    });
  }

  confirmSubmit = () => {
    let error = false;
    if (this.state.medicationitemname.length == 0) {
      error = true;
      this.setState({
        medicationitemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else {
      this.setState({ medicationitemnameError: null });
    }
    if (this.state.medicationcategory == "0") {
      error = true;
      this.setState({
        medicationcategoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ medicationcategoryError: null });
    }
    if (this.state.medicationunitprice.length == 0) {
      error = true;
      this.setState({
        medicationunitpriceError: (
          <small className="text-danger">Unit Price is required.</small>
        ),
      });
    } else {
      this.setState({ medicationunitpriceError: null });
    }
    if (this.state.is_flash_medicine === 0) {
      if (this.state.medicationitemcode.length == 0) {
        error = true;
        this.setState({
          medicationitemcodeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ medicationitemcodeError: null });
      }
    } else {
      this.setState({ medicationitemcodeError: null });
    }
    if (this.state.medicationcity == "0") {
      error = true;
      this.setState({
        medicationcityError: (
          <small className="text-danger">Distrcit is required.</small>
        ),
      });
    } else {
      this.setState({ medicationcityError: null });
    }

    if (!error) {
      var packageimages = this.state.package_image_data;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var medicationaddcommision = "";
      if (this.state.medicationaddcommision == "1") {
        medicationaddcommision = "1";
      } else if (this.state.medicationaddcommision == "2") {
        medicationaddcommision = "0";
      }
      var medicationis_featured = "";
      if (this.state.medicationis_featured == "1") {
        medicationis_featured = "1";
      } else if (this.state.medicationis_featured == "2") {
        medicationis_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }
      AddMedication(
        this.state.medicationitemname,
        this.state.medicationcategory,
        this.state.medicationitemcode,
        medicationaddcommision,
        this.state.medicationunitprice,
        this.state.medicationcity,
        this.state.medicationdescription,
        medicationis_featured,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.display_discount,
        this.state.supplier,
        this.state.primaryimage,
        packageimages,
        this.state.tags,
        obj,
        this.state.item_description,
      )
        .then((res) => {
          if (res.data.success == false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ medicationerrormessage: ermessage });
              this.medication_item_code_error.current.focus();
              this.setState({
                medicationitemcodeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success == true) {
            var nmdata = "";
            nmdata = res.data.data;

            if (this.state.city_id == nmdata.country_id) {
              var medicationItems = [];
              if (nmdata != undefined) {
                var data = {
                  value: nmdata.id,
                  label: nmdata.title + "(" + nmdata.item_code + ")",
                };

                var array1 = this.state.medicationItems;
                var array2 = array1.concat(data);

                var array1md = this.state.medication_detail;
                var array2md = array1md.concat(res.data.data);
                /* this.setState({  medication_detail : array2md,
            medicationItems : array2,  });*/
              }
            } else {
              // this.setState({medication_detail :  this.state.medication_detail ,
              //  medicationItems : this.state.medicationItems});
            }

            this.setState({
              showmediactonModal: false,
              medicationaddcommision: "1",
              medicationdescription: "",
              medicationunitprice: 0,
              medicationitemcode: "",
              medicationis_featured: "2",
              // medicationprice : 0,
              medicationitemname: "",

              medicationcategory: "",
              medicationcity: "0",
            });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    }
  };

  setInputRef = (el, index) => {
    if (!this.inputRef.current) {
      this.inputRef.current = {};
    }
    this.inputRef.current[index] = el;
  };

  setBarcodeRef = (el, index) => {
    if (!this.barcodeInputRef.current) {
      this.barcodeInputRef.current = {};
    }
    this.barcodeInputRef.current[index] = el;
  };
  setSellingPriceInputRef = (el, index) => {
    console.log("setSellingPriceInputRef called with el:", el, "index:", index);
    if (!this.sellingPriceInputRef.current) {
      this.sellingPriceInputRef.current = {};
    }
    this.sellingPriceInputRef.current[index] = el;
    console.log(
      "sellingPriceInputRef.current after assignment:",
      this.sellingPriceInputRef.current,
    );
  };

  setQtyRef = (el, index, idx) => {
    if (!this.qtyInputRef.current) {
      this.qtyInputRef.current = {};
    }
    if (!this.qtyInputRef.current[index]) {
      this.qtyInputRef.current[index] = {};
    }
    this.qtyInputRef.current[index][idx] = el;
  };

  handleBarcodeNoChange = (event, id, index) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    if (event.target.value[0] === "F") {
      self.setState({
        name: event.target.value.trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcodeNot(self.state.name, index);
        }, 500),
      });
    } else {
      self.setState({
        name: event.target.value.substring(1, 7).trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcode(self.state.name, index);
        }, 500),
      });
    }
  };

  sendToParentBarcode = async (name, i) => {
    if (this.state.name.length !== 0) {
      const list = [...this.state.inputList];
      var madpackageItem = [];

      if (list[i]["item_type"] == "1") {
        let compelte = 1;
        let pg_no = 1;
        const token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var city_id = this.state.city_id;
        await searchMedicationForOrder(
          this.state.name,
          city_id,
          pg_no,
          obj,
          this.state.store,
        ).then(async (res) => {
          const list = [...this.state.inputList];

          var mdata = res.data.data;
          var medicationItems = [];

          //alert("in else")
          this.setState({ medication_detail: [] });

          res.data.data.map((x, i) => {
            medicationItems.push({
              value: x.id,
              label: x.title + "(" + x.item_code + ")",
            });
          });

          // for (let x of mdata) {
          //   // Call updateMedication_old_data API for each medication
          //   const res = await updateMedication_old_data(x.id, obj);
          //   const sellingPrice = res.data.price;
          //   const itemDes = res.data.description;

          //   medicationItems.push({
          //     value: x.id,
          //     label: `${x.title}(${x.item_code}) - ${x.barcode}`,
          //     // selling_price: sellingPrice, // Add sellingPrice to each medication item
          //   });
          //   this.setState({
          //     selling_price: sellingPrice,
          //     item_description: itemDes,
          //   });
          // }
          list[i]["medicationItems"] = medicationItems;
          this.setState({ inputList: list });

          var mew_arr = this.state.medicationItems;
          mew_arr[i] = medicationItems;
          var array1md = this.state.medication_detail;
          var array2md = array1md.concat(res.data.data);
          var medi_array = [];
          medi_array[i] = array2md;

          this.setState({
            medication_detail: medi_array,
            medicationItems: mew_arr,
          });
          if (medicationItems.length === 1) {
            // Automatically select the only result
            // this.handleSelectChange(i, medicationItems[0]);
          } else if (medicationItems.length > 1) {
            // Focus on the Select component when there are more than one items
            if (this.inputRef.current && this.inputRef.current[i]) {
              this.inputRef.current[i].focus();
              this.inputRef.current[i].onMenuOpen();
            }
          }
        });
      } else if (list[i]["item_type"] == "2") {
        this.state.packageItems.map((x, i) => {
          madpackageItem.push({
            value: x.value,
            label: x.label,
          });
        });
        list[i]["medicationItems"] = madpackageItem;
      }

      this.setState({ inputList: list });
      if (list[i]["barcode"]) {
        const removeFirstDigit = list[i]["barcode"].slice(1);
        if (name === removeFirstDigit) {
          this.handleAddMultipleClick();
        }
      }
    } else {
      const list = [...this.state.inputList];
      list[i]["medicationItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };
  sendToParentBarcodeNot = async (name, i) => {
    if (this.state.name.length !== 0) {
      const list = [...this.state.inputList];
      var madpackageItem = [];

      if (list[i]["item_type"] == "1") {
        let compelte = 1;
        let pg_no = 1;
        const token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var city_id = this.state.city_id;
        await searchMedicationUsingBarcodeForOrder(
          this.state.name,
          city_id,
          pg_no,
          obj,
        ).then(async (res) => {
          const list = [...this.state.inputList];

          var mdata = res.data.data;

          var medicationItems = [];

          //alert("in else")
          this.setState({ medication_detail: [] });

          res.data.data.map(async (x, i) => {
            medicationItems.push({
              value: x.id,
              label: x.title + "(" + x.item_code + ")",
              //  +
              // (x.barcode != null ? " - " + x.barcode : "")
            });
          });
          // for (let x of mdata) {
          //   // Call updateMedication_old_data API for each medication
          //   const res = await updateMedication_old_data(x.id, obj);
          //   const sellingPrice = res.data.price;
          //   const itemDes = res.data.description;

          //   medicationItems.push({
          //     value: x.id,
          //     label: `${x.title}(${x.item_code}) - ${x.barcode}`,
          //     // selling_price: sellingPrice, // Add sellingPrice to each medication item
          //   });
          //   this.setState({
          //     selling_price: sellingPrice,
          //     item_description: itemDes,
          //   });
          // }
          list[i]["medicationItems"] = medicationItems;
          this.setState({ inputList: list });

          var mew_arr = this.state.medicationItems;
          mew_arr[i] = medicationItems;
          var array1md = this.state.medication_detail;
          var array2md = array1md.concat(res.data.data);
          var medi_array = [];
          medi_array[i] = array2md;

          this.setState({
            medication_detail: medi_array,
            medicationItems: mew_arr,
          });
          if (medicationItems.length === 1) {
            // Automatically select the only result
            // this.handleSelectChange(i, medicationItems[0]);
          } else if (medicationItems.length > 1) {
            // Focus on the Select component when there are more than one items
            // if (this.inputRef.current && this.inputRef.current[i]) {
            //   this.inputRef.current[i].focus();
            //   this.inputRef.current[i].onMenuOpen();
            // }
            if (
              this.barcodeInputRef.current &&
              this.barcodeInputRef.current[i]
            ) {
              this.barcodeInputRef.current[i].focus();
              this.barcodeInputRef.current[i].onMenuOpen();
            }
          }
        });
      } else if (list[i]["item_type"] == "2") {
        this.state.packageItems.map((x, i) => {
          madpackageItem.push({
            value: x.value,
            label: x.label,
          });
        });
        list[i]["medicationItems"] = madpackageItem;
      }
      this.setState({ inputList: list });

      if (name === list[i]["barcode"]) {
        this.handleAddMultipleClick();
      }
    } else {
      const list = [...this.state.inputList];
      list[i]["medicationItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], medicationItems: [] });
    }
    // this.inputRef.current[`${i}`].focus();
    // this.inputRef.current[`${i}`].onMenuOpen();
    // this.handleAddClick();
  };

  add_new_medication_category = async () => {
    let error = false;
    if (this.state.medicationitemname.length == 0) {
      error = true;
      this.setState({
        medicationitemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else {
      this.setState({ medicationitemnameError: null });
    }
    if (this.state.medicationcategory == "0") {
      error = true;
      this.setState({
        medicationcategoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ medicationcategoryError: null });
    }
    if (this.state.medicationunitprice.length == 0) {
      error = true;
      this.setState({
        medicationunitpriceError: (
          <small className="text-danger">Unit Price is required.</small>
        ),
      });
    } else {
      this.setState({ medicationunitpriceError: null });
    }
    if (this.state.is_flash_medicine === 0) {
      if (this.state.medicationitemcode.length == 0) {
        error = true;
        this.setState({
          medicationitemcodeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ medicationitemcodeError: null });
      }
    } else {
      this.setState({ medicationitemcodeError: null });
    }
    if (this.state.medicationcity == "0") {
      error = true;
      this.setState({
        medicationcityError: (
          <small className="text-danger">Distrcit is required.</small>
        ),
      });
    } else {
      this.setState({ medicationcityError: null });
    }
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var id = "";
    await checkMedication(this.state.medicationitemname, id, obj).then(
      (res) => {
        if (res.data.success === false) {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => this.confirmSubmit(id)}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="danger"
                confirmBtnText="Yes, add it!"
                cancelBtnText="Cancel"
                showCancel
              >
                <h4>
                  This medication name already exist. Are you sure you want to
                  add it!
                </h4>
              </SweetAlert>
            ),
          });
        }
      },
    );
    if (!error) {
      var packageimages = this.state.package_image_data;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var medicationaddcommision = "";
      if (this.state.medicationaddcommision == "1") {
        medicationaddcommision = "1";
      } else if (this.state.medicationaddcommision == "2") {
        medicationaddcommision = "0";
      }
      var medicationis_featured = "";
      if (this.state.medicationis_featured == "1") {
        medicationis_featured = "1";
      } else if (this.state.medicationis_featured == "2") {
        medicationis_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }
      AddMedication(
        this.state.medicationitemname,
        this.state.medicationcategory,
        this.state.medicationitemcode,
        medicationaddcommision,
        this.state.medicationunitprice,
        this.state.medicationcity,
        this.state.medicationdescription,
        medicationis_featured,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.display_discount,
        this.state.supplier,
        this.state.primaryimage,
        packageimages,
        this.state.tags,
        obj,
        this.state.item_description,
      )
        .then((res) => {
          if (res.data.success == false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ medicationerrormessage: ermessage });
              this.medication_item_code_error.current.focus();
              this.setState({
                medicationitemcodeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success == true) {
            var nmdata = "";
            nmdata = res.data.data;

            if (this.state.city_id == nmdata.country_id) {
              var medicationItems = [];
              if (nmdata != undefined) {
                var data = {
                  value: nmdata.id,
                  label: nmdata.title + "(" + nmdata.item_code + ")",
                };

                var array1 = this.state.medicationItems;
                var array2 = array1.concat(data);

                var array1md = this.state.medication_detail;
                var array2md = array1md.concat(res.data.data);
                /* this.setState({  medication_detail : array2md,
            medicationItems : array2,  });*/
              }
            } else {
              // this.setState({medication_detail :  this.state.medication_detail ,
              //  medicationItems : this.state.medicationItems});
            }

            this.setState({
              showmediactonModal: false,
              medicationaddcommision: "1",
              medicationdescription: "",
              medicationunitprice: 0,
              medicationitemcode: "",
              medicationis_featured: "2",
              // medicationprice : 0,
              medicationitemname: "",

              medicationcategory: "",
              medicationcity: "0",
            });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    }
  };

  handleMedicineSelectChange = async (selectedOption, index) => {
    if (!selectedOption || !selectedOption.value) {
      return;
    }

    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token ? token.token : null;
    const list = [...this.state.inputList];
    let itemId = 0;
    const findSelectedMedicine = (this.state.localMedicationData || []).find(
      (med) => med.id === selectedOption.value,
    );
    if (!findSelectedMedicine) {
      return;
    }

    const storeWiseMedication = Array.isArray(
      findSelectedMedicine.store_wise_medication,
    )
      ? findSelectedMedicine.store_wise_medication
      : [];

    console.log("findSelectedMedicine", findSelectedMedicine);
    const getPharmacyLevelQuantity = storeWiseMedication.find(
      (med) =>
        med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
    );

    const getStoreLevelQuantity = storeWiseMedication.find(
      (med) => med.pharmacies && med.pharmacies.name === "Flash WareHouse",
    );
    const newData = await searchMedicationById(obj, selectedOption.value);
    console.log("newData", newData.data.data);
    let batches = [];
    const getTotalQuantity =
      findSelectedMedicine &&
      storeWiseMedication.reduce((acc, curr) => acc + curr.quantity, 0);

    const filterPharmacymedicine = newData.data.data.medication_batches.filter(
      (med) =>
        med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
    );
    console.log("Filter Pharmacy Medicine:", filterPharmacymedicine);
    if (
      findSelectedMedicine &&
      // Array.isArray(findSelectedMedicine.batches) &&
      // findSelectedMedicine.batches.length > 0 &&
      newData &&
      newData.data &&
      newData.data.data &&
      (newData.data.data.product_categories == "medicine" ||
        newData.data.data.product_categories == "Medicine")
    ) {
      batches = filterPharmacymedicine || [];
    } else {
      batches = [
        {
          medication_id: selectedOption.value,
          batch_no: "",
          quantity: getTotalQuantity || 0,
          item_code:
            (newData &&
              newData.data &&
              newData.data.data &&
              newData.data.data.item_code) ||
            "",
          expiry_date: "",
        },
      ];
    }

    if (findSelectedMedicine) {
      const addDetails = list.map((item, idx) => {
        if (idx === index) {
          itemId = item.id;
          return {
            ...item,
            description: selectedOption,
            unitprice: parseFloat(findSelectedMedicine.price - 0).toFixed(2),
            unit_price: parseFloat(findSelectedMedicine.price - 0).toFixed(2),
            total_quantity: findSelectedMedicine.total_quantity,
            availableQuantity: Number(findSelectedMedicine.total_quantity),
            total_allocated: Number(findSelectedMedicine.total_allocated),
            selling_price: findSelectedMedicine.price,
            barcode: findSelectedMedicine.barcode,
            subtotal: Number(
              parseFloat(findSelectedMedicine.price - 0).toFixed(2) *
                item.quantity,
            ).toFixed(2),
            location:
              findSelectedMedicine.xcoord && findSelectedMedicine.ycoord
                ? `${findSelectedMedicine.ycoord}${findSelectedMedicine.xcoord}`
                : null,
            medicinBatchesdata: batches,
            item_code: findSelectedMedicine.item_code,
            storeLevelQuantity: getStoreLevelQuantity
              ? getStoreLevelQuantity.quantity
              : 0,
            pharmacyLevelQuantity: getPharmacyLevelQuantity
              ? getPharmacyLevelQuantity.quantity
              : 0,
            other_brands: newData && newData.data.data.genericNamesList,
            generic_name: newData && newData.data.data.generic_name,
            reOrderLevel: newData && newData.data.data.reorder_level,
            consumtionLevel: newData && newData.data.data.daily_consumption,
            quantity: 1,
          };
        }
        return item;
      });

      const availableQuantity = Number(findSelectedMedicine.total_quantity);
      if (
        Number(list[index]["quantity"]) > availableQuantity ||
        0 === availableQuantity
      ) {
        this.setState({ isOverQuantity: index });
      } else {
        this.setState({ isOverQuantity: "" });
      }

      this.handlebasketandsubtotal();

      this.setState(
        {
          inputList: addDetails,
          medicinBatchesdata: findSelectedMedicine.batches,
          expandedId: itemId,
        },
        () => {
          // Focus selling price input after state update if this was triggered by barcode scan
          if (index !== null) {
            setTimeout(() => {
              console.log("Focusing selling price input at index:", index);
              this.focusSellingPriceInput(index, 0);
            }, 300);
          }
        },
      );
    }
    // this.handleSelectChange(index, selectedOption);
  };

  // handleSelectChange = (index, value) => {
  //   let name = "description";
  //   const list = [...this.state.inputList];
  //   list[index][name] = value.value;
  //   var temp_arr = [];
  //   //  temp_arr.push(value)

  //   if (list[index]["item_type"] == "1") {
  //     this.state.medication_detail.map((pac) => {
  //       if (list[index]["description"] == pac.id) {
  //         list[index]["unitprice"] = parseFloat(pac.price - 0).toFixed(2);
  //       }
  //     });

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;

  //     const data = this.state.medication_detail[index].map((medi) => {
  //       if (list[index]["description"] == medi.id) {
  //         // const matchingItem = this.state.inputList.filter(
  //         //   (item) => item.description === medi.id
  //         // );

  //         // if (matchingItem.length > 1) {
  //         //   const currentTotalQuantity =
  //         //     medi.total_quantity - matchingItem[0].quantity;

  //         //   list[index]["unitprice"] = parseFloat(medi.price - 0).toFixed(2);
  //         //   list[index]["selling_price"] = medi.price;
  //         //   list[index]["total_quantity"] = currentTotalQuantity;
  //         //   list[index]["availableQuantity"] = currentTotalQuantity;
  //         //   list[index]["barcode"] = medi.barcode;

  //         //   if (currentTotalQuantity >= list[index]["quantity"]) {
  //         //     list[index]["isPartialOrderItem"] = true;
  //         //   } else {
  //         //     list[index]["isPartialOrderItem"] = false;
  //         //   }
  //         // } else {
  //         list[index]["unitprice"] = parseFloat(medi.price - 0).toFixed(2);

  //         list[index]["total_quantity"] = medi.total_quantity;
  //         list[index]["availableQuantity"] = Number(medi.total_quantity);
  //         list[index]["total_allocated"] = Number(medi.total_allocated);

  //         list[index]["selling_price"] = medi.price;
  //         list[index]["barcode"] = medi.barcode;

  //         // if (Number(medi.total_quantity) === 0) {
  //         //   // list[index]["quantity"] = medi.total_quantity;
  //         //   this.setState({ isWrongQuantity: true });
  //         // }
  //         // list[index]["item_description"] = medi.description;
  //         // if (medi.total_quantity >= list[index]["quantity"]) {
  //         //   list[index]["isPartialOrderItem"] = true;
  //         // } else {
  //         //   list[index]["isPartialOrderItem"] = false;
  //         // }
  //         // }
  //       }
  //     });

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

  //     const availableQuantity = parseFloat(list[index]["availableQuantity"]);
  //     // if (availableQuantity < 1) {
  //     //   this.setState({ isWrongQuantity: true });
  //     //   this.setState({ wrongFieldId: index });
  //     // } else {
  //     //   this.setState({ isWrongQuantity: false });
  //     //   this.setState({ wrongFieldId: "" });
  //     // }

  //     if (
  //       Number(list[index]["quantity"]) > availableQuantity ||
  //       0 === availableQuantity
  //     ) {
  //       this.setState({ isOverQuantity: index });
  //     } else {
  //       this.setState({ isOverQuantity: "" });
  //     }

  //     this.setState({ inputList: list, totalcost: "", discountamount: 0 });

  //     this.handlebasketandsubtotal();
  //     var new_array = this.state.medicationItems;
  //     new_array[index] = [];
  //     this.setState({ medicationItems: new_array });
  //   } else if (list[index]["item_type"] == "2") {
  //     this.state.labpackage.map((repo) => {
  //       if (list[index]["description"] == repo.id) {
  //         list[index]["unitprice"] = parseFloat(repo.price - 0).toFixed(2);
  //       }
  //     });

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;
  //     const data = this.state.labpackage.map((medi) => {
  //       if (list[index]["description"] == medi.id) {
  //         list[index]["unitprice"] = parseFloat(medi.price - 0).toFixed(2);
  //         list[index]["total_quantity"] = medi.total_quantity;
  //         list[index]["availableQuantity"] = medi.quantity;
  //         list[index]["selling_price"] = medi.price;
  //         // list[index]["item_description"] = medi.description;
  //         // if (medi.total_quantity >= list[index]["quantity"]) {
  //         //   list[index]["isPartialOrderItem"] = true;
  //         // } else {
  //         //   list[index]["isPartialOrderItem"] = false;
  //         // }
  //       }
  //     });

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

  //     this.setState({ inputList: list, totalcost: "", discountamount: 0 });

  //     this.handlebasketandsubtotal();
  //     var new_array = this.state.medicationItems;
  //     new_array[index] = [];
  //     this.setState({ medicationItems: new_array });
  //   }
  // };

  handleInputChange = (e, index, type) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];

    const numericValue = parseFloat(value);
    const availableQuantity = parseFloat(list[index]["availableQuantity"]);

    if (
      type === "quantity" &&
      list[index]["isPartialOrderItem"] &&
      (value < 1 || availableQuantity < 1)
    ) {
      this.setState({ isWrongQuantity: true });
      this.setState({ wrongFieldId: index });
    } else {
      this.setState({ isWrongQuantity: false });
      this.setState({ wrongFieldId: "" });
    }

    if (
      type === "quantity" &&
      list[index]["isPartialOrderItem"] &&
      (value > availableQuantity || 0 === availableQuantity)
    ) {
      this.setState({
        isOverQuantity: index,
        // isWrongQuantity: true
      });
      // this.setState({ wrongFieldId: index });
    } else {
      this.setState({ isOverQuantity: "" });
      // this.setState({ wrongFieldId: "" });
    }

    // if (type === "quantity" && numericValue > availableQuantity) {
    //   list[index]["isPartialOrderItem"] = false;
    // } else {
    //   list[index]["isPartialOrderItem"] = true;
    // }

    if (name == "item_type") {
      if (list[index][name] != value) {
        list[index]["description"] = "";
        list[index]["unitprice"] = 0;
        list[index]["newmargin"] = 0;
        list[index]["item_type"] = value;
        list[index]["margin_discount_percentage"] = 0;
        list[index]["margin_discount_sub_type"] = 2;
        list[index]["quantity"] = 1;
        list[index]["subtotal"] = 0;
        list[index]["medicationItems"] = [];
        list[index]["selectmedication"] = "";
        list[index]["availableQuantity"] = 0;
        list[index]["orderItemNumber"] = 0;
        list[index]["item_description"] = "";
        list[index]["selling_price"] = "";

        this.setState({ inputList: list, availableQuantity: value });

        this.handlebasketandsubtotal();
      }
    } else {
      if (list[index]["unitprice"] == "" || list[index]["unitprice"] == null) {
        list[index][name] = value;
        // if (
        //   type === "quantity" &&
        //   list[index]["isPartialOrderItem"] &&
        //   value > availableQuantity
        // ) {
        //   list[index]["quantity"] = availableQuantity;
        // }
        this.setState({
          inputList: list,
        });
      } else {
        list[index][name] = value;
        // if (
        //   type === "quantity" &&
        //   list[index]["isPartialOrderItem"] &&
        //   value > availableQuantity
        // ) {
        //   list[index]["quantity"] = availableQuantity;
        // }
        var subtotal = list[index]["unitprice"] * list[index]["quantity"] || 0;
        var addmargin = 0;
        if (list[index]["margin_discount_sub_type"] == 2) {
          if (
            list[index]["newmargin"] != "" &&
            list[index]["newmargin"] != 0 &&
            list[index]["newmargin"] != null &&
            !isNaN(parseFloat(list[index]["newmargin"]))
          ) {
            addmargin = list[index]["newmargin"];
          } else {
            addmargin = 0;
          }
        } else {
          if (
            list[index]["margin_discount_percentage"] != "" &&
            list[index]["margin_discount_percentage"] != 0 &&
            list[index]["margin_discount_percentage"] != null &&
            !isNaN(parseFloat(list[index]["margin_discount_percentage"]))
          ) {
            addmargin =
              (subtotal * list[index]["margin_discount_percentage"]) / 100;
          }
        }

        list[index]["subtotal"] =
          (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) *
            list[index]["quantity"] || 0;
        list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

        this.setState({
          inputList: list,
        });
        this.handlebasketandsubtotal();
      }
    }
  };

  handleInputDescriptionChange = (e, index, type) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];

    if (name == "item_type") {
      if (list[index][name] != value) {
        list[index]["description"] = "";
        list[index]["unitprice"] = "";
        list[index]["newmargin"] = "";
        list[index]["item_type"] = value;
        list[index]["margin_discount_percentage"] = 0;
        list[index]["margin_discount_sub_type"] = 2;
        list[index]["quantity"] = 1;
        list[index]["subtotal"] = 0;
        list[index]["medicationItems"] = [];
        list[index]["selectmedication"] = "";
        list[index]["availableQuantity"] = "";
        list[index]["orderItemNumber"] = 0;
        list[index]["item_description"] = "";
        list[index]["selling_price"] = "";

        this.setState({ inputList: list });
        this.handlebasketandsubtotal();
      }
    } else {
      if (list[index]["unitprice"] == "" || list[index]["unitprice"] == null) {
        list[index][name] = value;
        this.setState({
          inputList: list,
        });
      } else {
        list[index][name] = value;
        var subtotal = list[index]["unitprice"] * list[index]["quantity"];
        var addmargin = 0;
        if (list[index]["margin_discount_sub_type"] == 2) {
          if (
            list[index]["newmargin"] != "" &&
            list[index]["newmargin"] != 0 &&
            list[index]["newmargin"] != null &&
            !isNaN(parseFloat(list[index]["newmargin"]))
          ) {
            addmargin = list[index]["newmargin"];
          } else {
            addmargin = 0;
          }
        } else {
          if (
            list[index]["margin_discount_percentage"] != "" &&
            list[index]["margin_discount_percentage"] != 0 &&
            list[index]["margin_discount_percentage"] != null &&
            !isNaN(parseFloat(list[index]["margin_discount_percentage"]))
          ) {
            addmargin =
              (subtotal * list[index]["margin_discount_percentage"]) / 100;
          }
        }

        list[index]["subtotal"] =
          (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) *
          list[index]["quantity"];
        list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);
        list[index]["claimableValue"] = JSON.parse(list[index]["subtotal"]);
        if (
          list[index]["isChecked"] &&
          this.claimableTotal +
            list[index]["subtotal"] +
            Number(this.state.deliverycharge) >
            this.state.availableTotalClaimCredits
        ) {
          list[index]["isChecked"] = false;
        }
        this.setState({
          inputList: list,
        });
        this.handlebasketandsubtotal();
      }
    }
  };

  openmarginmodal() {
    this.setState({ marginmodal: true });
  }
  opendiscountmodal() {
    this.setState({ discountmodal: true });
  }

  closedynamicdiscount() {
    var dd = "";
    if (
      this.state.discountpercentage == 0 ||
      this.state.discountpercentage == null
    ) {
      this.setState({ discountpercentage: 0 });
    } else {
      this.setState({ discountpercentage: this.state.discountpercentage });
    }
    this.setState({
      discountmodal: false,
      // dynamicfinalpercentage : 0
    });
  }

  closedynamicmargin() {
    var margin = "";
    if (this.state.margintype == 1) {
      if (
        this.state.marginpercentage == null ||
        this.state.marginpercentage == 0
      ) {
        this.setState({ marginpercentage: 0 });
      } else {
        this.setState({ marginpercentage: this.state.marginpercentage });
      }
    } else if (this.state.margintype == 2) {
      if (this.state.marginamount == null || this.state.marginamount == 0) {
        this.setState({ marginamount: 0 });
      } else {
        this.setState({ marginamount: this.state.marginamount });
      }
    }

    this.setState({
      marginmodal: false,
      // marginfinalamount : margin
    });
  }

  submitdynamicdiscount() {
    this.handlebasketandsubtotal();
    var dd = "";
    if (
      this.state.discountpercentage != null ||
      this.state.discountpercentage != 0
    ) {
      dd = this.state.discountpercentage;
    } else {
      dd = 0;
    }
    this.setState({
      discountmodal: false,
      dynamicfinalpercentage: dd,
    });
  }

  submitdynamicmargin() {
    this.handlebasketandsubtotal();

    var margin = "";
    if (this.state.margintype == 1) {
      margin = 0;
      if (
        this.state.marginpercentage != null ||
        this.state.marginpercentage != 0
      ) {
        margin = this.state.marginpercentage;
      } else {
        margin = 0;
      }
      this.setState({ displaymarginpercentage: margin });
    } else if (this.state.margintype == 2) {
      margin = 0;
      if (this.state.marginamount != null || this.state.marginamount != 0) {
        margin = this.state.marginamount;
      } else {
        margin = 0;
      }
      this.setState({ displaymarginamount: margin });
    }

    this.setState({
      marginmodal: false,
      marginfinalamount: margin,
    });
  }
  // handle click event of the Remove button
  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({ inputList: list });

    const list1 = list;

    let count_x = 1;
    list1.map((medi, ind) => {
      list1[ind]["srno"] = count_x;
      count_x++;
    });
    this.serial = count_x;

    const enableSubmitButton = list.some((data) => Number(data.quantity) === 0);
    if (!enableSubmitButton) {
      this.setState({ isWrongQuantity: false });
    } else {
      this.setState({ isWrongQuantity: true });
    }
    this.setState({ inputList: list1 });

    this.handlebasketandsubtotal();
  };

  deliveryTypeLabel(deliveryValue) {
    switch (deliveryValue) {
      case "1":
        return "standard";
      case "2":
        return "express";
      case "3":
        return "island_wide";
      case "4":
        return "pick_up_wide_delivery_charge";
    }
  }

  deliveryTypeLabel3(deliveryValue) {
    switch (deliveryValue) {
      case "1":
        return "standard_delivery_charge";
      case "2":
        return "express_delivery_charge";
      case "3":
        return "island_wide_delivery_charge";
      case "4":
        return "pick_up_wide_delivery_charge";
    }
  }

  handleDeliveryTypeOnChange(value) {
    this.setState({ deliverytype: value });
    if (this.state.store !== 1 && this.state.store !== null) {
      this.setState({
        deliverycharge: 0,
        isDeliveryCharge: true,
      });
      this.handlebasketandsubtotal();
      return;
    }
    if (this.state.sub_orderType === false) {
      var deliveryCharge = 0;
      var isDeliveryDisabled = false;

      const deliveryValue =
        this.state.DeliveryChargeValues &&
        this.state.DeliveryChargeValues.find(
          (deliveryChargeValue) =>
            deliveryChargeValue.setting_key ===
            this.deliveryTypeLabel3(value.value),
        );
      const checkData =
        this.state.packagefeatures.length &&
        this.state.packagefeatures[0].express.find(
          (deliveryDetails) =>
            deliveryDetails.type === this.deliveryTypeLabel(value.value),
        );
      const findTotalCount =
        this.state.packagefeatures.length &&
        this.state.packagefeatures[0].express.find(
          (totalCount) => totalCount.type === "sum",
        );

      if (
        checkData &&
        Number(checkData.free) === 0 &&
        findTotalCount &&
        Number(findTotalCount.t_count) === 0
      ) {
        if (
          Number(checkData.base_price) > 0 &&
          Number(checkData.discount) > 0
        ) {
          deliveryCharge = parseFloat(
            Number(checkData.base_price) -
              (Number(checkData.base_price) * Number(checkData.discount)) / 100,
          );
          isDeliveryDisabled = true;
        } else if (
          Number(checkData.base_price) === 0 &&
          Number(checkData.discount) > 0 &&
          deliveryValue
        ) {
          deliveryCharge = parseFloat(
            Number(deliveryValue.setting_value) -
              (Number(deliveryValue.setting_value) *
                Number(checkData.discount)) /
                100,
          );
          isDeliveryDisabled = true;
        } else if (
          Number(checkData.base_price) > 0 &&
          Number(checkData.discount) === 0
        ) {
          deliveryCharge = parseFloat(Number(checkData.base_price));
          isDeliveryDisabled = true;
        } else if (
          Number(checkData.base_price) === 0 &&
          Number(checkData.discount) === 0 &&
          deliveryValue
        ) {
          deliveryCharge = parseFloat(Number(deliveryValue.setting_value));
          isDeliveryDisabled = false;
        }
        this.setState({
          deliverycharge: deliveryCharge,
          isDeliveryCharge: isDeliveryDisabled,
        });
      } else {
        if (
          checkData &&
          Number(checkData.free) !== 0 &&
          findTotalCount &&
          Number(findTotalCount.t_count) !== 0
        ) {
          deliveryCharge = parseFloat(0);
          isDeliveryDisabled = true;
        } else if (
          Number(checkData && checkData.base_price) > 0 &&
          Number(checkData && checkData.discount) > 0
        ) {
          deliveryCharge = parseFloat(
            Number(checkData && checkData.base_price) -
              (Number(checkData && checkData.base_price) *
                Number(checkData.discount)) /
                100,
          );
          isDeliveryDisabled = true;
        } else if (
          Number(checkData && checkData.base_price) === 0 &&
          Number(checkData && checkData.discount) > 0 &&
          deliveryValue
        ) {
          deliveryCharge = parseFloat(
            Number(deliveryValue.setting_value) -
              (Number(deliveryValue.setting_value) *
                Number(checkData && checkData.discount)) /
                100,
          );
          isDeliveryDisabled = true;
        } else if (
          Number(checkData && checkData.base_price) > 0 &&
          Number(checkData && checkData.discount) === 0
        ) {
          deliveryCharge = parseFloat(
            Number(checkData && checkData.base_price),
          );
          isDeliveryDisabled = true;
        } else if (
          Number(checkData && checkData.base_price) === 0 &&
          Number(checkData && checkData.discount) === 0 &&
          deliveryValue
        ) {
          deliveryCharge = parseFloat(Number(deliveryValue.setting_value));
          isDeliveryDisabled = false;
        }
        this.setState({
          deliverycharge: deliveryCharge,
          isDeliveryCharge: isDeliveryDisabled,
        });
      }

      if (
        this.state.packagefeatures.length &&
        this.state.packagefeatures[0].express.length === 0 &&
        deliveryValue
      ) {
        deliveryCharge = parseFloat(Number(deliveryValue.setting_value));
        isDeliveryDisabled = false;
        this.setState({
          deliverycharge: deliveryCharge,
          isDeliveryCharge: isDeliveryDisabled,
        });
      }
      this.handlebasketandsubtotal();
    }
  }

  handlebasketandsubtotal() {
    var data = 0;
    var final = 0;
    var basketamount = 0;
    this.setState({ loading: true }, () => {
      this.state.inputList.map((bas) => {
        data = parseFloat(data) + parseFloat(bas.subtotal);
      });
      basketamount = parseFloat(data);
      if (this.state.margintype == 1) {
        var discountper = 0;
        if (
          this.state.marginfinalamount == "" ||
          this.state.marginfinalamount == 0
        ) {
          discountper = 0;
        } else {
          discountper = this.state.marginfinalamount;
        }
        var calculateamount =
          (parseFloat(data) * parseFloat(discountper)) / 100;
        data = parseFloat(data) + parseFloat(calculateamount);
      } else if (this.state.margintype == 2) {
        var marginamount = 0;
        if (
          this.state.marginfinalamount == "" ||
          this.state.marginfinalamount == 0
        ) {
          marginamount = 0;
        } else {
          marginamount = this.state.marginfinalamount;
        }
        data = parseFloat(data) + parseFloat(marginamount);
      }

      var discount = 0;

      if (this.state.dynamicfinalpercentage != 0) {
        discount = parseFloat(this.state.dynamicfinalpercentage);
      } else {
        if (this.state.discount == null) {
          discount = 0;
        } else {
          discount = parseFloat(this.state.discount);
        }
      }
      var discount_amount = 0;
      var deliveryCharge =
        this.state.deliverycharge !== null ? this.state.deliverycharge : 0;
      var amount = parseFloat(data) + parseFloat(deliveryCharge);

      if (discount != 0 || discount != "NaN") {
        discount_amount =
          (parseFloat(basketamount) * parseFloat(discount)) / 100;
      } else {
        discount_amount = 0;
      }

      var package_discount = 0;
      var package_discount_amount = 0;
      if (this.state.is_LeadB2B == 1 || this.state.sub_orderType == true) {
        var package_discount = parseFloat(this.state.catPackageDiscount);
      } else {
        var package_discount = parseFloat(this.state.catPackageDiscount);
        if (package_discount != 0 || package_discount != "NaN") {
          package_discount_amount =
            (parseFloat(basketamount) * parseFloat(package_discount)) / 100;
        } else {
          package_discount_amount = 0;
        }
      }

      var totalvalue =
        parseFloat(amount) -
        parseFloat(discount_amount) -
        parseFloat(package_discount_amount);

      data = data.toFixed(2);
      totalvalue = totalvalue.toFixed(2);
      discount_amount = discount_amount.toFixed(2);

      this.setState({
        loading: false,
        basketvalue: data,
        totalcost: totalvalue,
        discountamount: discount_amount,
        catPackageDiscountAmount: package_discount_amount,
      });
    });
  }

  async addrssselect(id, city_id, type) {
    this.setState({ inputList: [] }); //empty exitsing medictaion list
    this.serial = 1;
    if (type == "delivery") {
      const nextState = {
        address_id: id,
        city_id: city_id,
        // addressaccess : '0',
        cityError: null,
        countryError: null,
        medicationItems: [],
        medication_detail: [],
        latiAndLogitError: null,
        //addnewaddress :false
      };
      if (this.state.isBillingSame) {
        nextState.billing_address_id = id;
        nextState.first_billing_address = id;
        nextState.billing_city_id = city_id;
      }
      this.setState(nextState);
    } else {
      this.setState({
        billing_address_id: id,
        billing_city_id: city_id,
        // addressaccess : '0',
        cityError: null,
        countryError: null,
        medicationItems: [],
        medication_detail: [],
        latiAndLogitError: null,
        //addnewaddress :false
      });
    }

    if (id != "" && id != 0) {
      this.setState({ addnewaddress: false, addressaccess: "0" });
    } else {
      this.setState({ addnewaddress: true, addressaccess: "1" });
    }
    this.handlebasketandsubtotal();
    let compelte = 1;
    let pg_no = 1;
    /** punita remove preloaded medication list */
    {
      /* 
   while(compelte==1)
   {
    var token = JSON.parse(localStorage.getItem('user'));
    // console.log(token.token);  
    const  obj = token.token;
    
    await getcitywiseMedication(obj,city_id,pg_no)
    .then(res=> {
      var mdata = res.data.data
      
      var medicationItems = []
      if(mdata.length == 0)
      {
           compelte = 0
            this.setState({medicationloading : false})
          //  this.setState({ medicationItems : medicationItems });
      }
      else
      {
        compelte = 1
        this.setState({medicationloading : true})
        

        var array1 = this.state.medication_detail;
                var array2 = array1.concat( mdata)
                 
                  this.setState({
                    medication_detail : array2
                  })
                  let medicationItems = []
                  //console.log(this.state.medication_detail,"medicationdetail");
                  this.state.medication_detail.map((x, i) => {
                    medicationItems.push({ value:x.id , label: x.title + '('+x.item_code+')' })
                  })
                 
                  //  console.log(medicationItems , "medication item");
                  this.setState({
                    medicationItems : medicationItems
                  })
      
      
      }
    
  })
  pg_no++
  // this.setState({medicationloading : true})

  }
  */
    }
  }

  handleBillingSameToggle = () => {
    const nextChecked = !this.state.isBillingSame;
    if (nextChecked) {
      this.setState({
        isBillingSame: true,
        billing_address_id: this.state.address_id,
        first_billing_address: this.state.address_id,
        billing_city_id: this.state.city_id,
      });
    } else {
      this.setState({
        isBillingSame: false,
      });
    }
  };

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  sendToParentSubscriber = async () => {
    //this.props.searching(this.state.name);c
    // alert("==="+this.state.name.trim()+"===")
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchLeadForOrder(this.state.subscribername, obj).then((res) => {
        const data = res.data.data;
        this.setState({ getSource: data[0].source });
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.name + " (" + x.mobile_no + ")",
          });
        });

        this.setState({
          subscriber_detail: data,
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
      });
    }
  };

  sendToParent = async (name, i) => {
    //this.props.searching(this.state.name);c

    if (this.state.name.length !== 0) {
      const list = [...this.state.inputList];
      var madpackageItem = [];

      if (list[i]["item_type"] == "1") {
        let compelte = 1;
        let pg_no = 1;
        var token = JSON.parse(localStorage.getItem("user"));

        const obj = token.token;
        var city_id = this.state.city_id;
        await searchMedicationForOrder(
          this.state.name,
          city_id,
          pg_no,
          obj,
          this.state.store,
        ).then((res) => {
          const list = [...this.state.inputList];
          var mdata = res.data.data;
          var medicationItems = [];
          this.setState({ medication_detail: [] });
          res.data.data.map((x, i) => {
            medicationItems.push({
              value: x.id,
              label: x.title + "(" + x.item_code + ")",
            });
          });

          // for (let x of mdata) {
          //   // Call updateMedication_old_data API for each medication
          //   const res = await updateMedication_old_data(x.id, obj);
          //   const sellingPrice = res.data.price;
          //   const itemDescription = res.data.description;

          //   medicationItems.push({
          //     value: x.id,
          //     label: `${x.title}(${x.item_code}) - ${x.barcode}`,
          //     // selling_price: sellingPrice, // Add sellingPrice to each medication item
          //   });
          //   this.setState({
          //     // selling_price: sellingPrice,
          //     // item_description: itemDescription,
          //   });
          // }
          list[i]["medicationItems"] = medicationItems;
          this.setState({ inputList: list });

          var mew_arr = [];
          mew_arr[i] = medicationItems;
          var array1md = this.state.medication_detail;
          var array2md = array1md.concat(res.data.data);
          var medi_array = [];
          medi_array[i] = array2md;

          this.setState({
            medication_detail: medi_array,
            medicationItems: mew_arr,
          });
          // Check if there is only one medication item and select it
          if (medicationItems.length === 1) {
            // this.handleSelectChange(i, medicationItems[0]); // Automatically select the only result
          }
        });
      } else if (list[i]["item_type"] == "2") {
        this.state.packageItems.map((x, i) => {
          madpackageItem.push({
            value: x.value,
            label: x.label,
          });
        });
        list[i]["medicationItems"] = madpackageItem;
      }

      this.setState({ inputList: list });
    } else {
      // alert("==="+this.state.name.length+"===")
      const list = [...this.state.inputList];
      list[i]["medicationItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };

  setIndexValue = (event, i) => {
    //this.setState({currentMedicineIndex :i})
    //console.log("index",i)
  };

  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim(), i);
      }, 500),
    });
  };

  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };

  downshiftOnSubscriberChange = (selectedItem) => {
    var d = selectedItem.id;

    this.setState({ selectedSubscriber: d });
    this.setState({
      subscriber: d,
    });

    this.handlebasketandsubtotal();

    this.handleb2bdetails();
    this.handlebasketandsubtotal();

    setTimeout(() => {
      if (!this.state.inputList || this.state.inputList.length === 0) {
        this.handleAddMultipleClick(5);
      }
    }, 250);

    this.setState({
      deliverycharge: "",
      totalcost: "",
      discountamount: 0,
      name: "",
      email: "",
      phoneno: "",
      mobileno: "",
      addressline1: "",
      addressline2: "",
      city: "0",
      country: "1",
      postalcode: "",
      lastsubscription: [],
    });
  };

  downshiftOnChange = (selectedItem, i) => {
    var index = i;

    var d = selectedItem.id;

    this.setState({ selectedmedication: d });

    let name = "description";
    const list = [...this.state.inputList];
    list[index][name] = selectedItem.id;
    list[index]["unitprice"] = parseFloat(selectedItem.price - 0).toFixed(2);

    list[index]["subtotal"] =
      list[index]["unitprice"] * list[index]["quantity"];
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

    this.setState({ inputList: list, totalcost: "", discountamount: 0 });
    this.handlebasketandsubtotal();
    //alert(`your  Selected Medication  ${selectedItem.id}`)
  };

  handleFileChange = async (event) => {
    let data = [];

    data.push(event.target.files);

    this.setState({ package_image: data });

    var packageimages = "";
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (data.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();

      data.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("image_file[]", file[i]);
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/image";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          packageimages = res.data.data.image_url;
          this.setState({ package_image_data: packageimages });
          // priscription_array_data.push(priscription_data);
        });
    }
  };

  handleChange(tags) {
    this.setState({ tags });
  }

  handleAllChecked = (e) => {
    let arr = [];
    let emptyArray = [];
    if (e.target.checked) {
      this.setState({ isAllChecked: true });
      this.state.inputList.forEach((data) => {
        data.isChecked = true;
        arr.push(data.description);
      });
      this.setState({ medicineCheckedValue: arr });
    } else {
      this.setState({ isAllChecked: false });
      this.state.inputList.forEach((data) => {
        data.isChecked = false;
      });
      this.setState({ medicineCheckedValue: emptyArray });
    }
  };

  handleItemSelectionChange = (e, itemId) => {
    const updatedInputList = this.state.inputList.map((item) => {
      if (item.id === itemId) {
        return { ...item, isSelected: e.target.checked };
      }
      return item;
    });
    this.setState({ inputList: updatedInputList });
  };

  handleCheckboxChange = (e, med_id) => {
    let arr = [...this.state.medicineCheckedValue];
    if (e.target.checked) {
      this.state.inputList.forEach((data) => {
        if (data.id == Number(e.target.value)) {
          data.isChecked = true;
          arr.push(data.description);
        }
      });
      this.setState({ medicineCheckedValue: arr });
    } else {
      this.setState({ isAllChecked: false });
      this.state.inputList.forEach((data) => {
        if (data.id == Number(e.target.value)) {
          data.isChecked = false;
        }
      });
      const unCheckedValue = this.state.medicineCheckedValue.filter(
        (data) => data !== med_id,
      );
      this.setState({ medicineCheckedValue: unCheckedValue });
    }
  };

  handleUpsellerCheckboxChange(e) {
    const checkMedicineUpseller = this.state.inputList.map((data) => {
      if (data.id === Number(e.target.value)) {
        return {
          ...data,
          isUpSeller: e.target.checked,
        };
      }
      return data;
    });
    this.setState({ inputList: checkMedicineUpseller });
  }
  // handlePartialOrderCheckboxChange(e) {
  //   const checkMedicinePartialOrder = this.state.inputList.map((data) => {
  //     if (data.id === Number(e.target.value)) {
  //       return {
  //         ...data,
  //         isPartialOrderItem: e.target.checked,
  //       };
  //     }
  //     return data;
  //   });
  //   const findPartialItemsIncluded = checkMedicinePartialOrder.filter(
  //     (item) => !item.isPartialOrderItem,
  //   );

  //   this.setState(
  //     {
  //       inputList: checkMedicinePartialOrder,
  //       isPartialOrder: findPartialItemsIncluded.length > 0 ? true : false,
  //     },
  //     () => {
  //       this.getUnavailableCost();
  //     },
  //   );
  //   // this.getPartialSentData(checkMedicinePartialOrder);
  // }
  handlePartialOrderOnChange = (e) => {
    this.setState({ isPartialOrder: e.target.checked });
  };
  handleAbusableOrderOnChange = (e) => {
    this.setState({ isAbusableOrder: e.target.checked });
  };
  handleis_printableOnChange(e) {
    const checkMedicinePrintable = this.state.inputList.map((data) => {
      if (data.id === Number(e.target.value)) {
        return {
          ...data,
          is_printable: e.target.checked,
        };
      }
      return data;
    });
    this.setState({ inputList: checkMedicinePrintable });
  }

  handleMarkedAsClaimOrderOnChange = (e) => {
    if (!e.target.checked) {
      const removeClaimableFlag = this.state.inputList.map((item) => {
        return {
          ...item,
          isChecked: false,
        };
      });
      this.setState({ inputList: removeClaimableFlag });
    }
    this.setState({ isClaimableOrder: e.target.checked });
  };
  handleInputLocationChange = (e) => {
    const input = e.target.value;
    this.setState({ input });
    const [latitude, longitude] = input.split(",").map((coord) => coord.trim());
    if (input.includes(",")) {
      this.setState({
        latitude: latitude || "",
        longitude: longitude || "",
      });
    } else {
      this.setState({
        latitude: latitude,
        longitude: "",
      });
    }
    this.setState({
      latiAndLogitError: null,
    });
  };
  getUnavailableCost = () => {
    const unavailableCost = this.state.inputList
      .filter((item) => !item.isPartialOrderItem)
      .reduce((sum, item) => sum + Number(item.subtotal || 0), 0);
    this.setState({ getUnavalibleCost: unavailableCost });
  };

  handleAddressSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Address</b> - Created Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleAddressChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onSubmitAddressModal = () => {
    const validationState = {
      addressline1Error: null,
      cityError: null,
      countryError: null,
      addressTypeError: null,
      latiAndLogitError: null,
    };

    if (!this.state.addressline1 || this.state.addressline1.trim() === "") {
      validationState.addressline1Error = (
        <small className="text-danger">Address is required.</small>
      );
    }

    if (!this.state.city || this.state.city === "0") {
      validationState.cityError = (
        <small className="text-danger">District is required.</small>
      );
    }

    if (!this.state.country || this.state.country == "0") {
      validationState.countryError = (
        <small className="text-danger">Country is required.</small>
      );
    }

    if (!this.state.addressType || this.state.addressType === "0") {
      validationState.addressTypeError = (
        <small className="text-danger">Address Type is required.</small>
      );
    }

    if (!this.state.latitude || !this.state.longitude) {
      validationState.latiAndLogitError = (
        <small className="text-danger">
          Latitude and Longitude are required.
        </small>
      );
    }

    const hasErrors = Object.values(validationState).some(Boolean);
    if (hasErrors) {
      this.setState({ validationState: validationState });
      return;
    }

    this.setState({ validationState: validationState });
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const addressPayload = {
      address_line1: this.state.addressline1,
      address_line2: this.state.addressline2,
      city: this.state.city,
      postal_code: this.state.postalcode,
      country_id: this.state.country,
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      address_type: this.state.addressType,
      customAddress: this.state.customAddress,
    };
    createAddress(obj, addressPayload, this.state.subscriber)
      .then((res) => {
        if (res.data.success) {
          this.handleAddressSuccess("bl");

          this.setState({
            addressdata: res.data.data.address,
            isCreateAddressModalOpen: false,
            addressline1: "",
            addressline2: "",
            city: "",
            postalcode: "",
            country: "1",
            latitude: "",
            longitude: "",
            customAddress: "",
            input: "",
            addressType: "",
            address_id:
              this.state.addressModalType === "delivery"
                ? res.data.data.address_id
                : this.state.address_id,
            first_address:
              this.state.addressModalType === "delivery"
                ? res.data.data.address_id
                : this.state.address_id,
            billing_address_id:
              this.state.addressModalType === "billing"
                ? res.data.data.address_id
                : this.state.billing_address_id,
            first_billing_address:
              this.state.addressModalType === "billing"
                ? res.data.data.address_id
                : this.state.first_billing_address,
          });
          // want to refresh the page to show the new address added
        }
        console.log("res", res);
      })
      .catch((error) => {
        console.error("Error creating address", error);
      });
  };

  handleBatchNumber = async (value, scannedIndex = null) => {
    console.log("handleBatchNumber", value, "scannedIndex:", scannedIndex);
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (value !== "") {
      try {
        const data = await getBatchNumberByAllMedicine(obj, value);

        if (
          (data && data.status === 404) ||
          (data && data.data && data.data.status === 404)
        ) {
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnText="OK"
                confirmBtnBsStyle="danger"
              >
                <h4>No medicine found for this batch number.</h4>
              </SweetAlert>
            ),
          });
          return;
        }

        console.log("Batch number data response:", data);
        console.log("data", data.data.data);
        const getPharmacyLevelQuantity =
          data.data.data.medication.store_wise_medication.find(
            (med) =>
              med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
          );

        const getStoreLevelQuantity =
          data.data.data.medication.store_wise_medication.find(
            (med) =>
              med.pharmacies && med.pharmacies.name === "Flash WareHouse",
          );
        this.setState({
          medicinBatchesdata:
            data.data.data.medication.medication_batches || [],
        });
        const filterPharmacymedicine =
          data.data.data.medication.medication_batches.filter(
            (med) =>
              med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
          );
        console.log("Filter Pharmacy Medicine:", filterPharmacymedicine);
        this.state.inputList.map((item, index) => {
          if (item.batch_no === value) {
            item.medicinBatchesdata = filterPharmacymedicine || [];
            item.other_brands = data.data.data.same_generic_medications || [];
          }
        });

        const MEdicineDetails =
          data.data.data.medication.medication_batches.find(
            (item) => item.batch_no === value,
          );
        if (MEdicineDetails) {
          MEdicineDetails.not_fifo = true;
        }
        console.log("MEdicineDetails", MEdicineDetails);

        if (data.data.success) {
          const medicineOption = {
            value: data.data.data.medication.id,
            label:
              data.data.data.medication.title +
              " (" +
              data.data.data.medication.item_code +
              ")" +
              (data.data.data.medication.barcode != null
                ? " - " + data.data.data.medication.barcode
                : ""),
          };
          console.log("medicineOption", medicineOption);
          const newData = await searchMedicationById(obj, medicineOption.value);
          const setMedicinDetails = this.state.inputList.map((item) => {
            if (item.batch_no === value) {
              return {
                ...item,
                description: medicineOption,
                batch_no: value,
                unitprice: data.data.data.medication.price || "",
                unit_price: data.data.data.medication.price || "",
                item_code: data.data.data.medication.item_code || "",
                total_quantity: data.data.data.medication.total_quantity || "",
                selling_price: data.data.data.medication.price || "",
                qty: 0,
                subtotal:
                  (data.data.data.medication.price || 0) *
                  (item.quantity || 1).toFixed(2),
                location:
                  data.data.data.medication.xcoord &&
                  data.data.data.medication.ycoord
                    ? `${data.data.data.medication.ycoord}${data.data.data.medication.xcoord}`
                    : "",
                batches: {
                  batch_no: MEdicineDetails ? MEdicineDetails.batch_no : "",
                  expiry_date: MEdicineDetails
                    ? MEdicineDetails.expiry_date
                    : "",
                  quantity: 1,
                },
                pharmacyLevelQuantity: getPharmacyLevelQuantity
                  ? getPharmacyLevelQuantity.quantity
                  : 0,
                storeLevelQuantity: getStoreLevelQuantity
                  ? getStoreLevelQuantity.quantity
                  : 0,
                generic_name: data.data.data.medication.generic_name || "",
                reOrderLevel: newData && newData.data.data.reorder_level,
                consumtionLevel: newData && newData.data.data.daily_consumption,
              };
            }
            return item;
          });

          this.setState(
            {
              inputList: setMedicinDetails,
            },
            () => {
              // Focus selling price input after state update if this was triggered by barcode scan
              if (scannedIndex !== null) {
                setTimeout(() => {
                  console.log(
                    "Focusing selling price input at index:",
                    scannedIndex,
                  );
                  this.focusSellingPriceInput(scannedIndex, 0);
                }, 300);
              }
            },
          );
        }
      } catch (error) {
        if (error && error.response && error.response.status === 404) {
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnText="OK"
                confirmBtnBsStyle="danger"
              >
                <h4>No medicine found for this batch number.</h4>
              </SweetAlert>
            ),
          });
          return;
        }
        console.error("Error getting batch number:", error);
      }
    }
  };
  BatchNoOnchange(event, index) {
    let value = "";
    value = event.target.value;
    this.state.inputList[index]["batch_no"] = value;
    console.log("batch no", value);
    this.setState({
      batch_no: value,
    });
    this.handleBatchNumber(value, index);
  }

  focusSellingPriceInput = (index, batchIndex) => {
    try {
      console.log("focusSellingPriceInput called with index:", index);
      console.log(
        "sellingPriceInputRef.current:",
        this.sellingPriceInputRef.current,
      );

      let inputElement =
        this.qtyInputRef.current && this.qtyInputRef.current[index][batchIndex];
      console.log("Ref element at index:", index, "element:", inputElement);

      // If the element is a React component (FormControl), try to get the actual DOM input
      if (inputElement && inputElement.refs && inputElement.refs.input) {
        console.log("Found FormControl with refs.input");
        inputElement = inputElement.refs.input;
      } else if (inputElement && inputElement._reactInternalFiber) {
        // Try to access the actual DOM node from the React fiber
        const fiberNode = inputElement._reactInternalFiber;
        if (fiberNode && fiberNode.child) {
          let currentFiber = fiberNode.child;
          while (currentFiber) {
            if (
              currentFiber.elementType === "input" ||
              currentFiber.type === "input"
            ) {
              inputElement = currentFiber.stateNode;
              console.log("Found input through fiber traversal");
              break;
            }
            currentFiber = currentFiber.child;
          }
        }
      }

      if (inputElement) {
        console.log(
          "Final element type:",
          inputElement.tagName || "not a DOM element",
        );
        console.log("Has focus method:", typeof inputElement.focus);
      }

      if (inputElement && typeof inputElement.focus === "function") {
        console.log("Focusing selling price input");
        inputElement.focus();
      } else {
        console.log("Element is not valid or does not have focus method");
      }
    } catch (error) {
      console.error("Error focusing selling price input:", error);
    }
  };

  handlePartialOrderCheckboxChange = (index, event) => {
    const checked = event.target.checked;
    const updatedInputList = [...this.state.inputList];
    updatedInputList[index].isPartialOrderItem = checked;

    const findPartialItemsIncluded = updatedInputList.filter(
      (item) => !item.isPartialOrderItem,
    );

    this.setState(
      {
        inputList: updatedInputList,
        isPartialOrder: findPartialItemsIncluded.length > 0 ? true : false,
      },
      () => {
        this.getUnavailableCost();
      },
    );

    // this.setState({ inputList: updatedInputList });
    // this.getUnavailableCost();
  };

  handleRefillRequestChange = (index) => {
    const updatedInputList = [...this.state.inputList];
    updatedInputList[index].refillRequestText =
      "Please Submit the order to request refill";
    this.setState({
      inputList: updatedInputList,
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        >
          <div style={{ marginBottom: "8px" }}>
            <i
              className="fa fa-info-circle"
              style={{ fontSize: "42px", color: "#17a2b8" }}
            ></i>
          </div>
          <h4>Please Submit the order to request refill</h4>
        </SweetAlert>
      ),
    });
  };

  callRequestRefillAPI = async (item, index) => {
    if (!item) {
      console.warn("Refill request skipped: item not found");
      return;
    }

    const medicationId =
      (item.description && item.description.value) ||
      item.description ||
      item.medication_id ||
      item.id;

    if (!medicationId) {
      console.warn("Refill request skipped: medication id missing", item);
      return;
    }

    let refillQuantity = 0;
    if (item.pharmacyLevelQuantity < item.reOrderLevel) {
      refillQuantity =
        Number(item.reOrderLevel) -
        Number(item.pharmacyLevelQuantity) +
        Number(item.consumtionLevel);
    }

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const payload = {
      reference: "",
      request_date: new Date().toISOString(),
      status: 1,
      request_by: token.id,
      medications: [
        {
          id: medicationId,
          quantity: refillQuantity,
        },
      ],
      store_id: 10,
    };
    const createPurchaseRequests = await CreateNewPurchaseRequest(obj, payload);
    if (createPurchaseRequests.data.success) {
      const updatedInputList = [...this.state.inputList];
      updatedInputList[index].refillRequested = true;
      this.setState({
        inputList: updatedInputList,
        isHideRefillRequest: true,
        requestRefillLabel: "Refill Request Created",
      });
    }
  };

  handleQuantityChange = (idx, index, event) => {
    const value = Number(event.target.value);
    const updatedInputList = [...this.state.inputList];
    updatedInputList[index].medicinBatchesdata[idx].qty = value;
    updatedInputList[index].quantity = updatedInputList[
      index
    ].medicinBatchesdata.reduce((sum, batch) => sum + (batch.qty || 0), 0);
    updatedInputList[index].subtotal = (
      (updatedInputList[index].unitprice || 0) *
      (updatedInputList[index].quantity || 1)
    ).toFixed(2);

    updatedInputList[index].batches =
      updatedInputList[index].medicinBatchesdata[idx];
    const getBatches = updatedInputList[index].medicinBatchesdata.map(
      (batch) => {
        return {
          ...batch,

          batch_no: batch.batch_no,
          expiry_date: batch.expiry_date,
          quantity: batch.qty,
        };
      },
    );

    updatedInputList[index].batches = getBatches;
    this.setState({ inputList: updatedInputList });
    this.handlebasketandsubtotal();
  };
  // updatedInputList[index].subtotal = (
  checkIsExpiaryCloserMedicine(batch, allBatches) {
    if (!batch || !batch.expiry_date || !allBatches || !allBatches.length) {
      return false;
    }

    const currentExpiry = moment(batch.expiry_date);
    if (!currentExpiry.isValid()) {
      return false;
    }

    const checkIsNotFifo = allBatches.some((item) => {
      if (item === batch || !item || !item.expiry_date) {
        return false;
      }

      const otherExpiry = moment(item.expiry_date);
      if (!otherExpiry.isValid()) {
        return false;
      }

      return !currentExpiry.isBefore(otherExpiry);
    });

    console.log("checkIsNotFifo", checkIsNotFifo);
    return checkIsNotFifo;
  }

  toggleExpand = (id) => {
    this.setState((prevState) => ({
      expandedId: prevState.expandedId === id ? null : id,
    }));
  };

  handleSellingPriceChange = (index, event) => {
    const value = Number(event.target.value);
    const updatedInputList = [...this.state.inputList];
    updatedInputList[index].selling_price = value;
    updatedInputList[index].subtotal = (
      (value || 0) * (updatedInputList[index].quantity || 1)
    ).toFixed(2);
    this.setState({ inputList: updatedInputList });
    this.handlebasketandsubtotal();
  };

  getOtherBrandQuantity = (item) => {
    const getQuantity =
      item &&
      item.reduce((sum, medication) => sum + (medication.quantity || 0), 0);
    return getQuantity || 0;
  };

  getOtherBrandLocation = (item, stock) => {
    // want to show the location of the medicine where in the store_wise_medication.pharmacy.name want prioritise the flash health pharmacy location if not and available in flash warehouse then show the location of flash warehouse
    let location = "";
    if (item && item.length > 0) {
      const flashHealthPharmacy = item.find(
        (medication) =>
          medication.pharmacies && medication.pharmacies.name === stock,
      );
      console.log("Flash Health Pharmacy:", flashHealthPharmacy);
      // const flashWarehouse = item.find(
      //   (medication) =>
      //     medication.pharmacies &&
      //     medication.pharmacies.name === "Flash WareHouse",
      // );
      if (flashHealthPharmacy) {
        location = flashHealthPharmacy.quantity || "";
      }
      // else if (flashWarehouse) {
      //   location = flashWarehouse.pharmacies.name || "";
      // }
    }
    return location || "-";
  };

  render() {
    console.log("InputList", this.state.inputList);
    const { item, index, onRemove, onCheck, isChecked } = this.props;
    const { isExpanded, selectedBatch } = this.state;
    let defaultFlashRef =
      this.state.store !== 1 && this.state.store !== null
        ? "Delta Force Clinic"
        : "Whatsapp";
    const subscriber_detail = this.state.subscriber_detail;
    const country_detail = this.state.country_detail;
    const view = <Tooltip id="view">View</Tooltip>;
    const subscriptiondetail = this.state.subscriptiondetail;
    const medicationdata = this.state.medicationdata;
    const quanitydata = this.state.quanitydata;
    const sub_id = this.state.subscriber;
    const hc_id = this.state.healthcondition;
    const errormessages = this.state.errormessages;
    const medicationerrormessage = this.state.medicationerrormessage;
    const isSuperAdmin = this.state.tokenDetails.token.role === 1;

    return (
      <>
        <>
          {this.state.packagefeatures[0]
            ? (this.state.packagefeatures[0].raya != "" ||
                this.state.packagefeatures[0].mad != "" ||
                this.state.packagefeatures[0].express != "" ||
                (this.state.isFirstOrder && !this.state.sub_orderType)) && (
                <div className="package_feature">
                  {this.state.catalougepackagename && (
                    <div className="package_featurelist">
                      {this.state.logo_1 !== "" ? (
                        <img height="50px" src={this.state.logo_1} alt="logo" />
                      ) : (
                        <div style={{ height: "50px" }}>{null}</div>
                      )}
                      <h5 style={{ fontSize: "14px", width: "190px" }}>
                        Package Name:
                      </h5>
                      <p
                        style={{
                          fontSize: "14px",
                          textTransform: "uppercase",
                          fontWeight: "bold",
                        }}
                      >
                        {this.state.catalougepackagename}
                      </p>
                    </div>
                  )}
                  {this.state.packagefeatures[0].raya != "" && (
                    <div
                      className="package_featurelist"
                      style={{ margin: "0px" }}
                    >
                      <h5>Raya:</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          textTransform: "uppercase",
                          fontWeight: "bold",
                        }}
                      >
                        {this.state.packagefeatures[0].raya}%
                      </p>
                    </div>
                  )}
                  {this.state.packagefeatures[0].mad != "" && (
                    <div className="package_featurelist">
                      <h5 style={{ fontSize: "14px" }}>Medicine:</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          textTransform: "uppercase",
                          fontWeight: "bold",
                        }}
                      >
                        {this.state.packagefeatures[0].mad}%
                      </p>
                    </div>
                  )}
                  {this.state.packagefeatures[0].express.length != 0 &&
                    this.state.packagefeatures[0].express[3].t_count != 0 && (
                      <div className="package_featurelist">
                        <h5 style={{ fontSize: "12px" }}>N.O.Free Delivery:</h5>
                        {this.state.packagefeatures[0].express.length != 0 &&
                          Number(
                            this.state.packagefeatures[0].express[0].free,
                          ) !== 0 && (
                            <>
                              <h5 style={{ fontSize: "12px" }}>Standard:</h5>
                              <p
                                style={{
                                  fontSize: "14px",
                                  textTransform: "uppercase",
                                  fontWeight: "bold",
                                }}
                              >
                                {this.state.packagefeatures[0].express[0].free}
                              </p>
                            </>
                          )}
                        {this.state.packagefeatures[0].express.length != 0 &&
                          Number(
                            this.state.packagefeatures[0].express[1].free,
                          ) !== 0 && (
                            <>
                              <h5 style={{ fontSize: "12px" }}>Express:</h5>
                              <p
                                style={{
                                  fontSize: "14px",
                                  textTransform: "uppercase",
                                  fontWeight: "bold",
                                }}
                              >
                                {this.state.packagefeatures[0].express[1].free}
                              </p>
                            </>
                          )}
                        {this.state.packagefeatures[0].express.length != 0 &&
                          Number(
                            this.state.packagefeatures[0].express[2].free,
                          ) !== 0 && (
                            <>
                              <h5 style={{ fontSize: "12px" }}>Island Wide:</h5>
                              <p
                                style={{
                                  fontSize: "14px",
                                  textTransform: "uppercase",
                                  fontWeight: "bold",
                                }}
                              >
                                {this.state.packagefeatures[0].express[2].free}
                              </p>
                            </>
                          )}
                      </div>
                    )}
                  {this.state.packagefeatures[0].express.length != 0 &&
                    this.state.packagefeatures[0].express[3].t_count == 0 && (
                      <>
                        <div className="package_featurelist">
                          <h5 style={{ fontSize: "12px" }}>
                            Delivery Discounts:
                          </h5>
                          {this.state.packagefeatures[0].express.length != 0 &&
                            Number(
                              this.state.packagefeatures[0].express[0].discount,
                            ) !== 0 && (
                              <>
                                <h5 style={{ fontSize: "12px" }}>Standard:</h5>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {
                                    this.state.packagefeatures[0].express[0]
                                      .discount
                                  }
                                  %
                                </p>
                              </>
                            )}
                          {this.state.packagefeatures[0].express.length != 0 &&
                            Number(
                              this.state.packagefeatures[0].express[1].discount,
                            ) !== 0 && (
                              <>
                                <h5 style={{ fontSize: "12px" }}>Express:</h5>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {
                                    this.state.packagefeatures[0].express[1]
                                      .discount
                                  }
                                  %
                                </p>
                              </>
                            )}
                          {this.state.packagefeatures[0].express.length != 0 &&
                            Number(
                              this.state.packagefeatures[0].express[2].discount,
                            ) !== 0 && (
                              <>
                                <h5 style={{ fontSize: "12px" }}>
                                  Island Wide:
                                </h5>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {
                                    this.state.packagefeatures[0].express[2]
                                      .discount
                                  }
                                  %
                                </p>
                              </>
                            )}
                        </div>
                        <div className="package_featurelist">
                          <h5 style={{ fontSize: "12px" }}>
                            Delivery Base price:
                          </h5>
                          {this.state.packagefeatures[0].express.length != 0 &&
                            Number(
                              this.state.packagefeatures[0].express[0]
                                .base_price,
                            ) !== 0 && (
                              <>
                                <h5 style={{ fontSize: "12px" }}>Standard:</h5>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {Number(
                                    this.state.packagefeatures[0].express[0]
                                      .base_price,
                                  ).toFixed(2)}
                                </p>
                              </>
                            )}
                          {this.state.packagefeatures[0].express.length != 0 &&
                            Number(
                              this.state.packagefeatures[0].express[1]
                                .base_price,
                            ) !== 0 && (
                              <>
                                <h5 style={{ fontSize: "12px" }}>Express:</h5>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {Number(
                                    this.state.packagefeatures[0].express[1]
                                      .base_price,
                                  ).toFixed(2)}
                                </p>
                              </>
                            )}
                          {this.state.packagefeatures[0].express.length != 0 &&
                            Number(
                              this.state.packagefeatures[0].express[2]
                                .base_price,
                            ) !== 0 && (
                              <>
                                <h5 style={{ fontSize: "12px" }}>
                                  Island Wide:
                                </h5>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {Number(
                                    this.state.packagefeatures[0].express[2]
                                      .base_price,
                                  ).toFixed(2)}
                                </p>
                              </>
                            )}
                        </div>
                      </>
                    )}
                  {this.state.packagefeatures[0].express.length == 0 && (
                    <div className="package_featurelist">
                      <h5 style={{ fontSize: "14px" }}>
                        Package Discount Eligibility
                      </h5>
                    </div>
                  )}
                  {this.state.isFirstOrder && !this.state.sub_orderType && (
                    <div
                      className="package_featurelist"
                      style={{ marginLeft: "auto" }}
                    >
                      <h5
                        className="btn btn-fill claimButton"
                        style={{
                          fontSize: "16px",
                          textTransform: "uppercase",
                          fontWeight: "bold",
                          marginRight: "25px",
                          border: "unset",
                          outline: "none",
                          boxShadow: "none",
                        }}
                      >
                        🎈 Add Balloon & Bookmark
                      </h5>
                    </div>
                  )}
                </div>
              )
            : ""}
        </>
        <div className="main-content addorder-page">
          {this.state.contentLoading ? <LoadingOrder /> : ""}
          <Grid fluid>
            {this.state.alert}
            <NotificationSystem ref="notificationSystem" style={style} />
            <Card
              content={
                <Row>
                  {/*this.state.ispaywarning && (
                  <div className="paywarning_message_display">
                    This Order Value is more than Rs.5000. Please contact and
                    ask them to pay on card
                  </div>
                )*/}

                  <Col sm={8} className="orderFormdata-container">
                    <input
                      style={{ width: "0px", height: "0px", border: "none" }}
                      type="text"
                      ref={this.message_error}
                    />
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <div
                      className="order_topdata_container"
                      style={{
                        marginBottom: "40px",
                        padding: "20px",
                      }}
                    >
                      <Row>
                        <Col md={12}>
                          <h3
                            style={{
                              margin: "0",
                              letterSpacing: "0.5px",
                              fontSize: "24px",
                            }}
                          >
                            Order Details
                          </h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <br></br>
                            <ControlLabel style={{ display: "block" }}>
                              Order Type
                            </ControlLabel>
                            <div
                              className="OrderType_switch"
                              style={{ marginTop: 16, marginBottom: 16 }}
                            >
                              <Switch
                                checked={this.state.sub_orderType}
                                onChange={(e) => {
                                  this.setState({
                                    sub_orderType: !this.state.sub_orderType,
                                  });
                                  if (e) {
                                    this.setState({
                                      deliverytype: {
                                        value: "1",
                                        label: "Normal",
                                      },
                                      source: { value: "1", label: "Flash" },
                                      paymentoption: {
                                        value: "Cheque",
                                        label: "Cheque",
                                      },
                                    });
                                  } else {
                                    this.setState({
                                      deliverytype: "",
                                      source: "",
                                      paymentoption: "",
                                    });
                                  }
                                  if (this.state.subscriber != 0) {
                                    setTimeout(
                                      this.handlebasketandsubtotal,
                                      this.handleb2bdetails(),
                                      500,
                                    );
                                  }
                                }}
                                onColor="#6c757d"
                                offColor="#007bff"
                                onHandleColor="#007bff"
                                offHandleColor="#6c757d"
                                height={32}
                                width={70}
                                uncheckedIcon={
                                  <div
                                    style={{
                                      padding: "7px 6px",
                                      color: "white",
                                      fontWeight: "600",
                                    }}
                                  >
                                    B2C
                                  </div>
                                }
                                checkedIcon={
                                  <div
                                    style={{
                                      padding: "7px 10px",
                                      color: "white",
                                      fontWeight: "600",
                                    }}
                                  >
                                    B2B
                                  </div>
                                }
                                className="react-switch"
                                id="small-radius-switch"
                              />
                            </div>
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Subscriber</ControlLabel>
                            {this.props.match.params.id !== undefined ? (
                              <FormControl
                                value={this.state.selectedSubscriberName}
                                readOnly
                                type="text"
                              />
                            ) : (
                              <div
                                onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                                className="Appy2"
                                style={{ textTransform: "capitalize" }}
                              >
                                <Select
                                  style={{ textTransform: "capitalize" }}
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="subscriber"
                                  onChange={(value) =>
                                    this.onSubscriberChange(value)
                                  }
                                  options={this.state.subscriberItems}
                                  placeholder="Subscriber"
                                  noOptionsMessage={() =>
                                    "Type Name or Phone Number"
                                  }
                                />
                              </div>
                            )}
                            {this.state.subscriberError}
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Prescription</ControlLabel>
                            <br></br>
                            <input
                              style={{ display: "none" }}
                              id="selectImage"
                              type="file"
                              className="form-control"
                              name="prescription"
                              multiple
                              onChange={(e) =>
                                this.handlePrescriptionFileChange(e)
                              }
                            />
                            <Button
                              onClick={this.upload}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  this.state.selectedFile.length == 0
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {this.state.selectedFile.length == 0
                                ? "Choose File"
                                : "Change File"}
                              {this.state.selectedFile.length > 0 && (
                                <i
                                  className="fa fa-check"
                                  style={{
                                    color: "green",
                                    marginLeft: 5,
                                    fontSize: "16px",
                                  }}
                                  aria-hidden="true"
                                ></i>
                              )}
                            </Button>
                          </FormGroup>
                        </Col>

                        <Col
                          md="6"
                          className="addorder-source-reference"
                          style={{ width: "45%" }}
                        >
                          <FormGroup
                            className="fl_datepicker"
                            style={{ padding: "10px 0" }}
                          >
                            <br></br>
                            <div
                              style={{ position: "relative", bottom: "5px" }}
                            >
                              <ControlLabel
                                style={{
                                  marginTop: "1px",
                                  borderTop: "5px",
                                }}
                              >
                                {" "}
                                Order Date
                              </ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{ placeholder: "Order Date" }}
                                defaultValue={new Date()}
                                closeOnSelect={true}
                                value={this.state.orderdate}
                                onChange={this.handleDateChange}
                              />
                            </div>
                          </FormGroup>

                          {(this.state.store == 1 ||
                            this.state.store == null) && (
                            <FormGroup style={{ marginTop: "-17px" }}>
                              <ControlLabel>Sales Rep </ControlLabel>
                              <select
                                name="sales_rep"
                                value={this.state.sales_rep}
                                onChange={this.onChange}
                                className="form-control"
                              >
                                <option value="0">Select Sales Rep</option>
                                {this.state.sales_rep_data.map((sales_data) => (
                                  <option value={sales_data.value}>
                                    {sales_data.label}
                                  </option>
                                ))}
                              </select>
                            </FormGroup>
                          )}
                        </Col>
                      </Row>

                      {(this.state.store == 1 ||
                        this.state.store == 15 ||
                        this.state.store == null) && (
                        <Row>
                          <Col md="6" className="addorder-source-select">
                            <FormGroup style={{ padding: "10px 0" }}>
                              <ControlLabel>Source </ControlLabel>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="source"
                                value={this.state.source}
                                onChange={(value) => {
                                  if (value.value == "2") {
                                    this.setState({
                                      mypharmareferance: "",
                                      source: value,
                                    });
                                  } else if (value.value == "3") {
                                    this.setState({
                                      opharmareferance: "",
                                      source: value,
                                    });
                                  } else if (value.value == "4") {
                                    this.setState({
                                      mypharmareferance: "",
                                      opharmareferance: "",
                                      source: value,
                                    });
                                  } else {
                                    this.setState({ source: value });
                                  }
                                }}
                                placeholder="Select Source"
                                options={[
                                  { value: "1", label: "Flash" },
                                  { value: "2", label: "oPharma" },
                                  { value: "3", label: "MyPharma" },
                                  { value: "4", label: "Daraz" },
                                  { value: "5", label: "Pickme" },
                                  { value: "6", label: "E-channeling" },
                                  { value: "7", label: "Uber" },
                                  { value: "8", label: "Heart 2 Heart" },
                                  { value: "9", label: "Vida" },
                                  { value: "10", label: "PetDoc" },
                                  { value: "11", label: "LankaRemit" },
                                  { value: "13", label: "LiweCommunities" },
                                  { value: "15", label: "Delta" },
                                ]}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="6" style={{ width: "45%" }}>
                            {this.state.source.value == 3 ? (
                              <FormGroup>
                                <ControlLabel>MyPharma Referance</ControlLabel>
                                <FormControl
                                  name="mypharmareferance"
                                  value={this.state.mypharmareferance}
                                  onChange={(event) => {
                                    this.setState({
                                      mypharmareferance: event.target.value,
                                    });
                                  }}
                                  placeholder="Enter MyPharma Referance"
                                  type="text"
                                />
                                {this.state.mypharmareferanceError}
                              </FormGroup>
                            ) : (
                              ""
                            )}

                            {this.state.source.value == 2 ? (
                              <FormGroup>
                                <ControlLabel className="opharma">
                                  oPharma Referance
                                </ControlLabel>
                                <FormControl
                                  style={{ margin: "0" }}
                                  name="opharmareferance"
                                  value={this.state.opharmareferance}
                                  onChange={(event) => {
                                    this.setState({
                                      opharmareferance: event.target.value,
                                    });
                                    // event.target.value === ""
                                    //   ? this.setState({
                                    //       opharmareferanceError: (
                                    //         <small className="text-danger">
                                    //           OPharma Referance is required.
                                    //         </small>
                                    //       )
                                    //     })
                                    //   : this.setState({ opharmareferanceError: null });
                                  }}
                                  placeholder="Enter oPharma Referance"
                                  type="text"
                                />
                                {this.state.opharmareferanceError}
                              </FormGroup>
                            ) : this.state.source.value == 1 ||
                              this.state.source.value == 15 ? (
                              <>
                                <FormGroup style={{ marginTop: "10px" }}>
                                  <ControlLabel>Flash Reference</ControlLabel>
                                  <select
                                    value={
                                      this.state.flashreference ||
                                      defaultFlashRef
                                    }
                                    className="form-control"
                                    onChange={(event) => {
                                      this.setState({
                                        flashreference: event.target.value,
                                      });
                                    }}
                                  >
                                    <option value="Watsapp">Whatsapp</option>
                                    <option value="Google">Google</option>
                                    <option value="Flash Hotline">
                                      Flash Hotline
                                    </option>
                                    <option value="NCD">NCD</option>
                                    <option value="Delta Force Clinic">
                                      Delta Force Clinic
                                    </option>
                                  </select>
                                </FormGroup>
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      )}

                      {this.state.sub_orderType == true && (
                        <Row>
                          <Col md="4">
                            <FormGroup>
                              <ControlLabel>PO Number</ControlLabel>
                              <FormControl
                                style={{ margin: "0" }}
                                name="po_number"
                                value={this.state.po_number}
                                onChange={this.onChange}
                                placeholder="Enter PO Number"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="document_upload_container">
                              <ControlLabel>PO Document</ControlLabel>
                              <div className="docUrl_listview">
                                {this.state.PNdocUrl.length > 0 ? (
                                  <>
                                    {this.state.PNdocUrl.map((pre, key) => (
                                      <div className="document_adddelete">
                                        <Button
                                          style={{
                                            marginRight: "3px",
                                            marginBottom: "10px",
                                            padding: 0,
                                          }}
                                        >
                                          <a
                                            className="orderdoc_nav_link"
                                            key={key}
                                            style={{
                                              fontSize: "25px",
                                              display: "inline-block",
                                              color: "black",
                                            }}
                                            href={pre}
                                            target="_blank"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                            }}
                                          >
                                            {" "}
                                            PO {key + 1}{" "}
                                          </a>
                                        </Button>
                                        <p
                                          className="delete_addeddoc delete_gen_doc"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.poFinaldeleteDoc(key);
                                          }}
                                        >
                                          x
                                        </p>
                                      </div>
                                    ))}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                              <input
                                style={{ display: "none" }}
                                id="select_podoc"
                                type="file"
                                className="form-control"
                                name="po_document"
                                multiple
                                onChange={this.handlePOFileChange}
                              />
                              <Button
                                onClick={this.uploadPODoc}
                                style={{ color: "#2B3A41" }}
                              >
                                {" "}
                                <i
                                  className={
                                    this.state.po_document == ""
                                      ? "fa fa-plus"
                                      : "fa fa-pencil fa-fw"
                                  }
                                ></i>{" "}
                                {this.state.po_document == ""
                                  ? "Choose File"
                                  : "Change File"}
                              </Button>
                              {this.state.po_document.length > 0 && (
                                <Button
                                  onClick={this.uploadPOFinal}
                                  style={{
                                    color: "#2B3A41",
                                    marginLeft: "10px",
                                  }}
                                >
                                  Upload
                                </Button>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="document_upload_container">
                              <ControlLabel>GRN Document</ControlLabel>
                              <div className="docUrl_listview">
                                {this.state.GRNDocUrl.length > 0 ? (
                                  <>
                                    {this.state.GRNDocUrl.map((pre, key) => (
                                      <div className="document_adddelete">
                                        <Button
                                          style={{
                                            marginRight: "3px",
                                            marginBottom: "10px",
                                            padding: 0,
                                          }}
                                        >
                                          <a
                                            className="orderdoc_nav_link"
                                            key={key}
                                            style={{
                                              fontSize: "25px",
                                              display: "inline-block",
                                              color: "black",
                                            }}
                                            href={pre}
                                            target="_blank"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                            }}
                                          >
                                            GRN {key + 1}{" "}
                                          </a>
                                        </Button>
                                        <p
                                          className="delete_addeddoc delete_gen_doc"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.grnFinaldeleteDoc(key);
                                          }}
                                        >
                                          x
                                        </p>
                                      </div>
                                    ))}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                              <input
                                style={{ display: "none" }}
                                id="select_grndoc"
                                type="file"
                                className="form-control"
                                name="grn_document"
                                multiple
                                onChange={this.handleGRNFileChange}
                              />
                              <Button
                                onClick={this.uploadGRNDoc}
                                style={{ color: "#2B3A41" }}
                              >
                                {" "}
                                <i
                                  className={
                                    this.state.grn_document == ""
                                      ? "fa fa-plus"
                                      : "fa fa-pencil fa-fw"
                                  }
                                ></i>{" "}
                                {this.state.grn_document == ""
                                  ? "Choose File"
                                  : "Change File"}
                              </Button>
                              {this.state.grn_document.length > 0 && (
                                <Button
                                  onClick={this.uploadGRNFinal}
                                  style={{
                                    color: "#2B3A41",
                                    marginLeft: "10px",
                                  }}
                                >
                                  Upload
                                </Button>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      )}
                      <Row className="submit_button_row_mobile">
                        <Col sm={12}>
                          <Button
                            disabled={
                              !this.state.processing ||
                              this.state.isWrongQuantity
                            }
                            onClick={this.onSubmit.bind(this)}
                            class="btn-color" //bsStyle="info"
                            fill
                          >
                            Submit
                          </Button>
                          <Button
                            disabled={
                              !this.state.processing ||
                              this.state.isWrongQuantity
                            }
                            onClick={this.onSendQuote.bind(this)}
                            class="btn-color" //bsStyle="info"
                            fill
                          >
                            Submit Quote
                          </Button>
                        </Col>
                      </Row>
                    </div>

                    {this.state.subscriber != 0 &&
                      (this.state.store == 1 || this.state.store == null) && (
                        <div
                          className="order_address_container"
                          style={{
                            padding: "0 20px",
                          }}
                        >
                          <Row>
                            <Col md={6}>
                              <h3
                                style={{
                                  margin: "0",
                                  letterSpacing: "0.5px",
                                  fontSize: "24px",
                                }}
                              >
                                Delivery Address
                              </h3>
                            </Col>
                            <Col md={6} style={{ textAlign: "right" }}>
                              <Button
                                fill
                                // onClick={this.addanother.bind(this)}
                                onClick={() =>
                                  this.setState({
                                    isCreateAddressModalOpen: true,
                                    addressModalType: "delivery",
                                  })
                                }
                                style={{ marginBottom: "17px" }}
                              >
                                Add Another Address
                                <i className="fa fa-plus"></i>
                              </Button>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={12}>
                              {(!this.state.address_id ||
                                Number(this.state.address_id) === 0) &&
                                this.state.addressline1Error && (
                                  <small className="text-danger">
                                    Delivery Address is required.
                                  </small>
                                )}

                              {this.state.addressdata.length > 0 && (
                                <div
                                  style={{
                                    padding: "20px 0",
                                  }}
                                >
                                  {this.state.addressdata.map(
                                    (add, indexk) =>
                                      add.is_active === 1 &&
                                      this.state.first_address == add.id && (
                                        <p>
                                          {" "}
                                          <div
                                            style={{
                                              borderColor: "#D3D3D3",
                                            }}
                                          >
                                            <input
                                              name="addressradio"
                                              value={add.id}
                                              checked={
                                                this.state.address_id == add.id
                                              }
                                              onChange={this.addrssselect.bind(
                                                this,
                                                add.id,
                                                add.country_id,
                                                "delivery",
                                              )}
                                              type="radio"
                                            ></input>{" "}
                                            {add.address_line1},
                                            {add.address_line2} ,
                                            {this.state.city_info.map(
                                              (city) => (
                                                <React.Fragment>
                                                  {city.id == add.city
                                                    ? city.city_name
                                                    : ""}
                                                </React.Fragment>
                                              ),
                                            )}{" "}
                                            ,
                                            {country_detail.map(
                                              (country_data) => (
                                                <React.Fragment>
                                                  {country_data.id ==
                                                  add.country_id
                                                    ? country_data.country_name +
                                                      ","
                                                    : ""}{" "}
                                                </React.Fragment>
                                              ),
                                            )}
                                            {add.postal_code}
                                            {this.state.address_id ==
                                              add.id && (
                                              <i
                                                style={{
                                                  color: "green",
                                                  fontSize: "20px",
                                                }}
                                                className="fa fa-check"
                                              ></i>
                                            )}
                                          </div>{" "}
                                        </p>
                                      ),
                                  )}

                                  {this.state.addressdata.length > 1 && (
                                    <div className="collapeable_addresses_list">
                                      <Collapsible
                                        trigger="View Other Addresses"
                                        transitionTime={200}
                                        onClosing={() => {
                                          this.setState({
                                            first_address:
                                              this.state.address_id,
                                          });
                                        }}
                                      >
                                        {this.state.addressdata.map(
                                          (add, indexk) =>
                                            add.is_active === 1 &&
                                            this.state.first_address !=
                                              add.id && (
                                              <p>
                                                {" "}
                                                <div
                                                  style={{
                                                    borderColor: "#D3D3D3",
                                                  }}
                                                >
                                                  <input
                                                    name="addressradio"
                                                    value={add.id}
                                                    checked={
                                                      this.state.address_id ==
                                                      add.id
                                                    }
                                                    onChange={this.addrssselect.bind(
                                                      this,
                                                      add.id,
                                                      add.country_id,
                                                      "delivery",
                                                    )}
                                                    type="radio"
                                                  />
                                                  {add.address_line1},
                                                  {add.address_line2} ,
                                                  {this.state.city_info.map(
                                                    (city) => (
                                                      <React.Fragment>
                                                        {city.id == add.city
                                                          ? city.city_name
                                                          : ""}
                                                      </React.Fragment>
                                                    ),
                                                  )}{" "}
                                                  ,
                                                  {country_detail.map(
                                                    (country_data) => (
                                                      <React.Fragment>
                                                        {country_data.id ==
                                                        add.country_id
                                                          ? country_data.country_name +
                                                            ","
                                                          : ""}{" "}
                                                      </React.Fragment>
                                                    ),
                                                  )}
                                                  {add.postal_code}
                                                  {this.state.address_id ==
                                                    add.id && (
                                                    <i
                                                      style={{
                                                        color: "green",
                                                        fontSize: "20px",
                                                      }}
                                                      className="fa fa-check"
                                                    ></i>
                                                  )}
                                                </div>{" "}
                                              </p>
                                            ),
                                        )}
                                      </Collapsible>
                                    </div>
                                  )}
                                </div>
                              )}
                            </Col>
                          </Row>
                        </div>
                      )}
                    {this.state.subscriber != 0 && this.state.sub_orderType ? (
                      <div
                        className="order_address_container"
                        style={{
                          padding: "0 20px",
                        }}
                      >
                        <Row>
                          <Col md={6}>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Billing Address
                            </h3>
                          </Col>
                          <Col md={6} style={{ textAlign: "right" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "12px",
                                flexWrap: "nowrap",
                              }}
                            >
                              <div
                                style={{
                                  marginBottom: 0,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <Checkbox
                                  number="57"
                                  checked={
                                    this.state.first_address ===
                                    this.state.first_billing_address
                                  }
                                  onClick={this.handleBillingSameToggle}
                                  label={
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        marginTop: "-1.5px",
                                      }}
                                    >
                                      &nbsp;&nbsp;Same as delivery address
                                    </p>
                                  }
                                />
                              </div>
                              <Button
                                style={{
                                  marginBottom: "17px",
                                  whiteSpace: "nowrap",
                                }}
                                fill
                                // onClick={this.addanother.bind(this)}
                                onClick={() =>
                                  this.setState({
                                    isCreateAddressModalOpen: true,
                                    addressModalType: "billing",
                                  })
                                }
                              >
                                Add Another Address
                                <i className="fa fa-plus"></i>
                              </Button>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            {this.state.addressline1Error && (
                              <small className="text-danger">
                                {this.state.addressline1Error}
                              </small>
                            )}

                            {this.state.addressdata.length > 0 ? (
                              <div
                                style={{
                                  padding: "20px 0",
                                }}
                              >
                                {this.state.addressdata.map((add, key) =>
                                  this.state.first_billing_address == add.id ? (
                                    <p key={key}>
                                      {" "}
                                      <div
                                        style={{
                                          borderColor: "#D3D3D3",
                                        }}
                                      >
                                        <input
                                          name="billingAddressRadio"
                                          value={add.id}
                                          checked={
                                            this.state.billing_address_id ==
                                            add.id
                                          }
                                          onChange={this.addrssselect.bind(
                                            this,
                                            add.id,
                                            add.country_id,
                                            "billing",
                                          )}
                                          type="radio"
                                        />{" "}
                                        &nbsp;
                                        {add.address_line1},{add.address_line2}{" "}
                                        ,
                                        {this.state.city_info.map((city) => (
                                          <React.Fragment>
                                            {city.id == add.city
                                              ? city.city_name
                                              : ""}{" "}
                                          </React.Fragment>
                                        ))}{" "}
                                        ,
                                        {country_detail.map((country_data) => (
                                          <React.Fragment>
                                            {country_data.id == add.country_id
                                              ? country_data.country_name + ","
                                              : ""}{" "}
                                          </React.Fragment>
                                        ))}
                                        {add.postal_code}
                                        {this.state.billing_address_id ==
                                          add.id && (
                                          <i
                                            style={{
                                              color: "green",
                                              fontSize: "20px",
                                            }}
                                            className="fa fa-check"
                                          ></i>
                                        )}
                                      </div>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  ),
                                )}

                                {this.state.addressdata.length > 1 && (
                                  <div className="collapeable_addresses_list">
                                    <Collapsible
                                      trigger="View Other Addresses"
                                      transitionTime={200}
                                      onClosing={() => {
                                        this.setState({
                                          first_billing_address:
                                            this.state.billing_address_id,
                                        });
                                      }}
                                    >
                                      {this.state.addressdata.map((add, key) =>
                                        this.state.first_billing_address !=
                                        add.id ? (
                                          <p key={key}>
                                            {" "}
                                            <div
                                              style={{
                                                borderColor: "#D3D3D3",
                                              }}
                                            >
                                              <input
                                                name="billingAddressRadio"
                                                value={add.id}
                                                checked={
                                                  this.state
                                                    .billing_address_id ==
                                                  add.id
                                                }
                                                onChange={this.addrssselect.bind(
                                                  this,
                                                  add.id,
                                                  add.country_id,
                                                  "billing",
                                                )}
                                                type="radio"
                                              ></input>{" "}
                                              {add.address_line1},
                                              {add.address_line2} ,
                                              {this.state.city_info.map(
                                                (city) => (
                                                  <React.Fragment>
                                                    {city.id == add.city
                                                      ? city.city_name
                                                      : ""}
                                                  </React.Fragment>
                                                ),
                                              )}{" "}
                                              ,
                                              {country_detail.map(
                                                (country_data) => (
                                                  <React.Fragment>
                                                    {country_data.id ==
                                                    add.country_id
                                                      ? country_data.country_name +
                                                        ","
                                                      : ""}{" "}
                                                  </React.Fragment>
                                                ),
                                              )}
                                              {add.postal_code}
                                              {this.state.billing_address_id ==
                                              add.id ? (
                                                <i
                                                  style={{
                                                    color: "green",
                                                    fontSize: "20px",
                                                  }}
                                                  className="fa fa-check"
                                                ></i>
                                              ) : (
                                                ""
                                              )}
                                            </div>{" "}
                                          </p>
                                        ) : (
                                          ""
                                        ),
                                      )}
                                    </Collapsible>
                                  </div>
                                )}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.getSource === 15 ||
                    (this.state.subscriber !== 0 &&
                      (this.state.address_id !== 0 ||
                        this.state.city_id !== 0)) ? (
                      <div
                        className="order_medicine_container"
                        style={{
                          padding: "0 20px",
                        }}
                      >
                        {/* {(this.state.store == 1 ||
                          this.state.store === null) && ( */}
                        <div
                          style={{
                            flex: "1",
                            textAlign: "end",
                            marginBottom: "-78px",
                          }}
                        >
                          <Button
                            onClick={this.opendiscountmodal.bind(this)}
                            style={{ color: "#2B3A41", marginTop: "30px" }}
                          >
                            {" "}
                            <i className="fa fa-plus"></i> Add Discount{" "}
                          </Button>
                        </div>
                        {/* )} */}
                        <div
                          className="order_items_header"
                          style={{ paddingBottom: "20px" }}
                        >
                          <div>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Order Item
                            </h3>
                          </div>
                          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                          {/* {(this.state.store === 1 ||
                            this.state.store === null) && ( */}
                          <div>
                            <FormGroup
                              style={{
                                flex: "3",
                                textAlign: "end",
                                marginTop: "35px",
                                display: "flex",
                              }}
                            >
                              <Checkbox
                                number="47"
                                checked={this.state.isPartialOrder}
                                onClick={(e) =>
                                  this.handlePartialOrderOnChange(e)
                                }
                                label={
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      marginTop: "-1.5px",
                                    }}
                                  >
                                    &nbsp;&nbsp;Is Pending Item?
                                  </p>
                                }
                              ></Checkbox>{" "}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <div>
                                <Checkbox
                                  number="50"
                                  checked={this.state.isAbusableOrder}
                                  onClick={(e) =>
                                    this.handleAbusableOrderOnChange(e)
                                  }
                                  label={
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        marginTop: "-1.5px",
                                      }}
                                    >
                                      &nbsp;&nbsp;Abusable Drug
                                    </p>
                                  }
                                ></Checkbox>
                              </div>
                              &nbsp;&nbsp;
                            </FormGroup>
                          </div>
                          {/* )} */}
                          {this.state.isPackageHasClaimMedicineAllowed && (
                            // isSuperAdmin &&
                            <div>
                              <FormGroup
                                style={{
                                  flex: "3",
                                  textAlign: "end",
                                  marginTop: "35px",
                                  display: "flex",
                                }}
                              >
                                <Checkbox
                                  number="48"
                                  checked={this.state.isClaimableOrder}
                                  onClick={(e) =>
                                    this.handleMarkedAsClaimOrderOnChange(e)
                                  }
                                  label={
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        marginTop: "-1.5px",
                                      }}
                                    >
                                      &nbsp;&nbsp;Claim order
                                    </p>
                                  }
                                  disabled={
                                    this.state.selectedFile.length === 0
                                      ? true
                                      : false
                                  }
                                ></Checkbox>
                              </FormGroup>
                            </div>
                          )}
                        </div>
                        {this.state.inputList.map((item, index) => (
                          <div
                            className={`order-item-card ${item.isSelected ? "checked" : ""}`}
                          >
                            {/* Header Section */}
                            <div className="order-item-header-order">
                              <div className="header-left-order">
                                <input
                                  type="checkbox"
                                  checked={item.isSelected || false}
                                  value={item.id}
                                  onChange={(e) =>
                                    this.handleItemSelectionChange(e, item.id)
                                  }
                                  className="item-checkbox"
                                />
                                <span className="item-number">{index + 1}</span>
                                <span className="batch-number">
                                  {/* add input text field */}
                                  <ForwardedFormControl
                                    type="text"
                                    name="Batch No"
                                    placeholder="Batch No"
                                    style={{
                                      backgroundColor: "#ffffff",
                                      border: "1px solid #e3e3e3",
                                      borderRadius: "22px",
                                      color: "#565656",
                                      padding: " 8px 12px",
                                      height: "40px",
                                      boxShadow: "none",
                                      width: "100%",
                                    }}
                                    // onChange={(e) => this.BatchNoOnchange(e)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        this.BatchNoOnchange(e, index);
                                        this.toggleExpand(item.id);
                                      }
                                    }}
                                    ref={(ref) =>
                                      this.setBarcodeRef(ref, index)
                                    }
                                    // value={poItem.barcode}
                                  />
                                </span>
                                <span className="item-name-order">
                                  <AsyncSelect
                                    className="react-select primary"
                                    classNamePrefix="react-select"
                                    name="description"
                                    value={item.description || ""}
                                    onChange={(value) =>
                                      this.handleMedicineSelectChange(
                                        value,
                                        index,
                                      )
                                    }
                                    loadOptions={this.loadMedicationOptions}
                                    cacheOptions
                                    defaultOptions={false}
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        borderRadius: "22px",
                                      }),
                                    }}
                                    // ref={(ref) =>
                                    //   this.setInputRef(ref, i)
                                    // }
                                    placeholder="Medication"
                                    noOptionsMessage={() =>
                                      "Type Item Name or Code or Barcode"
                                    }
                                  />
                                </span>
                              </div>
                              <div className="header-right-order">
                                <div
                                  className="price-info"
                                  style={{ paddingLeft: "9px" }}
                                >
                                  <label>Unit Price</label>
                                  <span>{item.unit_price || "0.00"}</span>
                                </div>
                                <div className="price-info sale-price">
                                  {/* <label>Sale Price</label> */}
                                  {/* <label>Selling Price</label> */}
                                  <span>
                                    <FormControl
                                      // className="no-padding"
                                      name="unitprice"
                                      style={{
                                        borderRadius: "22px",
                                        padding: "8px !important",
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      value={item.unitprice}
                                      onChange={(e) =>
                                        this.handleInputChange(
                                          e,
                                          index,
                                          "unitprice",
                                        )
                                      }
                                      placeholder="0.00"
                                      type="number"
                                      ref={(ref) =>
                                        this.setSellingPriceInputRef(ref, index)
                                      }
                                    />
                                  </span>
                                </div>
                                <div className="price-info">
                                  <label>Total Qty</label>
                                  <span>{item.quantity || 0}</span>
                                </div>
                                <button
                                  className="remove-btn"
                                  onClick={() => this.handleRemoveClick(index)}
                                >
                                  X
                                </button>
                              </div>
                            </div>

                            <div style={{ padding: "0 20px" }}>
                              <hr
                                style={{
                                  border: "2px solid #ff9800",
                                  margin: "10px 0",
                                  width: "100%",
                                }}
                              />
                            </div>

                            {/* Toggle Bar */}
                            <div className="order-item-toggle">
                              {item.medicinBatchesdata &&
                                item.medicinBatchesdata.length > 0 && (
                                  <div className="item-info-field checkbox-field">
                                    <label
                                      className="toggle-label"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {this.state.expandedId === item.id
                                        ? "Hide"
                                        : "Show"}
                                    </label>
                                    <div
                                      className="show-hide-checkbox"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        this.toggleExpand(item.id);
                                      }}
                                    >
                                      {this.state.expandedId === item.id
                                        ? "-"
                                        : "+"}
                                    </div>

                                    {/* <input
                                      type="checkbox"
                                      checked={item.isPartialOrderItem}
                                      onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        this.toggleExpand(item.id);
                                      }}
                                      className="toggle-btn"
                                    /> */}
                                  </div>
                                  // <button
                                  //   type="button"
                                  //   className={`toggle-btn ${this.state.expandedId === item.id ? "expanded" : "collapsed"}`}
                                  //   onClick={(event) => {
                                  //     event.preventDefault();
                                  //     event.stopPropagation();
                                  //     this.toggleExpand(item.id);
                                  //     console.log(
                                  //       "Toggle clicked for item:",
                                  //       item.id,
                                  //       "Current expandedId:",
                                  //       this.state.expandedId,
                                  //     );
                                  //   }}
                                  // >
                                  //   {this.state.expandedId === item.id
                                  //     ? "Hide Stock Details"
                                  //     : "Show Stock Details"}
                                  // </button>
                                )}
                              <div className="item-info-row">
                                <div className="item-info-field checkbox-field">
                                  <label
                                    className="toggle-label"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Available
                                  </label>
                                  <input
                                    type="checkbox"
                                    checked={item.isPartialOrderItem}
                                    onClick={(event) => {
                                      this.handlePartialOrderCheckboxChange(
                                        index,
                                        event,
                                      );
                                    }}
                                  />
                                </div>
                                <div className="item-info-field checkbox-field">
                                  <label
                                    className="toggle-label"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Printable
                                  </label>
                                  <input
                                    type="checkbox"
                                    checked={item.is_printable}
                                    onClick={(e) => {
                                      this.handleis_printableOnChange(e);
                                    }}
                                    value={item.id}
                                  />
                                </div>
                                {this.state.isClaimableOrder && (
                                  <div className="item-info-field checkbox-field">
                                    <label
                                      className="toggle-label"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                    >
                                      Claimable
                                    </label>
                                    <input
                                      type="checkbox"
                                      checked={item.isChecked}
                                      onClick={(e) => {
                                        this.handleCheckboxChange(e, item.id);
                                      }}
                                      value={item.id}
                                    />
                                  </div>
                                )}
                                <div className="item-info-field checkbox-field">
                                  <label
                                    className="toggle-label"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Upseller
                                  </label>
                                  <input
                                    type="checkbox"
                                    checked={item.isUpSeller}
                                    onClick={(e) =>
                                      this.handleUpsellerCheckboxChange(e)
                                    }
                                    value={item.id}
                                  />
                                </div>
                                <div className="item-info-field checkbox-field">
                                  <label
                                    className="toggle-label"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Placement
                                  </label>
                                  <span>{item.location || "-"}</span>
                                </div>
                                <div className="item-info-field checkbox-field">
                                  <label
                                    className="toggle-label"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Total Stock
                                  </label>
                                  <span
                                    style={{
                                      color:
                                        (item.pharmacyLevelQuantity || 0) > 0
                                          ? "green"
                                          : "red",
                                    }}
                                  >
                                    {item.pharmacyLevelQuantity || 0}
                                  </span>
                                </div>
                                <div className="item-info-field checkbox-field">
                                  <label
                                    className="toggle-label"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Item Code
                                  </label>
                                  <span>{item.item_code || "-"}</span>
                                </div>
                                <div className="item-info-field sub-total checkbox-field">
                                  <label
                                    className="toggle-label"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Sub Total
                                  </label>
                                  <span>
                                    {item.subtotal
                                      ? Number(item.subtotal).toFixed(2)
                                      : "0.00"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Expandable Content */}

                            {item.description && item.description.value && (
                              <>
                                <div style={{ padding: "0 20px" }}>
                                  <hr
                                    style={{
                                      border: "2px solid #ff9800",
                                      margin: "10px 0",
                                      width: "100%",
                                    }}
                                  />
                                </div>
                                <div className="order-item-content">
                                  {/* Stock Availability Section */}
                                  <div className="stock-section-order">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      <div className="section-header-order">
                                        STOCK AVAILABILITY
                                      </div>
                                      {/* Warehouse Stock Section */}
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          paddingLeft: "20px",
                                          paddingBottom: "12px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontWeight: "900",
                                            color: "#ff9800",
                                          }}
                                        >
                                          Warehouse Stock:
                                        </div>
                                        {/* <label>Available Stock:</label> */}
                                        <span
                                          style={{
                                            color:
                                              (item.storeLevelQuantity || 0) > 0
                                                ? "green"
                                                : "red",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            marginTop: "2px",
                                            marginLeft: "5px",
                                            marginRight: "15px",
                                          }}
                                        >
                                          {item.storeLevelQuantity || 0}
                                        </span>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <div
                                          style={{
                                            fontWeight: "900",
                                            color: "#000000ff",
                                          }}
                                        >
                                          Consumption Level:
                                        </div>
                                        {/* <label>Available Stock:</label> */}
                                        <span
                                          style={{
                                            color:
                                              Math.ceil(
                                                item.consumtionLevel || 0,
                                              ) > 0
                                                ? "green"
                                                : "red",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            marginTop: "2px",
                                            marginLeft: "5px",
                                            marginRight: "15px",
                                          }}
                                        >
                                          {Math.ceil(item.consumtionLevel || 0)}
                                        </span>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <div
                                          style={{
                                            fontWeight: "900",
                                            color: "#000000ff",
                                          }}
                                        >
                                          Reorder Level:
                                        </div>
                                        {/* <label>Available Stock:</label> */}
                                        <span
                                          style={{
                                            color:
                                              Number(
                                                item.storeLevelQuantity ||
                                                  0 +
                                                    item.pharmacyLevelQuantity ||
                                                  0,
                                              ) > Number(item.reOrderLevel || 0)
                                                ? "green"
                                                : "red",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            marginTop: "2px",
                                            marginLeft: "5px",
                                            marginRight: "15px",
                                          }}
                                        >
                                          {item.reOrderLevel || 0}
                                        </span>
                                        {/* {item.pharmacyLevelQuantity <
                                        item.reOrderLevel && ( */}
                                        <div
                                          className="item-info-field checkbox-field"
                                          style={{
                                            margin: 0,
                                            marginLeft: "24px",
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          <Button
                                            className="btn-fill btn btn-default"
                                            style={{
                                              margin: 0,
                                              padding: "6px 12px",
                                            }}
                                            onClick={() =>
                                              this.handleRefillRequestChange(
                                                index,
                                              )
                                            }
                                            disabled={
                                              item.refillRequestCreated || false
                                            }
                                          >
                                            {item.refillRequestCreated
                                              ? "Refill Request Created"
                                              : "Request Refill"}
                                          </Button>
                                        </div>
                                        &nbsp;&nbsp;&nbsp;
                                        {/* )} */}
                                      </div>
                                    </div>

                                    {/* Pharmacy Stock Section */}
                                    {item.medicinBatchesdata &&
                                      item.medicinBatchesdata.length > 0 &&
                                      this.state.expandedId === item.id && (
                                        <table className="stock-table-order">
                                          <thead>
                                            <tr>
                                              <th>Batch</th>
                                              <th>Expiry</th>
                                              <th className="align-center">
                                                Available Qty
                                              </th>
                                              <th className="align-center">
                                                Location
                                              </th>
                                              <th className="align-center">
                                                Qty
                                              </th>
                                              <th></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item.medicinBatchesdata &&
                                            item.medicinBatchesdata.length >
                                              0 ? (
                                              item.medicinBatchesdata.map(
                                                (stock, idx) => (
                                                  <tr
                                                    key={idx}
                                                    className={
                                                      item.batch_no ===
                                                      stock.batch_no
                                                        ? "not-fifo"
                                                        : ""
                                                    }
                                                  >
                                                    <td>
                                                      {stock.batch_no || "N/A"}
                                                    </td>
                                                    <td>
                                                      {stock.expiry_date ||
                                                        "N/A"}
                                                    </td>
                                                    <td className="align-center">
                                                      {stock.quantity}
                                                    </td>
                                                    <td className="align-center">
                                                      {(stock.pharmacies &&
                                                        stock.pharmacies
                                                          .name) ||
                                                        "-"}
                                                    </td>
                                                    <td className="align-center">
                                                      <FormControl
                                                        type="number"
                                                        value={stock.qty || ""}
                                                        onChange={(e) =>
                                                          this.handleQuantityChange(
                                                            idx,
                                                            index,
                                                            e,
                                                          )
                                                        }
                                                        className="qty-input align-center"
                                                        onWheel={(e) =>
                                                          e.target.blur()
                                                        }
                                                        ref={(ref) =>
                                                          this.setQtyRef(
                                                            ref,
                                                            index,
                                                            idx,
                                                          )
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            e.key === "Enter"
                                                          ) {
                                                            this.focusSellingPriceInput(
                                                              index,
                                                              idx + 1,
                                                            );
                                                          }
                                                        }}
                                                      />
                                                    </td>
                                                    <td className="align-center">
                                                      {item.batch_no ===
                                                        stock.batch_no &&
                                                        this.checkIsExpiaryCloserMedicine(
                                                          stock,
                                                          item.medicinBatchesdata,
                                                        ) && (
                                                          <span className="not-fifo-badge">
                                                            ⚠ Not FIFO
                                                          </span>
                                                        )}
                                                    </td>
                                                  </tr>
                                                ),
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="6"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  No stock available
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      )}
                                  </div>

                                  {/* Other Brand Section */}
                                  {item.other_brands &&
                                    item.other_brands.length > 0 &&
                                    this.state.expandedId === item.id && (
                                      <>
                                        <br />
                                        <br />
                                        <div className="other-brand-section">
                                          <div className="section-header-order">
                                            {`OTHER BRANDS FOR ${item.generic_name || ""}`}
                                          </div>
                                          <table className="stock-table-order">
                                            <thead>
                                              <tr>
                                                <th>Medicine</th>
                                                <th>Available Qty</th>
                                                <th>Pharmacy Qty</th>
                                                <th>Warehouse Qty</th>
                                                <th>Price</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {item.other_brands.map(
                                                (brand, idx) => (
                                                  <tr
                                                    key={idx}
                                                    style={{
                                                      borderBottom:
                                                        "1px dotted #9e9e9e",
                                                    }}
                                                  >
                                                    <td>{brand.title}</td>
                                                    <td>
                                                      {this.getOtherBrandQuantity(
                                                        brand.store_wise_medication,
                                                      ) || 0}
                                                    </td>
                                                    <td>
                                                      {this.getOtherBrandLocation(
                                                        brand.store_wise_medication,
                                                        "Flash Health Pharmacy",
                                                      )}
                                                    </td>
                                                    <td>
                                                      {this.getOtherBrandLocation(
                                                        brand.store_wise_medication,
                                                        "Flash WareHouse",
                                                      )}
                                                    </td>
                                                    <td>{brand.price}</td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </>
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                        <div>
                          {/* <Button
                            className="AddMedicine_Btn"
                            onClick={this.handleAddClick}
                          >
                            {" "}
                            <i className="fa fa-plus"></i> Add Medicine
                          </Button> */}
                          &nbsp;&nbsp;
                          <Button
                            className="AddMedicine_Btn"
                            // style={{ marginBottom: "10px" }}
                            onClick={() => this.handleAddMultipleClick(5)}
                          >
                            <i className="fa fa-plus"></i> Add Medicine
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            style={{ marginBottom: "10px" }}
                            // disabled={!this.state.processing}
                            // onClick={this.onSubmit.bind(this)}
                            class="btn-color" //bsStyle="info"
                            fill
                          >
                            Print
                          </Button>
                        </div>
                      </div>
                    ) : null}
                    <React.Fragment>
                      {this.state.subscriber != 0 ? (
                        this.state.address_id != 0 ||
                        this.state.city_id != 0 ? (
                          <Row>
                            <Modal
                              show={this.state.showmediactonModal}
                              onHide={() =>
                                this.setState({ showmediactonModal: false })
                              }
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>Medication Details</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <input
                                  style={{
                                    width: "0px",
                                    height: "0px",
                                    border: "none",
                                  }}
                                  type="text"
                                  ref={this.medication_item_code_error}
                                />
                                {medicationerrormessage.length != 0 && (
                                  <div className=" alert alert-danger">
                                    {medicationerrormessage.map((data) => (
                                      <React.Fragment>
                                        <li>{data}</li>
                                      </React.Fragment>
                                    ))}
                                  </div>
                                )}
                                <FormGroup>
                                  <Checkbox
                                    number="49"
                                    checked={this.state.is_flash_medicine}
                                    onChange={(e) => this.isFalshMedicine(e)}
                                    label="Is Flash Medicine / Product?"
                                  ></Checkbox>
                                </FormGroup>
                                {this.state.is_flash_medicine && (
                                  <FormGroup>
                                    <ControlLabel>Supplier</ControlLabel>
                                    <select
                                      className="react-select primary form-control"
                                      name="supplier"
                                      value={this.state.supplier}
                                      onChange={(event) => {
                                        this.setState({
                                          supplier: event.target.value,
                                        });
                                      }}
                                    >
                                      <option value="0">Select Supplier</option>
                                      {this.state.suppliersData.map((cus) => (
                                        <option value={cus.id}>
                                          {cus.name}
                                        </option>
                                      ))}
                                    </select>
                                  </FormGroup>
                                )}

                                <FormGroup>
                                  <ControlLabel>Item Code</ControlLabel>
                                  <FormControl
                                    name="medicationitemcode"
                                    value={this.state.medicationitemcode}
                                    disabled={this.state.codeDisabled}
                                    onChange={(event) => {
                                      this.setState({
                                        medicationitemcode: event.target.value,
                                      });
                                      ((this.state.is_flash_medicine === 0) &
                                        event.target.value) ===
                                      ""
                                        ? this.setState({
                                            medicationitemcodeError: (
                                              <small className="text-danger">
                                                ItemCode is required.
                                              </small>
                                            ),
                                          })
                                        : this.setState({
                                            medicationitemcodeError: null,
                                          });
                                    }}
                                    placeholder="Enter ItemCode"
                                  />
                                  {this.state.medicationitemcodeError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Item Name</ControlLabel>
                                  <FormControl
                                    name="medicationitemname"
                                    value={this.state.medicationitemname}
                                    type="text"
                                    placeholder="Enter Item Name"
                                    onChange={this.medicationChange}
                                  ></FormControl>
                                  {this.state.medicationitemnameError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Unit Price</ControlLabel>
                                  <FormControl
                                    name="medicationunitprice"
                                    value={this.state.medicationunitprice}
                                    type="number"
                                    placeholder="Enter UnitPrice"
                                    onChange={this.medicationChange}
                                  ></FormControl>
                                  {this.state.medicationunitpriceError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Item Name</ControlLabel>
                                  <FormControl
                                    name="medicationitemname"
                                    value={this.state.medicationitemname}
                                    type="text"
                                    placeholder="Enter Item Name"
                                    onChange={this.medicationChange}
                                  ></FormControl>
                                  {this.state.medicationitemnameError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>
                                    Medication Category
                                  </ControlLabel>
                                  <select
                                    name="medicationcategory"
                                    onChange={this.medicationChange}
                                    value={this.state.medicationcategory}
                                    className="form-control"
                                  >
                                    <option value="0">
                                      Select Medication Category
                                    </option>
                                    {this.state.category_detail.map(
                                      (mcatdata) => (
                                        <option value={mcatdata.id}>
                                          {mcatdata.category_name}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                  {this.state.medicationcategoryError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Country</ControlLabel>
                                  <select
                                    className=" primary form-control"
                                    name="medicationcity"
                                    value={this.state.medicationcity}
                                    onChange={this.medicationChange}
                                  >
                                    <option value="0">Select Country</option>
                                    {this.state.country_detail.map((cus) => (
                                      <option value={cus.id}>
                                        {cus.country_name}
                                      </option>
                                    ))}
                                  </select>
                                  {this.state.medicationcityError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Quantity</ControlLabel>
                                  <FormControl
                                    name="quantity"
                                    value={this.state.quantity}
                                    onChange={(event) => {
                                      this.setState({
                                        quantity: event.target.value,
                                      });
                                    }}
                                    placeholder="Enter quantity"
                                    type="number"
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Display Discount</ControlLabel>
                                  <FormControl
                                    name="display_discount"
                                    value={this.state.display_discount}
                                    placeholder="Enter Display Discount"
                                    onChange={(event) => {
                                      this.setState({
                                        display_discount: event.target.value,
                                      });
                                    }}
                                    type="number"
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Search Tags</ControlLabel>
                                  <TagsInput
                                    value={this.state.tags}
                                    onChange={(e) => this.handleChange(e)}
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Barcode</ControlLabel>
                                  <FormControl
                                    name="barcode"
                                    value={this.state.barcode}
                                    onChange={(event) => {
                                      this.setState({
                                        barcode: event.target.value,
                                      });
                                    }}
                                    placeholder="Enter Barcode"
                                    type="text"
                                  />
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Description</ControlLabel>
                                  <textarea
                                    className="form-control"
                                    name="medicationdescription"
                                    value={this.state.medicationdescription}
                                    cols={3}
                                    rows={2}
                                    placeholder="Enter Description"
                                    onChange={this.medicationChange}
                                  ></textarea>
                                  {this.state.medicationdescriptionError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Images</ControlLabel>
                                  <br></br>
                                  <input
                                    style={{ display: "none" }}
                                    id="selectImage"
                                    type="file"
                                    className="form-control"
                                    name="package_image"
                                    multiple
                                    onChange={this.handleFileChange}
                                  />
                                  <Button
                                    onClick={this.upload}
                                    style={{ color: "#2B3A41" }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        this.state.package_image == ""
                                          ? "fa fa-plus"
                                          : "fa fa-pencil fa-fw"
                                      }
                                    ></i>{" "}
                                    {this.state.package_image == ""
                                      ? "Choose File"
                                      : "Change File"}
                                  </Button>
                                </FormGroup>
                                <FormGroup>
                                  <Table>
                                    <tr>
                                      {this.state.package_image_data.map(
                                        (pid, i) => (
                                          <>
                                            <td style={{ width: "30px" }}>
                                              <Radio
                                                style={{
                                                  display: "inline-block",
                                                }}
                                                number={"5" + i}
                                                option={pid}
                                                name="primaryimage"
                                                onChange={this.onChange}
                                                //  checked={this.state.eligibility === "1"}
                                                //  label="Web"
                                              />
                                            </td>
                                            <td>
                                              <a href={pid} target="_blank">
                                                <img
                                                  src={pid}
                                                  style={{
                                                    height: "30px",
                                                    width: "30px",
                                                  }}
                                                ></img>
                                              </a>
                                            </td>
                                          </>
                                        ),
                                      )}
                                    </tr>
                                  </Table>

                                  {this.state.packageImageError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Add Commision 10%</ControlLabel>
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="10"
                                    option="1"
                                    name="medicationaddcommision"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationaddcommision === "1"
                                    }
                                    label="Yes"
                                  />
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="11"
                                    option="2"
                                    name="medicationaddcommision"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationaddcommision === "2"
                                    }
                                    label="No"
                                  />
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>
                                    Is Featured ? &nbsp;
                                  </ControlLabel>
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="12"
                                    option="1"
                                    name="medicationis_featured"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationis_featured === "1"
                                    }
                                    label="Yes"
                                  />
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="13"
                                    option="2"
                                    name="medicationis_featured"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationis_featured === "2"
                                    }
                                    label="No"
                                  />
                                </FormGroup>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  class="btn-color"
                                  fill
                                  onClick={this.add_new_medication_category.bind(
                                    this,
                                  )}
                                >
                                  Submit
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </Row>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </React.Fragment>

                    <div
                      className="order_middle_container"
                      style={{
                        position: "relative",
                        minHeight: "1px",
                        padding: "0 20px 20px 20px",
                      }}
                    >
                      {/* {(this.state.store == 1 || this.state.store == null) && ( */}
                      <Row>
                        <Col md={3} sm={3}>
                          <FormGroup className="order_source_data ">
                            <ControlLabel>Delivery Type</ControlLabel>

                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              placeholder="Delivery Type"
                              name="deliverytype"
                              value={this.state.deliverytype}
                              onChange={(value) =>
                                this.handleDeliveryTypeOnChange(value)
                              }
                              options={
                                this.state.sub_orderType
                                  ? this.state.deliveryTypeOptions
                                  : this.state.deliveryTypeOptionsB2C
                              }
                            />
                          </FormGroup>
                        </Col>
                        {this.state.deliverytype.value == 1 ? (
                          <>
                            <Col md={3} sm={3}>
                              <FormGroup className="fl_datepicker">
                                <div
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <ControlLabel> Delivery Within</ControlLabel>
                                  <FormControl
                                    style={{ margin: 0 }}
                                    value={`${this.state.datarange.start.format(
                                      "YYYY-MM-DD",
                                    )} - ${this.state.datarange.end.format(
                                      "YYYY-MM-DD",
                                    )}`}
                                    onClick={this.onToggle.bind(this)}
                                    placeholder="Date Range"
                                    type="text"
                                  />

                                  {this.state.isdatepickeron && (
                                    <DateRangePicker
                                      value={this.state.datarange}
                                      onSelect={this.onSelect}
                                      singleDateRange={true}
                                    />
                                  )}
                                </div>
                              </FormGroup>
                            </Col>
                          </>
                        ) : (
                          ""
                        )}
                        <Col md={3} sm={3}>
                          <ControlLabel>Payment Option</ControlLabel>
                          <Select
                            className="react-select primary commonform-margin"
                            classNamePrefix="react-select"
                            placeholder="Payment Option"
                            name="paymentoption"
                            value={this.state.paymentoption}
                            onChange={(value) =>
                              this.setState({
                                paymentoption: value,
                                paymentoptionError: null,
                              })
                            }
                            options={[
                              { value: "Cash", label: "Cash" },
                              // { value: "Card", label: "Card" },
                              { value: "Cheque", label: "Cheque" },
                              {
                                value: "Bank Transfer",
                                label: "Bank Transfer",
                              },
                              { value: "Hybrid", label: "Hybrid" },
                              { value: "ComBank", label: "ComBank" },
                              {
                                value: "Swap Machine",
                                label: "Swap Machine",
                              },
                            ]}
                          />
                          {this.state.paymentoptionError}
                          <br></br>
                        </Col>
                        <Col md={3} sm={3}>
                          <FormGroup className="fl_datepicker">
                            <div className="payment_duePicker">
                              <ControlLabel> Payment Due Date</ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{
                                  placeholder: "Payment Due Date",
                                }}
                                defaultValue={new Date()}
                                closeOnSelect={true}
                                value={this.state.paymentduedate}
                                onChange={this.handlePaymentDueDate}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      {/* )} */}
                      {this.state.store === 1 || this.state.store === null ? (
                        <Row>
                          <Col md={3} sm={3} style={{ position: "relative" }}>
                            <ControlLabel>Health Condition</ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Health Condition"
                              name="healthcondition"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.healthcondition}
                              onChange={(value) =>
                                this.setState({
                                  healthcondition: value,
                                })
                              }
                              options={this.state.healthconditionItems}
                            />
                          </Col>

                          <Col md={3} sm={3}>
                            <FormGroup>
                              {this.state.dynamicfinalpercentage != 0 ? (
                                <p style={{ marginTop: "26px" }}>
                                  Added Discount :
                                  {this.state.dynamicfinalpercentage} %
                                </p>
                              ) : (
                                ""
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      {this.state.store === 1 || this.state.store === null ? (
                        <Row>
                          <Col
                            md={12}
                            sm={12}
                            style={{ marginLeft: "1px", width: "91%" }}
                          >
                            <Checkbox
                              number="56"
                              checked={this.state.is_currier}
                              onChange={(e) => this.isCurrier(e)}
                              label="Is Courier ?"
                            ></Checkbox>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      {this.state.store === 1 || this.state.store === null ? (
                        <Row>
                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "yes"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup className="fl_datepicker">
                              <div style={{ bottom: "5px" }}>
                                <ControlLabel>Rider : </ControlLabel>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  placeholder="Rider"
                                  name="rider_id"
                                  value={this.state.rider_id}
                                  onChange={(value) =>
                                    this.setState({
                                      rider_id: value,
                                    })
                                  }
                                  options={this.state.rider_data}
                                />
                                {/* {this.state.rider_idError} */}
                              </div>
                            </FormGroup>
                          </Col>

                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup className="fl_datepicker">
                              <div>
                                <ControlLabel>Courier Partner : </ControlLabel>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  placeholder="Courier Partner"
                                  name="currier_id"
                                  value={this.state.currier_id}
                                  onChange={(value) =>
                                    this.setState({
                                      currier_id: value,
                                    })
                                  }
                                  options={this.currier_details}
                                />
                              </div>
                            </FormGroup>
                          </Col>

                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup>
                              <ControlLabel>Tracking Id</ControlLabel>
                              <FormControl
                                type="text"
                                name="tracking_id"
                                value={this.state.tracking_id}
                                onChange={this.onChange}
                                placeholder="Enter tracking id"
                              ></FormControl>
                            </FormGroup>
                          </Col>

                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup>
                              <ControlLabel>Tracking Url</ControlLabel>
                              <FormControl
                                type="text"
                                name="tracking_url"
                                value={this.state.tracking_url}
                                onChange={this.onChange}
                                placeholder="Enter tracking url"
                              ></FormControl>
                            </FormGroup>
                          </Col>

                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup>
                              <ControlLabel>Tracking Note</ControlLabel>
                              <FormControl
                                type="text"
                                name="tracking_note"
                                value={this.state.tracking_note}
                                onChange={this.onChange}
                                placeholder="Enter tracking note"
                              ></FormControl>
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      {(this.state.store === 1 ||
                        this.state.store === null) && (
                        <>
                          <Row>
                            <Col
                              md={12}
                              xs={12}
                              sm={12}
                              lg={12}
                              style={{ marginLeft: "1px", width: "91%" }}
                            >
                              <FormGroup>
                                <ControlLabel>Note</ControlLabel>
                                <textarea
                                  className="form-control"
                                  rows="4"
                                  cols="5"
                                  placeholder="Enter Note"
                                  onChange={(event) => {
                                    this.setState({
                                      ordernote: event.target.value,
                                    });
                                  }}
                                  value={this.state.ordernote}
                                ></textarea>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              {this.state.source.value == "9" ? (
                                <div class="alert alert-warning" role="alert">
                                  This is Vida order
                                </div>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                        </>
                      )}

                      <Row className="submit_button_row_desktop">
                        <Col sm={12}>
                          <br></br>
                          <Button
                            disabled={
                              !this.state.processing ||
                              this.state.isWrongQuantity
                            }
                            onClick={this.onSubmit.bind(this)}
                            class="btn-color" //bsStyle="info"
                            fill
                          >
                            Submit
                          </Button>{" "}
                          &nbsp;
                          {(this.state.store == 1 ||
                            this.state.store === null) && (
                            <Button
                              disabled={
                                !this.state.processing ||
                                this.state.isWrongQuantity
                              }
                              onClick={this.onSendQuote.bind(this)}
                              class="btn-color" //bsStyle="info"
                              fill
                            >
                              Submit Quote
                            </Button>
                          )}
                          &nbsp;
                        </Col>
                      </Row>
                    </div>
                    {(this.state.store == 1 || this.state.store === null) && (
                      <div
                        className="order_address_container"
                        style={{
                          padding: "0 20px",
                        }}
                      >
                        <Row
                          style={{
                            padding: "0 20px",
                          }}
                        >
                          <Col sm={12} md={12} style={{ paddingTop: "29px" }}>
                            <CommentSection
                              title="Order Comments"
                              comments={this.state.comments}
                              currentUser="Admin"
                              userOptions={this.state.UserListData}
                              UserListData={this.state.UserListData}
                              onAddComment={this.handleAddComment}
                              onDeleteComment={this.handleDeleteComment}
                              disableAfterFirstComment={true}
                              mentionedUsers={this.state.mentionedUsers}
                              onMentionChange={(users) =>
                                this.setState({ mentionedUsers: users })
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    )}
                    <br />
                    <Row
                      style={{
                        padding: "0 20px",
                      }}
                    >
                      <Col sm={12} className="collapeablecomp_orderhistory">
                        <Collapsible
                          trigger="Historical Orders"
                          transitionTime={200}
                        >
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Name</th>
                                {/* <th>OPharma Referance</th> */}
                                <th>Order Date</th>
                                <th>Total Cost</th>
                                <th className="text-right">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {this.state.lastsubscription.map((lastd) => (
                                    <tr>
                                      <td>{lastd.lead["name"]}</td>
                                      {/* <td>{lastd.opharma_reference}</td> */}
                                      <td>{lastd.order_date}</td>
                                      <td>
                                        {(lastd.total_cost - 0).toFixed(2)}
                                      </td>
                                      <td className="text-right">
                                        {" "}
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={view}
                                        >
                                          <Button
                                            simple
                                            bsStyle="info"
                                            onClick={this.lastorderdetail.bind(
                                              this,
                                              lastd.id,
                                            )}
                                            bsSize="xm"
                                          >
                                            <i className="fa fa-user" />
                                          </Button>
                                        </OverlayTrigger>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                        </Collapsible>
                      </Col>
                    </Row>
                  </Col>

                  {this.state.subscriber != 0 ? (
                    <Col
                      sm={4}
                      className="fl_sticky_side orderStatic-container"
                    >
                      <div className="dropdown-AddOrder">
                        <Row>
                          <Col md={12}>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                                marginBottom: "20px",
                              }}
                            >
                              Customer Info
                            </h3>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            <div className="table-responsive ">
                              <table className="table">
                                <tbody>
                                  {/* <React.Fragment> */}
                                  <tr>
                                    <td className="text-left">Name</td>
                                    <td
                                      className="text-right"
                                      style={{ padding: "1px" }}
                                    >
                                      {this.state.username != null
                                        ? this.state.username
                                        : "-"}
                                    </td>
                                  </tr>
                                  {/*this.state.userphone != null && (
                                      <tr>
                                        <td className="text-left">
                                          Phone Number
                                        </td>
                                        <td
                                          className="text-right"
                                          style={{ padding: "1px" }}
                                        >
                                          {this.state.userphone != null
                                            ? this.state.userphone
                                            : "-"}
                                        </td>
                                      </tr>
                                          )*/}
                                  <tr>
                                    <td className="text-left">Mobile Number</td>
                                    <td
                                      className="text-right"
                                      style={{ padding: "1px" }}
                                    >
                                      {this.state.usermobile != null
                                        ? this.state.usermobile
                                        : "-"}
                                    </td>
                                  </tr>
                                  {this.state.useremail && (
                                    <tr>
                                      <td className="text-left">
                                        Email Adress
                                      </td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state.useremail != null
                                          ? this.state.useremail
                                          : "-"}
                                      </td>
                                    </tr>
                                  )}
                                  {/*this.state.occupation && (
                                      <tr>
                                        <td className="text-left">
                                          Occupation
                                        </td>
                                        <td
                                          className="text-right"
                                          style={{ padding: "1px" }}
                                        >
                                          {this.state.occupation
                                            ? this.state.occupation
                                            : "-"}
                                        </td>
                                      </tr>
                                          )*/}
                                  <tr>
                                    <td className="text-left">
                                      Remaining Credits
                                    </td>
                                    <td
                                      className="text-right"
                                      style={{ padding: "1px" }}
                                    >
                                      {this.state.avalable_flash_point != null
                                        ? (
                                            this.state.avalable_flash_point - 0
                                          ).toFixed(2)
                                        : "0"}
                                    </td>
                                  </tr>
                                  {/*<tr>
                                  <td className="text-left">Package Name</td>
                                  <td
                                    className="text-right"
                                    style={{ padding: "1px" }}
                                  >
                                    {this.state.catalougepackagename != null
                                      ? this.state.catalougepackagename
                                      : "-"}
                                  </td>
                                </tr>*/}
                                  <tr>
                                    <td className="text-left">Company name</td>
                                    <td className="text-right">
                                      {this.state.companyname != null
                                        ? this.state.companyname
                                        : "-"}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <div className="dropdown2-AddOrder">
                        <Row>
                          <Col md={12}>
                            <h3
                              style={{
                                margin: "20px 0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Basket Info
                            </h3>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            <div className="table-responsive ">
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <td
                                      style={{ padding: "1px", width: "60%" }}
                                    >
                                      Basket Value
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {this.state.basketvalue}
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Discounted Amount
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {this.state.discountamount > 0
                                          ? "-"
                                          : ""}{" "}
                                        {this.state.discountamount}
                                      </p>
                                    </td>
                                  </tr>
                                  {Number(this.state.getUnavalibleCost) > 0 &&
                                    this.state.sub_orderType && (
                                      <tr>
                                        <td style={{ padding: "1px" }}>
                                          Pending Item value
                                        </td>
                                        <td style={{ padding: "1px" }}>
                                          <p className="basketValue_parent">
                                            (
                                            {(
                                              Number(
                                                this.state.getUnavalibleCost,
                                              ) || 0
                                            ).toFixed(2)}
                                            )
                                          </p>
                                        </td>
                                      </tr>
                                    )}
                                  {this.state.catPackageDiscountAmount != 0 && (
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        {`${this.state.catalougepackagename} Package Discount Amount (${this.state.catPackageDiscount}%)`}
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <p className="basketValue_parent">
                                          {this.state.catPackageDiscountAmount >
                                          0
                                            ? this.state.catPackageDiscountAmount.toFixed(
                                                2,
                                              )
                                            : ""}
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Delivery / Packaging Charge{" "}
                                      {this.state.deliverytype.value == 2 ? (
                                        <span>(Express Delivery)</span>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <FormControl
                                        disabled={
                                          this.state.isDeliveryCharge
                                            ? "disabled"
                                            : ""
                                        }
                                        name="deliverycharge"
                                        className="fl_deliverycharge basketValue_input"
                                        onChange={(event) =>
                                          this.handleDeliveryChange(event)
                                        }
                                        value={this.state.deliverycharge}
                                        placeholder="0.00"
                                        type="number"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Total Cost
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basket_totalcost">
                                        {this.state.sub_orderType
                                          ? (
                                              (parseFloat(
                                                this.state.totalcost,
                                              ) || 0) -
                                              (parseFloat(
                                                this.state.getUnavalibleCost,
                                              ) || 0)
                                            ).toFixed(2)
                                          : this.state.totalcost}
                                      </p>
                                      {/*<FormControl
                                      name="totalcost"
                                      className="basketValue_parent fl_basketinfoupdated"
                                      disabled="disabled"
                                      value={
                                        this.state.loading ? (
                                          <LoadingSpinner />
                                        ) : (
                                          this.state.totalcost
                                        )
                                      }
                                      onChange={(event) => {
                                        this.setState({
                                          totalcost: event.target.value,
                                        });
                                        event.target.value === ""
                                          ? this.setState({
                                              totalcostError: (
                                                <small className="text-danger">
                                                  Total Cost is required.
                                                </small>
                                              ),
                                            })
                                          : this.setState({
                                              totalcostError: null,
                                            });
                                      }}
                                      placeholder="0.00"
                                      type="number"
                                    />*/}
                                      {this.state.totalcostError}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              }
            />
          </Grid>
          {this.state.isLoading ? <ScreenLoader /> : ""}

          <Modal
            show={this.state.showModal}
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Medication Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p key={subscriptiondetail.id}>
                {" "}
                TotalCost : {(subscriptiondetail.total_cost - 0).toFixed(2)}
              </p>

              <p>
                Delivery Type :{" "}
                {subscriptiondetail.delivery_type == "1" ? "Flash" : "OPharma"}
              </p>
              {subscriptiondetail.delivery_charge != null ? (
                <p>
                  Delivery Charge :{" "}
                  {(subscriptiondetail.delivery_charge - 0).toFixed(2)}
                </p>
              ) : (
                ""
              )}
              {subscriptiondetail.organization_discount > 0 ? (
                <p>
                  Discount :{" "}
                  {(subscriptiondetail.organization_discount - 0).toFixed(2)}
                </p>
              ) : (
                ""
              )}

              <Table>
                <thead>
                  <tr>
                    <th>Medication</th>
                    <th>Price</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.quanitydata.map((data) => (
                    <tr>
                      <td key={data.medication_id}>{data.medication_title}</td>
                      <td>{(data.unit_price - 0).toFixed(2)}</td>
                      <td>{data.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.discountmodal}
            onHide={() => this.setState({ discountmodal: true })}
          >
            <Modal.Header>
              <Modal.Title>Dynamic Discount</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup>
                <ControlLabel>Discount Percentage</ControlLabel>
                <FormControl
                  type="number"
                  value={this.state.discountpercentage}
                  onChange={this.onChange}
                  name="discountpercentage"
                  placeholder="0%"
                ></FormControl>
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={this.submitdynamicdiscount.bind(this)}
                class="btn-color"
                fill
              >
                Submit
              </Button>
              &nbsp;
              <Button
                onClick={this.closedynamicdiscount.bind(this)}
                class="btn-color"
                fill
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.marginmodal}
            onHide={() => this.setState({ marginmodal: false })}
          >
            <Modal.Header>
              <Modal.Title>Dynamic Margin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup className="order_source_data">
                <ControlLabel>Select Margin Type</ControlLabel>
                &nbsp;
                <Radio
                  style={{ display: "inline-block" }}
                  number="8"
                  option="1"
                  name="margintype"
                  onChange={this.onChange}
                  checked={this.state.margintype === "1"}
                  label="Margin Percentage"
                />
                &nbsp;
                <Radio
                  style={{ display: "inline-block" }}
                  number="9"
                  option="2"
                  name="margintype"
                  onChange={this.onChange}
                  checked={this.state.margintype === "2"}
                  label="Margin in cash"
                />
              </FormGroup>
              {this.state.margintype == 1 ? (
                <FormGroup>
                  <ControlLabel>Margin Percentage</ControlLabel>
                  <FormControl
                    type="number"
                    onChange={this.onChange}
                    value={this.state.marginpercentage}
                    name="marginpercentage"
                    placeholder="0%"
                  ></FormControl>
                </FormGroup>
              ) : (
                ""
              )}
              {this.state.margintype == 2 ? (
                <FormGroup>
                  <ControlLabel>Margin Amount</ControlLabel>
                  <FormControl
                    type="number"
                    onChange={this.onChange}
                    value={this.state.marginamount}
                    name="marginamount"
                    placeholder="0.00"
                  ></FormControl>
                </FormGroup>
              ) : (
                ""
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={this.submitdynamicmargin.bind(this)}
                bsStyle="success"
                fill
              >
                {" "}
                Submit
              </Button>{" "}
              &nbsp;
              <Button
                onClick={this.closedynamicmargin.bind(this)}
                bsStyle="info"
                fill
              >
                {" "}
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* <Col md={12}>                         */}
          {/* <h3>Shipping Details</h3> */}

          {/* <Row></Row> */}
          {/* <Col md={6}>
                      <FormGroup>
                      <ControlLabel>Name</ControlLabel>
                      <FormControl name="name" value={this.state.name} onChange={event => {
                        this.setState({ name: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              nameError: (
                                <small className="text-danger">
                                  Name is required.
                                </small>
                              )
                            })
                          : this.setState({ nameError: null });
                      }} placeholder="Enter Name" type="text" />
                      {this.state.nameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Mobile No</ControlLabel>
                      <FormControl name="mobileno" value={this.state.mobileno} onChange={event => {
                        this.setState({ mobileno: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              mobilenoError: (
                                <small className="text-danger">
                                  Mobile No is required.
                                </small>
                              )
                            })
                          : this.setState({ mobilenoError: null });
                      }} placeholder="Enter Mobile No" type="number" />
                      {this.state.mobilenoError}
                    </FormGroup>
                    
                    <FormGroup>
                      <ControlLabel>Phone No</ControlLabel>
                      <FormControl name="phoneno" value={this.state.phoneno} onChange={event => {
                        this.setState({ phoneno: event.target.value });
                        // event.target.value === ""
                        //   ? this.setState({
                        //       phonenoError: (
                        //         <small className="text-danger">
                        //           Phone No is required.
                        //         </small>
                        //       )
                        //     })
                        //   : this.setState({ phonenoError: null });
                      }} placeholder="Enter Phone No" type="number" />
                      {this.state.phonenoError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Status</ControlLabel>
                      <select name="status" onChange={event => {
                        this.setState({ status: event.target.value });
                        event.target.value === "0"
                          ? this.setState({
                              statusError: (
                                <small className="text-danger">
                                  Status is required.
                                </small>
                              )
                            })
                          : this.setState({ statusError: null });
                      }} value={this.state.status} className="form-control">
                        <option value="0">Select Status</option>                     
                          <option value="1">Submitted</option>
                          <option value="2">Processing</option>
                          <option value="3">Dispatched</option>
                          <option value="4">Delivered</option>
                          <option value="5">Cancelled</option>
                          <option value="6">Attempted</option>
                          <option value="7">Unreachable</option>
                        </select>
                        {this.state.statusError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Email</ControlLabel>
                      <FormControl name="email" value={this.state.email} onChange={event => {
                        this.setState({ email: event.target.value });
                        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                              emailRex.test(event.target.value) === false
                                ? this.setState({
                                    emailError: (
                                      <small className="text-danger">
                                        Email format should be{" "}
                                        <i>abc@doe.com</i>.
                                      </small>
                                    )
                                  })
                                : this.setState({ emailError: null });
                      }} placeholder="Enter Email" type="email" />
                      {this.state.emailError}
                    </FormGroup>
                      </Col> */}

          {/* {this.state.subscriber != 0?

                     <Button fill onClick={this.addanother.bind(this)}>Add Another Address<i className="fa fa-plus"></i></Button>
                    : ''}
                     {this.state.addressaccess == '1'?
                                           
                   <FormGroup>
                   <ControlLabel>Address Line 1</ControlLabel>
                     
                     <FormControl name="addressline1" value={this.state.addressline1} onChange={event => {
                       this.setState({ addressline1: event.target.value });
                       
                     }} placeholder="Enter Address Line1" type="text" />
                     {this.state.addressline1Error}
                     
                     <ControlLabel>Address Line 2</ControlLabel>

                     <FormControl name="addressline2" value={this.state.addressline2} onChange={this.onChange} placeholder="Enter Address Line2" type="text" />
                     
                     <ControlLabel>Postal code</ControlLabel>
                       
                   <FormControl name="postalcode" value={this.state.postalcode} onChange={event => {
                       this.setState({ postalcode: event.target.value });
                       // event.target.value === ""
                       //   ? this.setState({
                       //       postalcodeError: (
                       //         <small className="text-danger">
                       //           Postalcode is required.
                       //         </small>
                       //       )
                       //     })
                       //   : this.setState({ postalcodeError: null });
                     }}  placeholder="Enter Postal Code" type="number" />
                     {this.state.postalcodeError}
                     

                     <ControlLabel>Country</ControlLabel>
                     
                     <select name="country" value={this.state.country || "1"} onChange={this.onChange} className="form-control">
                       <option value="0">Select Country</option>
                       {country_detail.map((country_data) => (
                         <option value={country_data.id}>{country_data.country_name}</option>
                       ))}
                     </select>
                     {this.state.countryError}
                     <br></br>

                     <ControlLabel>City</ControlLabel>
                     
                       <select name="city" value={this.state.city} onChange={this.onChange} className="form-control" >
                         <option value="0">Select City</option>
                         {this.state.city_info.map(city=>(
                           <option value={city.id}>{city.city_name}</option>
                         ))}
                       </select>
                     {this.state.cityError}
                     
                     

                        </FormGroup>
                     :''}
                    */}

          {/*<Col
                        md={12}
                        xs={12}
                        sm={12}
                        lg={12}
                        className="no-padding"
                      >
                        {/* <Col md={3} sm={3} lg={3} xs={12}>   
                    <FormGroup >
                      <ControlLabel className="fl-w-100">Basket Value </ControlLabel>
                      <FormControl name="basketvalue" className="fl_basket_inpt" disabled="disabled" value={this.state.basketvalue} onChange={this.onChange} placeholder="0.00" type="number" />
                    </FormGroup>
                    </Col>
                    <Col md={3} sm={3} lg={3} xs={12} className="">   
                     <FormGroup  >
                      <ControlLabel className="fl-w-100">Discounted Amount</ControlLabel>
                      <FormControl name="discountamount" type="text" disabled="disabled" onChange={this.onChange} value={this.state.discountamount  }></FormControl>
                    </FormGroup>
                    </Col>
                    <Col md={3} sm={3} lg={3} xs={12}>   

                    <FormGroup >
                    <ControlLabel className="fl-w-100">Delivery Charge </ControlLabel>
                      <FormControl name="deliverycharge" className="fl_delivery_charge_inpt" value={this.state.deliverycharge} onChange={this.onChange} placeholder="0.00" type="number" />
                      {this.state.deliverychargeError}
                    </FormGroup>
                    </Col>
                    <Col md={3} sm={3} lg={3} xs={12}>   
                    <FormGroup>
                      <ControlLabel className="fl-w-100">Total Cost </ControlLabel>
                      
                      <FormControl name="totalcost" className="fl_total_cost_inpt" disabled="disabled" value={this.state.loading ? <LoadingSpinner /> :this.state.totalcost} onChange={event => {
                        this.setState({ totalcost: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              totalcostError: (
                                <small className="text-danger">
                                  Total Cost is required.
                                </small>
                              )
                            })
                          : this.setState({ totalcostError: null });
                      }} placeholder="0.00" type="number" >
                        </FormControl>
                      
                      {this.state.totalcostError}
                    
                    </FormGroup>
                    </Col>
                     }
                      </Col>*/}
        </div>
        <div>
          <OutOfStockModal
            show={this.state.showOutOfStockPop}
            onHide={() => this.setState({ showOutOfStockPop: false })}
            medicationListing={this.state.medicationListing}
          />
        </div>
        {this.state.isCreateAddressModalOpen && (
          <CreateAddressModal
            show={this.state.isCreateAddressModalOpen}
            onHide={() => this.setState({ isCreateAddressModalOpen: false })}
            handleChange={this.handleAddressChange}
            onSubmitAddress={this.onSubmitAddressModal}
            handleInputLocationChange={this.handleInputLocationChange}
            onChange={this.onChange}
            {...this.state}
          />
        )}
      </>
    );
  }
}

export default addorder;
